/**
 * Returns a list of all participles used for the Spanish passive voice assessment.
 * For each participle, versions for all four possible suffixes (-o, -a, -os, -as) are included.
 * @returns {Array} The list with participles.
 */
export default function() {
	return [
		"abajado",
		"abalanzado",
		"abaleado",
		"abandonado",
		"abaratado",
		"abarcado",
		"abarrotado",
		"abastecido",
		"abatido",
		"abdicado",
		"abierto",
		"abismado",
		"abjurado",
		"ablandado",
		"abocado",
		"abochornado",
		"abofeteado",
		"abolido",
		"abollado",
		"abombado",
		"abominado",
		"abonado",
		"abordado",
		"aborrecido",
		"aborregado",
		"abortado",
		"abotonado",
		"abrasado",
		"abrazado",
		"abrevado",
		"abreviado",
		"abrigado",
		"abrochado",
		"abrogado",
		"abroquelado",
		"abrumado",
		"absorbido",
		"abstenido",
		"abstraído",
		"absuelto",
		"abucheado",
		"abultado",
		"abundado",
		"aburguesado",
		"aburrido",
		"abusado",
		"acabado",
		"acallado",
		"acalorado",
		"acaparado",
		"acariciado",
		"acarreado",
		"acatado",
		"acaudillado",
		"accedido",
		"accionado",
		"acechado",
		"aceitado",
		"acelerado",
		"acentuado",
		"aceptado",
		"acerado",
		"acercado",
		"acertado",
		"achacado",
		"achantado",
		"achatado",
		"achicado",
		"acicalado",
		"acidificado",
		"aclarado",
		"aclimatado",
		"acobardado",
		"acodado",
		"acogido",
		"acojonado",
		"acometido",
		"acomodado",
		"acompañado",
		"acompasado",
		"acongojado",
		"aconsejado",
		"acontecido",
		"acopiado",
		"acoplado",
		"acordado",
		"acordonado",
		"acorralado",
		"acortado",
		"acosado",
		"acostado",
		"acostumbrado",
		"acotado",
		"acrecentado",
		"acreditado",
		"acrisolado",
		"activado",
		"actuado",
		"acuchillado",
		"acuciado",
		"acudido",
		"acuerpado",
		"acumulado",
		"acunado",
		"acuñado",
		"acurrucado",
		"acusado",
		"adaptado",
		"adecentado",
		"adelantado",
		"adelgazado",
		"adentrado",
		"adeudado",
		"adherido",
		"adicionado",
		"adiestrado",
		"adivinado",
		"adjetivado",
		"adjudicado",
		"adjuntado",
		"administrado",
		"admirado",
		"admitido",
		"adoctrinado",
		"adolecido",
		"adoptado",
		"adorado",
		"adormecido",
		"adornado",
		"adquirido",
		"aducido",
		"adueñado",
		"adulado",
		"adulterado",
		"advertido",
		"afanado",
		"afeado",
		"afectado",
		"afeitado",
		"aferrado",
		"afianzado",
		"afinado",
		"afirmado",
		"afligido",
		"aflorado",
		"afrentado",
		"afrontado",
		"agachado",
		"agarrado",
		"agarrotado",
		"agasajado",
		"agenciado",
		"agigantado",
		"agilizado",
		"agitado",
		"aglutinado",
		"agobiado",
		"agolpado",
		"agonizado",
		"agostado",
		"agotado",
		"agradado",
		"agradecido",
		"agrandado",
		"agravado",
		"agraviado",
		"agredido",
		"agregado",
		"agriado",
		"agrietado",
		"agrupado",
		"aguado",
		"aguantado",
		"aguardado",
		"agudizado",
		"aguijoneado",
		"agujereado",
		"aguzado",
		"ahogado",
		"ahondado",
		"ahorcado",
		"ahorrado",
		"ahuecado",
		"ahuyentado",
		"aireado",
		"aislado",
		"ajustado",
		"ajusticiado",
		"alabado",
		"alagado",
		"alambrado",
		"alardeado",
		"alargado",
		"alarmado",
		"albergado",
		"alborotado",
		"alcanzado",
		"aleccionado",
		"alegado",
		"alegrado",
		"alejado",
		"alentado",
		"alertado",
		"alfabetizado",
		"alfombrado",
		"aliado",
		"alienado",
		"aligerado",
		"alimentado",
		"aliñado",
		"alineado",
		"alisado",
		"alistado",
		"aliviado",
		"alivianado",
		"allanado",
		"almacenado",
		"almorzado",
		"alojado",
		"alquilado",
		"alterado",
		"alternado",
		"alucinado",
		"aludido",
		"alumbrado",
		"alzado",
		"amado",
		"amaestrado",
		"amagado",
		"amainado",
		"amalgamado",
		"amamantado",
		"amansado",
		"amargado",
		"amarrado",
		"amasado",
		"ambicionado",
		"amedrentado",
		"amenazado",
		"amenizado",
		"ameritado",
		"ametrallado",
		"amilanado",
		"aminorado",
		"amnistiado",
		"amoldado",
		"amonestado",
		"amontonado",
		"amordazado",
		"amortajado",
		"amortiguado",
		"amortizado",
		"amotinado",
		"amparado",
		"ampayado",
		"ampliado",
		"amplificado",
		"amputado",
		"amueblado",
		"añadido",
		"analizado",
		"anatematizado",
		"andado",
		"anegado",
		"anestesiado",
		"anexado",
		"anexionado",
		"anhelado",
		"anidado",
		"anillado",
		"animado",
		"aniquilado",
		"anisado",
		"añorado",
		"anotado",
		"anoticiado",
		"ansiado",
		"antecedido",
		"antepuesto",
		"anticipado",
		"antojado",
		"anudado",
		"anulado",
		"anunciado",
		"apabullado",
		"apachurrado",
		"apaciguado",
		"apadrinado",
		"apagado",
		"apalancado",
		"apaleado",
		"apañado",
		"apantallado",
		"aparcado",
		"apareado",
		"aparecido",
		"aparentado",
		"apartado",
		"apeado",
		"apedreado",
		"apelado",
		"apellidado",
		"apelmazado",
		"apercibido",
		"apersonado",
		"apestado",
		"apetecido",
		"apiadado",
		"apilado",
		"apiñado",
		"apisonado",
		"aplacado",
		"aplanado",
		"aplastado",
		"aplaudido",
		"aplazado",
		"aplicado",
		"apoderado",
		"apoltronado",
		"aporreado",
		"aportado",
		"aposentado",
		"apostado",
		"apostatado",
		"apostillado",
		"apoyado",
		"apreciado",
		"aprehendido",
		"apremiado",
		"aprendido",
		"apresado",
		"apresurado",
		"apretado",
		"apretujado",
		"aprisionado",
		"aprobado",
		"aprovechado",
		"aprovisionado",
		"aproximado",
		"apuñalado",
		"apuñaleado",
		"apuntado",
		"apuntalado",
		"apuntillado",
		"apurado",
		"aquejado",
		"aquietado",
		"aquilatado",
		"arañado",
		"arbitrado",
		"archivado",
		"arengado",
		"argüido",
		"argumentado",
		"armado",
		"armonizado",
		"aromatizado",
		"arqueado",
		"arrancado",
		"arrasado",
		"arrastrado",
		"arreado",
		"arrebatado",
		"arreciado",
		"arreglado",
		"arrellanado",
		"arremangado",
		"arremetido",
		"arrendado",
		"arrepentido",
		"arrestado",
		"arriado",
		"arribado",
		"arriesgado",
		"arrimado",
		"arrinconado",
		"arrodillado",
		"arrogado",
		"arrojado",
		"arrollado",
		"arropado",
		"arruinado",
		"arrullado",
		"articulado",
		"asado",
		"asaltado",
		"ascendido",
		"aseado",
		"asechado",
		"asediado",
		"asegurado",
		"asemejado",
		"asentado",
		"asentido",
		"aserrado",
		"asesinado",
		"asesorado",
		"asestado",
		"aseverado",
		"asfixiado",
		"asido",
		"asignado",
		"asilado",
		"asimilado",
		"asistido",
		"asolado",
		"asoleado",
		"asomado",
		"asombrado",
		"aspirado",
		"astillado",
		"asumido",
		"asustado",
		"atacado",
		"atado",
		"atajado",
		"atarantado",
		"atascado",
		"atemorizado",
		"atemperado",
		"atenazado",
		"atendido",
		"atenido",
		"atentado",
		"atenuado",
		"aterrado",
		"aterrorizado",
		"atesorado",
		"atestiguado",
		"atiborrado",
		"atisbado",
		"atizado",
		"atomizado",
		"atontado",
		"atorado",
		"atormentado",
		"atornillado",
		"atosigado",
		"atracado",
		"atragantado",
		"atraído",
		"atrancado",
		"atrapado",
		"atrasado",
		"atravesado",
		"atrevido",
		"atribuido",
		"atrincherado",
		"atrofiado",
		"atropellado",
		"aturdido",
		"auditado",
		"augurado",
		"aumentado",
		"aunado",
		"aupado",
		"auscultado",
		"ausentado",
		"autenticado",
		"autentificado",
		"autodefinido",
		"autoeditado",
		"automatizado",
		"autorizado",
		"autorregulado",
		"auxiliado",
		"avalado",
		"avanzado",
		"avasallado",
		"avenido",
		"aventado",
		"aventajado",
		"aventurado",
		"averiado",
		"averiguado",
		"avezado",
		"avisado",
		"avispado",
		"avistado",
		"avivado",
		"avizorado",
		"avocado",
		"ayudado",
		"azotado",
		"azuzado",
		"babeado",
		"bailado",
		"bajado",
		"balaceado",
		"balanceado",
		"bañado",
		"banalizado",
		"bancado",
		"bandeado",
		"barajado",
		"barrido",
		"basado",
		"bastardeado",
		"basureado",
		"batallado",
		"bateado",
		"batido",
		"bautizado",
		"beatificado",
		"bebido",
		"beneficiado",
		"besado",
		"bifurcado",
		"birlado",
		"blandido",
		"blanqueado",
		"blasfemado",
		"blindado",
		"bloqueado",
		"boicoteado",
		"bombardeado",
		"bombeado",
		"bonificado",
		"bordeado",
		"borrado",
		"borroneado",
		"bosquejado",
		"bostezado",
		"botado",
		"boxeado",
		"bregado",
		"brillado",
		"brincado",
		"brindado",
		"bromeado",
		"brotado",
		"bruñido",
		"buceado",
		"burlado",
		"buscado",
		"cabeceado",
		"cabido",
		"cabildeado",
		"cabreado",
		"cacareado",
		"cachado",
		"cacheado",
		"cacheteado",
		"caducado",
		"cagado",
		"calado",
		"calculado",
		"caldeado",
		"calefaccionado",
		"calendarizado",
		"calentado",
		"calibrado",
		"calificado",
		"caligrafiado",
		"callado",
		"calmado",
		"calumniado",
		"calzado",
		"cambiado",
		"caminado",
		"camuflado",
		"canalizado",
		"cancelado",
		"canjeado",
		"cansado",
		"cantado",
		"capado",
		"capeado",
		"capitalizado",
		"capitulado",
		"captado",
		"capturado",
		"caracterizado",
		"carburado",
		"carcomido",
		"cardado",
		"careado",
		"carecido",
		"cargado",
		"caricaturizado",
		"cartografiado",
		"cascado",
		"castigado",
		"castrado",
		"catado",
		"catalizado",
		"catalogado",
		"catapultado",
		"cateado",
		"categorizado",
		"causado",
		"cauterizado",
		"cautivado",
		"cavado",
		"cavilado",
		"cazado",
		"cebado",
		"cedido",
		"cegado",
		"cejado",
		"celebrado",
		"cenado",
		"ceñido",
		"censurado",
		"centrifugado",
		"centuplicado",
		"cepillado",
		"cercado",
		"cercenado",
		"cerciorado",
		"cernido",
		"cerrado",
		"cesado",
		"chafado",
		"chamuscado",
		"chantajeado",
		"chapado",
		"charlado",
		"chateado",
		"chequeado",
		"chiflado",
		"chillado",
		"chingado",
		"chirriado",
		"chivado",
		"chocado",
		"chorreado",
		"choteado",
		"chupado",
		"chutado",
		"cicatrizado",
		"cifrado",
		"cimentado",
		"cincelado",
		"circulado",
		"circuncidado",
		"circundado",
		"citado",
		"clamado",
		"clarificado",
		"clasificado",
		"claudicado",
		"clausurado",
		"clavado",
		"clicado",
		"clonado",
		"coaccionado",
		"coadyuvado",
		"coagulado",
		"coaligado",
		"coartado",
		"cobijado",
		"cobrado",
		"cocido",
		"cocinado",
		"codeado",
		"codiciado",
		"codificado",
		"codirigido",
		"coexistido",
		"cofinanciado",
		"cogido",
		"cohabitado",
		"cohibido",
		"coincidido",
		"colaborado",
		"colacionado",
		"colado",
		"colapsado",
		"coleccionado",
		"colectado",
		"colectivizado",
		"colgado",
		"colisionado",
		"colmado",
		"colocado",
		"colonizado",
		"coloreado",
		"columpiado",
		"combatido",
		"combinado",
		"comentado",
		"comenzado",
		"comerciado",
		"comercializado",
		"cometido",
		"comido",
		"comisionado",
		"compactado",
		"compadecido",
		"compaginado",
		"comparado",
		"comparecido",
		"compartido",
		"compatibilizado",
		"compelido",
		"compendiado",
		"compenetrado",
		"compensado",
		"compilado",
		"complacido",
		"complementado",
		"completado",
		"complotado",
		"comportado",
		"comprado",
		"comprendido",
		"comprimido",
		"comprobado",
		"comprometido",
		"compuesto",
		"compulsado",
		"computado",
		"comulgado",
		"comunicado",
		"concatenado",
		"concebido",
		"concedido",
		"concelebrado",
		"concentrado",
		"conceptuado",
		"conceptualizado",
		"concertado",
		"concienciado",
		"concientizado",
		"conciliado",
		"concitado",
		"concluido",
		"concordado",
		"concretado",
		"concretizado",
		"conculcado",
		"concursado",
		"condenado",
		"condensado",
		"condicionado",
		"condimentado",
		"condolido",
		"condonado",
		"conducido",
		"conectado",
		"conexionado",
		"confabulado",
		"confeccionado",
		"conferido",
		"confesado",
		"confiado",
		"configurado",
		"confirmado",
		"confiscado",
		"confluido",
		"conformado",
		"confortado",
		"confrontado",
		"confundido",
		"congeniado",
		"congestionado",
		"congratulado",
		"congregado",
		"conjeturado",
		"conjugado",
		"conjuntado",
		"conjurado",
		"conllevado",
		"conmemorado",
		"conminado",
		"conmocionado",
		"conmovido",
		"conmutado",
		"connotado",
		"conquistado",
		"consagrado",
		"conseguido",
		"consensuado",
		"consentido",
		"conservado",
		"considerado",
		"consignado",
		"consistido",
		"consolado",
		"consolidado",
		"conspirado",
		"constado",
		"constatado",
		"constelado",
		"constitucionalizado",
		"constituido",
		"constreñido",
		"construido",
		"consultado",
		"consumado",
		"consumido",
		"contabilizado",
		"contactado",
		"contado",
		"contagiado",
		"contemplado",
		"contendido",
		"contenido",
		"contentado",
		"contestado",
		"contextualizado",
		"continuado",
		"contorneado",
		"contraatacado",
		"contrabandeado",
		"contradicho",
		"contrahecho",
		"contraído",
		"contrapesado",
		"contrapuesto",
		"contrariado",
		"contrarrestado",
		"contrastado",
		"contratado",
		"contravenido",
		"contribuido",
		"contristado",
		"controlado",
		"convalidado",
		"convencido",
		"convenido",
		"convergido",
		"conversado",
		"convertido",
		"convidado",
		"convivido",
		"convocado",
		"convulsionado",
		"cooperado",
		"cooptado",
		"coordinado",
		"copado",
		"copiado",
		"coproducido",
		"copulado",
		"coqueteado",
		"corchado",
		"coreado",
		"coreografiado",
		"corneado",
		"coronado",
		"corporizado",
		"corregido",
		"correlacionado",
		"correspondido",
		"correteado",
		"corrido",
		"corroborado",
		"corroído",
		"corrompido",
		"cortado",
		"cortejado",
		"cosechado",
		"cosido",
		"cosificado",
		"costado",
		"costeado",
		"cotejado",
		"cotizado",
		"creado",
		"creído",
		"criado",
		"cribado",
		"criminalizado",
		"crispado",
		"cristalizado",
		"cristianizado",
		"criticado",
		"cronometrado",
		"crucificado",
		"crujido",
		"cruzado",
		"cuadriplicado",
		"cuadruplicado",
		"cuajado",
		"cuantificado",
		"cuarteado",
		"cubierto",
		"cuestionado",
		"cuidado",
		"culeado",
		"culminado",
		"culpabilizado",
		"culpado",
		"cultivado",
		"culturizado",
		"cumplido",
		"cumplimentado",
		"cundido",
		"curado",
		"curioseado",
		"currado",
		"cursado",
		"curvado",
		"custodiado",
		"dado",
		"dañado",
		"danzado",
		"datado",
		"dateado",
		"debatido",
		"debido",
		"debilitado",
		"debitado",
		"debutado",
		"decaído",
		"decantado",
		"decapitado",
		"decepcionado",
		"decidido",
		"declamado",
		"declarado",
		"declinado",
		"decodificado",
		"decolorado",
		"decomisado",
		"decrecido",
		"decretado",
		"dedicado",
		"deducido",
		"defecado",
		"defendido",
		"defenestrado",
		"deferido",
		"definido",
		"deformado",
		"defraudado",
		"degenerado",
		"deglutido",
		"degollado",
		"degradado",
		"degustado",
		"deificado",
		"dejado",
		"delatado",
		"delegado",
		"deleitado",
		"deletreado",
		"deliberado",
		"delimitado",
		"delineado",
		"delinquido",
		"demandado",
		"demarcado",
		"demediado",
		"demeritado",
		"democratizado",
		"demolido",
		"demonizado",
		"demorado",
		"demostrado",
		"demudado",
		"denegado",
		"denigrado",
		"denominado",
		"denostado",
		"denotado",
		"denunciado",
		"deparado",
		"departido",
		"dependido",
		"depilado",
		"deplorado",
		"deportado",
		"depositado",
		"depreciado",
		"depredado",
		"deprimido",
		"depuesto",
		"depurado",
		"derechizado",
		"derivado",
		"derogado",
		"derramado",
		"derretido",
		"derribado",
		"derrocado",
		"derrochado",
		"derrotado",
		"derruido",
		"derrumbado",
		"desabrochado",
		"desacatado",
		"desacelerado",
		"desacomodado",
		"desaconsejado",
		"desacoplado",
		"desacralizado",
		"desacreditado",
		"desactivado",
		"desafiado",
		"desafinado",
		"desaguado",
		"desahogado",
		"desairado",
		"desajustado",
		"desalentado",
		"desalineado",
		"desalojado",
		"desandado",
		"desangrado",
		"desanimado",
		"desaparecido",
		"desapegado",
		"desaprendido",
		"desaprobado",
		"desaprovechado",
		"desarmado",
		"desarraigado",
		"desarreglado",
		"desarrollado",
		"desarticulado",
		"desaseado",
		"desasido",
		"desasosegado",
		"desatado",
		"desatendido",
		"desautorizado",
		"desayunado",
		"desbancado",
		"desbandado",
		"desbaratado",
		"desbarrancado",
		"desbastado",
		"desbloqueado",
		"desbocado",
		"desbordado",
		"desbrozado",
		"descabalgado",
		"descabezado",
		"descaderado",
		"descalabrado",
		"descalificado",
		"descansado",
		"descargado",
		"descarriado",
		"descarrilado",
		"descartado",
		"descascarado",
		"descascarillado",
		"descendido",
		"descentrado",
		"descifrado",
		"descocido",
		"descodificado",
		"descojonado",
		"descolgado",
		"descolocado",
		"descolonizado",
		"descompensado",
		"descomprimido",
		"descompuesto",
		"desconectado",
		"desconfiado",
		"descongelado",
		"desconocido",
		"descontado",
		"descontaminado",
		"descontextualizado",
		"descontinuado",
		"desconvocado",
		"descorazonado",
		"descorchado",
		"descorrido",
		"descosido",
		"descoyuntado",
		"descreído",
		"descristianizado",
		"descuadrado",
		"descuartizado",
		"descubierto",
		"descuidado",
		"desdeñado",
		"desdibujado",
		"desdicho",
		"desdoblado",
		"deseado",
		"desecado",
		"desechado",
		"desembarazado",
		"desembarcado",
		"desembocado",
		"desembolsado",
		"desempacado",
		"desempañado",
		"desempaquetado",
		"desempeñado",
		"desempolvado",
		"desenamorado",
		"desencadenado",
		"desencajado",
		"desencarnado",
		"desenchufado",
		"desenfocado",
		"desenfundado",
		"desenganchado",
		"desengrasado",
		"desenmascarado",
		"desenredado",
		"desenrollado",
		"desentendido",
		"desenterrado",
		"desentonado",
		"desentrañado",
		"desenvainado",
		"desenvuelto",
		"desequilibrado",
		"desertado",
		"desestabilizado",
		"desestimado",
		"desfalcado",
		"desfallecido",
		"desfigurado",
		"desfondado",
		"desgajado",
		"desgañitado",
		"desgarrado",
		"desgastado",
		"desglosado",
		"desgobernado",
		"desgranado",
		"desguazado",
		"deshecho",
		"desheredado",
		"deshidratado",
		"deshilachado",
		"deshojado",
		"deshonrado",
		"deshuesado",
		"deshumanizado",
		"designado",
		"desilusionado",
		"desincentivado",
		"desinfectado",
		"desinflado",
		"desinflamado",
		"desinformado",
		"desinhibido",
		"desinstalado",
		"desintegrado",
		"desintoxicado",
		"desistido",
		"desjarretado",
		"deslegitimado",
		"desleído",
		"desligado",
		"deslindado",
		"deslizado",
		"deslucido",
		"deslumbrado",
		"desmadrado",
		"desmalezado",
		"desmantelado",
		"desmaquillado",
		"desmarcado",
		"desmayado",
		"desmejorado",
		"desmembrado",
		"desmentido",
		"desmenuzado",
		"desmerecido",
		"desmigado",
		"desmitificado",
		"desmoldado",
		"desmontado",
		"desmoralizado",
		"desmoronado",
		"desmotivado",
		"desmovilizado",
		"desnaturalizado",
		"desnivelado",
		"desnucado",
		"desnudado",
		"desobedecido",
		"desobligado",
		"desoído",
		"desollado",
		"desorganizado",
		"desorientado",
		"despachado",
		"desparasitado",
		"desparecido",
		"desparramado",
		"despedazado",
		"despedido",
		"despegado",
		"despeinado",
		"despejado",
		"despellejado",
		"despeñado",
		"despenalizado",
		"desperdiciado",
		"despersonalizado",
		"despertado",
		"despilfarrado",
		"despintado",
		"despiojado",
		"despistado",
		"desplazado",
		"desplegado",
		"desplomado",
		"desplumado",
		"despojado",
		"despolitizado",
		"desposado",
		"desposeído",
		"despotricado",
		"despreciado",
		"desprendido",
		"despreocupado",
		"desprestigiado",
		"desprogramado",
		"despulpado",
		"despuntado",
		"desquiciado",
		"desquitado",
		"destacado",
		"destapado",
		"desteñido",
		"desterrado",
		"destetado",
		"destilado",
		"destituido",
		"destrabado",
		"destripado",
		"destronado",
		"destrozado",
		"destruido",
		"desunido",
		"desvalijado",
		"desvalorizado",
		"desvanecido",
		"desvelado",
		"desvestido",
		"desviado",
		"desvinculado",
		"desvirtuado",
		"desvivido",
		"detectado",
		"detenido",
		"detentado",
		"deteriorado",
		"determinado",
		"detestado",
		"detonado",
		"devaluado",
		"devanado",
		"devastado",
		"develado",
		"devengado",
		"devenido",
		"devorado",
		"devuelto",
		"diagnosticado",
		"diagramado",
		"dializado",
		"dialogado",
		"dibujado",
		"dicho",
		"dictado",
		"dictaminado",
		"diezmado",
		"difamado",
		"diferenciado",
		"diferido",
		"dificultado",
		"difuminado",
		"difundido",
		"digerido",
		"digitado",
		"dignado",
		"dignificado",
		"dilapidado",
		"dilatado",
		"diligenciado",
		"dilucidado",
		"diluido",
		"dimensionado",
		"dimitido",
		"dinamitado",
		"dinamizado",
		"dirimido",
		"discernido",
		"disciplinado",
		"discontinuado",
		"discrepado",
		"discriminado",
		"disculpado",
		"discurrido",
		"discutido",
		"diseccionado",
		"diseminado",
		"diseñado",
		"disentido",
		"disertado",
		"disfrazado",
		"disfrutado",
		"disgregado",
		"disgustado",
		"disimulado",
		"disipado",
		"dislocado",
		"disminuido",
		"disociado",
		"dispensado",
		"dispersado",
		"dispuesto",
		"disputado",
		"distado",
		"distanciado",
		"distendido",
		"distinguido",
		"distorsionado",
		"distraído",
		"distribuido",
		"disuadido",
		"disuelto",
		"divagado",
		"diversificado",
		"divertido",
		"dividido",
		"divinizado",
		"divisado",
		"divorciado",
		"divulgado",
		"doblado",
		"doblegado",
		"doctorado",
		"documentado",
		"dogmatizado",
		"dolido",
		"domado",
		"domesticado",
		"dominado",
		"donado",
		"dopado",
		"dormido",
		"dosificado",
		"dotado",
		"dragado",
		"dramatizado",
		"drenado",
		"drogado",
		"duchado",
		"dudado",
		"dulcificado",
		"duplicado",
		"durado",
		"echado",
		"eclipsado",
		"eclosionado",
		"economizado",
		"ecualizado",
		"edificado",
		"editado",
		"educado",
		"efectuado",
		"ejecutado",
		"ejemplificado",
		"ejercido",
		"ejercitado",
		"elaborado",
		"electrizado",
		"electrocutado",
		"elevado",
		"elidido",
		"eliminado",
		"elogiado",
		"elucubrado",
		"eludido",
		"emanado",
		"emancipado",
		"embadurnado",
		"embalado",
		"embalsamado",
		"embanderado",
		"embarcado",
		"embargado",
		"embarrado",
		"embarrancado",
		"embaucado",
		"embebido",
		"embelesado",
		"embellecido",
		"embestido",
		"embolado",
		"embolsado",
		"emborrachado",
		"emborronado",
		"emboscado",
		"embotado",
		"embriagado",
		"embrollado",
		"embrutecido",
		"embuchado",
		"emergido",
		"emigrado",
		"emitido",
		"emocionado",
		"empacado",
		"empachado",
		"empadronado",
		"empalado",
		"empalmado",
		"empanado",
		"empañado",
		"empantanado",
		"empapelado",
		"empaquetado",
		"emparejado",
		"empastado",
		"empatado",
		"empecinado",
		"empeñado",
		"empeorado",
		"empequeñecido",
		"emperrado",
		"empezado",
		"empinado",
		"emplazado",
		"empleado",
		"empobrecido",
		"empoderado",
		"empollado",
		"empolvado",
		"emponzoñado",
		"emprendido",
		"empujado",
		"empuñado",
		"emputado",
		"emulado",
		"emulsionado",
		"enajenado",
		"enaltecido",
		"enamorado",
		"enarbolado",
		"enardecido",
		"encabezado",
		"encabritado",
		"encabronado",
		"encadenado",
		"encajado",
		"encajonado",
		"encallado",
		"encamado",
		"encaminado",
		"encandilado",
		"encanecido",
		"encañonado",
		"encantado",
		"encaprichado",
		"encapsulado",
		"encarado",
		"encaramado",
		"encarecido",
		"encargado",
		"encariñado",
		"encarnado",
		"encarrilado",
		"encartado",
		"encasillado",
		"encasquetado",
		"encasquillado",
		"encastrado",
		"encausado",
		"encauzado",
		"enceguecido",
		"encendido",
		"encerado",
		"encerrado",
		"encharcado",
		"enchufado",
		"encimado",
		"encogido",
		"encolado",
		"encolerizado",
		"encolumnado",
		"encomendado",
		"enconado",
		"encontrado",
		"encordado",
		"encrespado",
		"encuadrado",
		"encubierto",
		"encuerado",
		"encumbrado",
		"enderezado",
		"endeudado",
		"endilgado",
		"endiosado",
		"endosado",
		"endulzado",
		"endurecido",
		"enemistado",
		"energizado",
		"enervado",
		"enfadado",
		"enfangado",
		"enfatizado",
		"enfermado",
		"enfiestado",
		"enfilado",
		"enflaquecido",
		"enfocado",
		"enfrascado",
		"enfrentado",
		"enfriado",
		"enfurecido",
		"engalanado",
		"engañado",
		"enganchado",
		"engarzado",
		"engatusado",
		"engendrado",
		"englobado",
		"engolosinado",
		"engordado",
		"engranado",
		"engrandecido",
		"engrasado",
		"engreído",
		"engrosado",
		"engullido",
		"enharinado",
		"enhebrado",
		"enjuagado",
		"enjugado",
		"enjuiciado",
		"enlazado",
		"enlistado",
		"enlodado",
		"enloquecido",
		"enlozado",
		"enlutado",
		"enmarañado",
		"enmascarado",
		"enmendado",
		"enmohecido",
		"enmudecido",
		"ennegrecido",
		"ennoblecido",
		"enorgullecido",
		"enrarecido",
		"enredado",
		"enripiado",
		"enriquecido",
		"enrocado",
		"enrojecido",
		"enrolado",
		"enrollado",
		"enroscado",
		"enrumbado",
		"ensalzado",
		"ensamblado",
		"ensañado",
		"ensanchado",
		"ensartado",
		"ensayado",
		"ensebado",
		"enseñado",
		"enseñoreado",
		"ensillado",
		"ensoberbecido",
		"ensogado",
		"ensombrecido",
		"ensoñado",
		"ensordecido",
		"ensuciado",
		"entablado",
		"entallado",
		"entendido",
		"enterado",
		"enternecido",
		"enterrado",
		"entibiado",
		"entintado",
		"entonado",
		"entorpecido",
		"entrado",
		"entrampado",
		"entrañado",
		"entreabierto",
		"entrecomillado",
		"entrecruzado",
		"entregado",
		"entrelazado",
		"entremetido",
		"entremezclado",
		"entrenado",
		"entresacado",
		"entretejido",
		"entretenido",
		"entreverado",
		"entrevistado",
		"entristecido",
		"entrometido",
		"entronado",
		"entroncado",
		"entronizado",
		"entumecido",
		"enturbiado",
		"entusiasmado",
		"enumerado",
		"enunciado",
		"envainado",
		"envalentonado",
		"envanecido",
		"envasado",
		"envejecido",
		"envenenado",
		"envestido",
		"enviado",
		"enviciado",
		"envidiado",
		"envilecido",
		"enviudado",
		"envuelto",
		"enzarzado",
		"equilibrado",
		"equiparado",
		"equivocado",
		"erigido",
		"erizado",
		"erogado",
		"erosionado",
		"erotizado",
		"erradicado",
		"errado",
		"esbozado",
		"escabullido",
		"escalado",
		"escaldado",
		"escalfado",
		"escamado",
		"escamoteado",
		"escampado",
		"escandalizado",
		"escaneado",
		"escapado",
		"escaqueado",
		"escarbado",
		"escarchado",
		"escarmentado",
		"escarnecido",
		"escaseado",
		"escatimado",
		"escenificado",
		"escindido",
		"esclarecido",
		"esclavizado",
		"escocido",
		"escogido",
		"escolarizado",
		"escoltado",
		"escondido",
		"escorado",
		"escrachado",
		"escrito",
		"escrutado",
		"escuchado",
		"escudado",
		"escudriñado",
		"esculpido",
		"escupido",
		"escurrido",
		"esforzado",
		"esfumado",
		"esgrimido",
		"esmerado",
		"esmerilado",
		"espabilado",
		"espaciado",
		"españolizado",
		"espantado",
		"esparcido",
		"especificado",
		"especulado",
		"esperado",
		"espesado",
		"espetado",
		"espiado",
		"espigado",
		"espinado",
		"espirado",
		"espiritualizado",
		"espoleado",
		"espolvoreado",
		"esponjado",
		"esponsorizado",
		"esposado",
		"esquematizado",
		"esquiado",
		"esquilado",
		"esquilmado",
		"esquivado",
		"estabilizado",
		"establecido",
		"estacionado",
		"estafado",
		"estallado",
		"estampado",
		"estancado",
		"estaqueado",
		"estatizado",
		"estatuido",
		"esterificado",
		"esterilizado",
		"estigmatizado",
		"estilizado",
		"estimado",
		"estimulado",
		"estipulado",
		"estirado",
		"estorbado",
		"estornudado",
		"estragado",
		"estrangulado",
		"estrechado",
		"estrellado",
		"estremecido",
		"estrenado",
		"estresado",
		"estriado",
		"estropeado",
		"estructurado",
		"estrujado",
		"estudiado",
		"eternizado",
		"etiquetado",
		"evacuado",
		"evadido",
		"evaluado",
		"evangelizado",
		"evaporado",
		"evidenciado",
		"eviscerado",
		"evitado",
		"evocado",
		"evolucionado",
		"exacerbado",
		"exagerado",
		"exaltado",
		"examinado",
		"exasperado",
		"excarcelado",
		"excavado",
		"excedido",
		"exceptuado",
		"excitado",
		"exclamado",
		"excluido",
		"excretado",
		"exculpado",
		"excusado",
		"execrado",
		"exhalado",
		"exhibido",
		"exhortado",
		"exhumado",
		"exigido",
		"exilado",
		"eximido",
		"existido",
		"exonerado",
		"exorcizado",
		"expandido",
		"expedido",
		"expedientado",
		"expelido",
		"expendido",
		"experimentado",
		"expiado",
		"expirado",
		"explayado",
		"explicado",
		"explicitado",
		"explorado",
		"explosionado",
		"explotado",
		"expoliado",
		"exportado",
		"expresado",
		"exprimido",
		"expropiado",
		"expuesto",
		"expulsado",
		"expurgado",
		"extendido",
		"exteriorizado",
		"exterminado",
		"externado",
		"externalizado",
		"extinguido",
		"extirpado",
		"extorsionado",
		"extractado",
		"extraditado",
		"extraído",
		"extralimitado",
		"extrañado",
		"extrapolado",
		"extraviado",
		"extremado",
		"extruido",
		"exudado",
		"eyaculado",
		"eyectado",
		"fabricado",
		"fabulado",
		"facilitado",
		"facturado",
		"facultado",
		"fagocitado",
		"fajado",
		"fallado",
		"fallecido",
		"falsado",
		"falseado",
		"falsificado",
		"familiarizado",
		"fantaseado",
		"fascinado",
		"fastidiado",
		"fatigado",
		"favorecido",
		"fecundado",
		"felicitado",
		"feminizado",
		"fenecido",
		"fermentado",
		"fertilizado",
		"festejado",
		"fiado",
		"fichado",
		"fidelizado",
		"figurado",
		"fijado",
		"filmado",
		"filosofado",
		"filtrado",
		"finalizado",
		"financiado",
		"fincado",
		"fingido",
		"finiquitado",
		"firmado",
		"fiscalizado",
		"fisurado",
		"flagelado",
		"flameado",
		"flanqueado",
		"flaqueado",
		"fletado",
		"flexibilizado",
		"flexionado",
		"flipado",
		"floreado",
		"florecido",
		"flotado",
		"fluctuado",
		"focalizado",
		"fogueado",
		"foliado",
		"follado",
		"fomentado",
		"fondeado",
		"forcejeado",
		"forestado",
		"forjado",
		"formado",
		"formalizado",
		"formateado",
		"formulado",
		"fornicado",
		"forrado",
		"fortalecido",
		"forzado",
		"fotocopiado",
		"fotografiado",
		"fracasado",
		"fraccionado",
		"fracturado",
		"fragmentado",
		"fraguado",
		"franqueado",
		"frecuentado",
		"fregado",
		"frenado",
		"fresado",
		"friccionado",
		"frotado",
		"fructificado",
		"fruncido",
		"fugado",
		"fulminado",
		"fumado",
		"fumigado",
		"funcionado",
		"fundado",
		"fundamentado",
		"fundido",
		"fungido",
		"fusilado",
		"fusionado",
		"fustigado",
		"gafado",
		"ganado",
		"gangrenado",
		"garabateado",
		"garantido",
		"garantizado",
		"garrido",
		"gaseado",
		"gastado",
		"gemido",
		"generado",
		"generalizado",
		"gerenciado",
		"germinado",
		"gestado",
		"gestionado",
		"girado",
		"glorificado",
		"glosado",
		"gobernado",
		"goleado",
		"golpeado",
		"gozado",
		"grabado",
		"graduado",
		"graficado",
		"granjeado",
		"grapado",
		"gratificado",
		"gravado",
		"gravitado",
		"gritado",
		"gruñido",
		"guardado",
		"guarecido",
		"guarnecido",
		"guerreado",
		"guiado",
		"guillotinado",
		"guiñado",
		"guindado",
		"guisado",
		"gustado",
		"habilitado",
		"habitado",
		"habituado",
		"hablado",
		"halado",
		"halagado",
		"hallado",
		"hartado",
		"hechizado",
		"hecho",
		"helenizado",
		"henchido",
		"hendido",
		"heredado",
		"herido",
		"hermanado",
		"herrado",
		"hervido",
		"hibernado",
		"hibridado",
		"hidratado",
		"higienizado",
		"hilado",
		"hilvanado",
		"hincado",
		"hinchado",
		"hipnotizado",
		"hipotecado",
		"historiado",
		"hojeado",
		"holgado",
		"hollado",
		"homenajeado",
		"homogeneizado",
		"homologado",
		"honrado",
		"horadado",
		"horneado",
		"horrorizado",
		"hospedado",
		"hostigado",
		"hostilizado",
		"huido",
		"humanado",
		"humanizado",
		"humectado",
		"humedecido",
		"humillado",
		"hundido",
		"hurgado",
		"hurtado",
		"ideado",
		"idealizado",
		"identificado",
		"ideologizado",
		"idiotizado",
		"idolatrado",
		"ignorado",
		"igualado",
		"ilegalizado",
		"iluminado",
		"ilusionado",
		"ilustrado",
		"imaginado",
		"imbricado",
		"imitado",
		"impactado",
		"impartido",
		"impedido",
		"impelido",
		"imperado",
		"impermeabilizado",
		"implantado",
		"implementado",
		"implicado",
		"implorado",
		"importado",
		"importunado",
		"imposibilitado",
		"impresionado",
		"improvisado",
		"impuesto",
		"impugnado",
		"impulsado",
		"imputado",
		"inaugurado",
		"incautado",
		"incendiado",
		"incentivado",
		"incinerado",
		"incitado",
		"inclinado",
		"incluido",
		"incoado",
		"incomodado",
		"incorporado",
		"incrementado",
		"increpado",
		"incriminado",
		"incubado",
		"inculcado",
		"inculpado",
		"incumplido",
		"incurrido",
		"incursionado",
		"indagado",
		"indemnizado",
		"independizado",
		"indexado",
		"indicado",
		"indigestado",
		"indignado",
		"indispuesto",
		"individuado",
		"inducido",
		"indultado",
		"inervado",
		"infamado",
		"infartado",
		"infectado",
		"inferido",
		"inficionado",
		"infiltrado",
		"inflado",
		"inflamado",
		"infligido",
		"influenciado",
		"influido",
		"informado",
		"infravalorado",
		"infringido",
		"infundido",
		"ingeniado",
		"ingerido",
		"ingresado",
		"inhabilitado",
		"inhalado",
		"inhibido",
		"inhumado",
		"iniciado",
		"inicializado",
		"injertado",
		"injuriado",
		"inmigrado",
		"inmiscuido",
		"inmolado",
		"inmortalizado",
		"inmovilizado",
		"inmunizado",
		"innovado",
		"inoculado",
		"inquietado",
		"inquirido",
		"insensibilizado",
		"insertado",
		"insinuado",
		"insistido",
		"inspeccionado",
		"inspirado",
		"instado",
		"instalado",
		"instaurado",
		"instigado",
		"instituido",
		"instruido",
		"instrumentado",
		"instrumentalizado",
		"insuflado",
		"insultado",
		"insumido",
		"integrado",
		"intelectualizado",
		"intensificado",
		"intentado",
		"interactuado",
		"intercalado",
		"intercambiado",
		"intercedido",
		"interceptado",
		"interesado",
		"interferido",
		"interiorizado",
		"intermediado",
		"internacionalizado",
		"internalizado",
		"interpelado",
		"interpolado",
		"interpretado",
		"interpuesto",
		"interrogado",
		"interrumpido",
		"intervenido",
		"intimado",
		"intimidado",
		"intitulado",
		"intoxicado",
		"intrigado",
		"introducido",
		"intuido",
		"inundado",
		"inutilizado",
		"invadido",
		"invalidado",
		"inventado",
		"inventariado",
		"invertido",
		"investido",
		"investigado",
		"invitado",
		"invocado",
		"involucionado",
		"inyectado",
		"ionizado",
		"ironizado",
		"irradiado",
		"irrespetado",
		"irrigado",
		"irritado",
		"irrogado",
		"irrumpido",
		"jactado",
		"jalado",
		"jaleado",
		"jalonado",
		"jaqueado",
		"jerarquizado",
		"jodido",
		"jorobado",
		"jubilado",
		"jugado",
		"juntado",
		"jurado",
		"juramentado",
		"justificado",
		"juzgado",
		"laborado",
		"labrado",
		"laburado",
		"lacado",
		"lacerado",
		"lactado",
		"ladeado",
		"ladrado",
		"lamentado",
		"lamido",
		"laminado",
		"languidecido",
		"lanzado",
		"lapidado",
		"laqueado",
		"largado",
		"lastimado",
		"lastrado",
		"latido",
		"laudado",
		"lavado",
		"legalizado",
		"legislado",
		"legitimado",
		"leído",
		"lesionado",
		"leudado",
		"levantado",
		"liado",
		"liberado",
		"liberalizado",
		"libertado",
		"librado",
		"licitado",
		"licuado",
		"liderizado",
		"lidiado",
		"ligado",
		"lijado",
		"limado",
		"limitado",
		"limpiado",
		"linchado",
		"liquidado",
		"litigado",
		"llagado",
		"llamado",
		"llegado",
		"llenado",
		"llevado",
		"llorado",
		"localizado",
		"logrado",
		"lubricado",
		"luchado",
		"lucido",
		"lucrado",
		"lustrado",
		"macerado",
		"machacado",
		"macheteado",
		"machucado",
		"madreado",
		"madrugado",
		"madurado",
		"magnetizado",
		"magnificado",
		"malacostumbrado",
		"malbaratado",
		"malcriado",
		"maleado",
		"malentendido",
		"malgastado",
		"malinterpretado",
		"malogrado",
		"maltratado",
		"malversado",
		"mamado",
		"manchado",
		"mancillado",
		"mandado",
		"manejado",
		"mangado",
		"mangoneado",
		"manifestado",
		"maniobrado",
		"manipulado",
		"manoseado",
		"manteado",
		"mantenido",
		"manufacturado",
		"maquillado",
		"maquinado",
		"maravillado",
		"marcado",
		"marchitado",
		"mareado",
		"marginado",
		"maridado",
		"martillado",
		"martirizado",
		"masacrado",
		"masajeado",
		"mascado",
		"masificado",
		"masticado",
		"masturbado",
		"matado",
		"materializado",
		"matizado",
		"matriculado",
		"maximizado",
		"meado",
		"mecanografiado",
		"mechado",
		"mecido",
		"mediado",
		"mediatizado",
		"medicado",
		"medido",
		"meditado",
		"medrado",
		"mejorado",
		"mellado",
		"memorizado",
		"mencionado",
		"meneado",
		"menguado",
		"menoscabado",
		"menospreciado",
		"menstruado",
		"mensualizado",
		"mensurado",
		"mentado",
		"mentalizado",
		"mentido",
		"mercadeado",
		"mercantilizado",
		"merecido",
		"merendado",
		"mermado",
		"merodeado",
		"mesurado",
		"metamorfoseado",
		"metido",
		"mezclado",
		"migrado",
		"militado",
		"militarizado",
		"mimado",
		"mimetizado",
		"minado",
		"minimizado",
		"ministrado",
		"minusvalorado",
		"mirado",
		"mistificado",
		"mitificado",
		"mitigado",
		"modelado",
		"modernizado",
		"modificado",
		"modulado",
		"mofado",
		"mojado",
		"moldeado",
		"molestado",
		"molido",
		"monetizado",
		"monitorizado",
		"monopolizado",
		"montado",
		"morado",
		"moralizado",
		"mordido",
		"mordisqueado",
		"mortificado",
		"mosqueado",
		"mostrado",
		"motejado",
		"motivado",
		"movido",
		"movilizado",
		"mudado",
		"muestreado",
		"multado",
		"multiplicado",
		"munido",
		"murmurado",
		"mutado",
		"mutilado",
		"nacionalizado",
		"narcotizado",
		"narrado",
		"naufragado",
		"navegado",
		"necesitado",
		"negado",
		"negociado",
		"neutralizado",
		"ninguneado",
		"nivelado",
		"nombrado",
		"nominado",
		"noqueado",
		"normado",
		"normalizado",
		"notado",
		"notificado",
		"nutrido",
		"obcecado",
		"obedecido",
		"objetado",
		"objetivado",
		"obligado",
		"obliterado",
		"obnubilado",
		"obrado",
		"obsequiado",
		"observado",
		"obsesionado",
		"obstaculizado",
		"obstruido",
		"obtenido",
		"obturado",
		"obviado",
		"ocasionado",
		"ocluido",
		"ocultado",
		"ocupado",
		"odiado",
		"ofendido",
		"ofertado",
		"oficiado",
		"oficializado",
		"ofrecido",
		"ofrendado",
		"ofuscado",
		"oído",
		"ojeado",
		"olfateado",
		"olido",
		"olvidado",
		"omitido",
		"ondeado",
		"ondulado",
		"opacado",
		"operado",
		"opinado",
		"oprimido",
		"optado",
		"optimizado",
		"opuesto",
		"orado",
		"orbitado",
		"ordenado",
		"ordeñado",
		"organizado",
		"orientado",
		"originado",
		"orillado",
		"orinado",
		"ornado",
		"ornamentado",
		"orquestado",
		"osado",
		"oscilado",
		"oscurecido",
		"osificado",
		"ostentado",
		"otorgado",
		"ovacionado",
		"ovulado",
		"oxidado",
		"oxigenado",
		"pacificado",
		"pactado",
		"padecido",
		"paganizado",
		"paginado",
		"paladeado",
		"paliado",
		"palpado",
		"parado",
		"parafraseado",
		"paralizado",
		"parapetado",
		"parasitado",
		"parcelado",
		"parchado",
		"parcheado",
		"pareado",
		"parido",
		"parodiado",
		"parqueado",
		"participado",
		"particularizado",
		"partido",
		"pasado",
		"paseado",
		"pastoreado",
		"pataleado",
		"pateado",
		"patentado",
		"patentizado",
		"patinado",
		"patrullado",
		"pecado",
		"pedaleado",
		"pedido",
		"pegado",
		"peinado",
		"pellizcado",
		"penalizado",
		"penetrado",
		"pensado",
		"percatado",
		"percibido",
		"percutido",
		"perdido",
		"perdonado",
		"perdurado",
		"perecido",
		"peregrinado",
		"perfeccionado",
		"perfilado",
		"perforado",
		"perfumado",
		"pergeñado",
		"peritado",
		"perjudicado",
		"perjurado",
		"permeado",
		"permitido",
		"permutado",
		"pernoctado",
		"perpetrado",
		"perpetuado",
		"perseguido",
		"perseverado",
		"persistido",
		"personado",
		"personalizado",
		"personificado",
		"persuadido",
		"pertenecido",
		"pertrechado",
		"perturbado",
		"pervertido",
		"pervivido",
		"pescado",
		"petado",
		"peticionado",
		"picado",
		"picaneado",
		"picoteado",
		"pifiado",
		"pignorado",
		"pillado",
		"pilotado",
		"piloteado",
		"pincelado",
		"pinchado",
		"pintado",
		"pintarrajeado",
		"pinzado",
		"pirado",
		"pirateado",
		"pisado",
		"pisoteado",
		"pitado",
		"placido",
		"plagiado",
		"planchado",
		"planeado",
		"plantado",
		"planteado",
		"plasmado",
		"platicado",
		"plegado",
		"pluralizado",
		"podado",
		"poetizado",
		"polemizado",
		"politizado",
		"pololeado",
		"ponderado",
		"pontificado",
		"popularizado",
		"porfiado",
		"portado",
		"porteado",
		"posado",
		"posesionado",
		"posibilitado",
		"posicionado",
		"pospuesto",
		"posteado",
		"postergado",
		"postrado",
		"postulado",
		"potenciado",
		"practicado",
		"precarizado",
		"precedido",
		"preceptuado",
		"precintado",
		"precipitado",
		"precisado",
		"preconizado",
		"predicado",
		"predicho",
		"predispuesto",
		"predominado",
		"preferido",
		"prefigurado",
		"pregonado",
		"preguntado",
		"prejuzgado",
		"premiado",
		"prendado",
		"prendido",
		"preocupado",
		"preparado",
		"presagiado",
		"prescindido",
		"presenciado",
		"presentado",
		"presentido",
		"preservado",
		"presidido",
		"presionado",
		"prestado",
		"prestigiado",
		"presumido",
		"presurizado",
		"pretendido",
		"preterido",
		"prevalecido",
		"prevalido",
		"prevaricado",
		"prevenido",
		"previsto",
		"primado",
		"principiado",
		"pringado",
		"priorizado",
		"privatizado",
		"probado",
		"problematizado",
		"procedido",
		"procesado",
		"proclamado",
		"procreado",
		"procurado",
		"prodigado",
		"producido",
		"profanado",
		"proferido",
		"profesado",
		"profesionalizado",
		"profetizado",
		"profundizado",
		"programado",
		"progresado",
		"prohibido",
		"prohijado",
		"proletarizado",
		"proliferado",
		"prologado",
		"prolongado",
		"promediado",
		"prometido",
		"promocionado",
		"promovido",
		"promulgado",
		"pronosticado",
		"pronunciado",
		"propagado",
		"propalado",
		"propendido",
		"propiciado",
		"propinado",
		"proporcionado",
		"propuesto",
		"propugnado",
		"propulsado",
		"prorrateado",
		"prorrogado",
		"proseguido",
		"prosperado",
		"prostituido",
		"protegido",
		"protestado",
		"protocolizado",
		"provenido",
		"provocado",
		"proyectado",
		"psicoanalizado",
		"publicado",
		"publicitado",
		"puesto",
		"pugnado",
		"pujado",
		"pulido",
		"pulsado",
		"pululado",
		"pulverizado",
		"punado",
		"punteado",
		"puntuado",
		"puntualizado",
		"punzado",
		"purgado",
		"purificado",
		"puteado",
		"quebrado",
		"quebrantado",
		"quejado",
		"quemado",
		"querellado",
		"querido",
		"quintuplicado",
		"quitado",
		"racionado",
		"racionalizado",
		"radiado",
		"radicado",
		"radicalizado",
		"raído",
		"rajado",
		"ralentizado",
		"rapado",
		"rapeado",
		"raptado",
		"rascado",
		"rasgado",
		"rasguñado",
		"raspado",
		"rastreado",
		"rasurado",
		"ratificado",
		"rayado",
		"razonado",
		"reabierto",
		"reabsorbido",
		"reaccionado",
		"reactivado",
		"readaptado",
		"readmitido",
		"reafirmado",
		"reagrupado",
		"reajustado",
		"realimentado",
		"realizado",
		"realzado",
		"reanimado",
		"reanudado",
		"reaparecido",
		"rearmado",
		"reasumido",
		"reavivado",
		"rebajado",
		"rebalsado",
		"rebanado",
		"rebasado",
		"rebatido",
		"rebautizado",
		"rebelado",
		"reblandecido",
		"rebobinado",
		"rebosado",
		"rebotado",
		"rebozado",
		"rebuscado",
		"recabado",
		"recaído",
		"recalado",
		"recalcado",
		"recalentado",
		"recalificado",
		"recapacitado",
		"recapitulado",
		"recargado",
		"recatado",
		"recaudado",
		"receptado",
		"recetado",
		"rechazado",
		"recibido",
		"reciclado",
		"recitado",
		"reclamado",
		"reclinado",
		"reclutado",
		"recobrado",
		"recocido",
		"recogido",
		"recolectado",
		"recomendado",
		"recomenzado",
		"recompensado",
		"recompuesto",
		"reconcentrado",
		"reconciliado",
		"reconducido",
		"reconfortado",
		"reconocido",
		"reconquistado",
		"reconsiderado",
		"reconstituido",
		"reconstruido",
		"reconvenido",
		"reconvertido",
		"recopilado",
		"recordado",
		"recorrido",
		"recortado",
		"recreado",
		"recriminado",
		"recrudecido",
		"rectificado",
		"recubierto",
		"reculado",
		"recuperado",
		"recurrido",
		"recusado",
		"redactado",
		"redefinido",
		"redescubierto",
		"redimensionado",
		"redimido",
		"rediseñado",
		"redistribuido",
		"redituado",
		"redoblado",
		"redondeado",
		"reducido",
		"redundado",
		"reedificado",
		"reeditado",
		"reeducado",
		"reelaborado",
		"reembolsado",
		"reemplazado",
		"reencarnado",
		"reencauchado",
		"reencontrado",
		"reenganchado",
		"reenviado",
		"reescrito",
		"reestructurado",
		"reexaminado",
		"refaccionado",
		"referido",
		"refinado",
		"refinanciado",
		"reflejado",
		"reflexionado",
		"reflotado",
		"reforestado",
		"reformado",
		"reforzado",
		"refractado",
		"refrenado",
		"refrendado",
		"refrescado",
		"refrigerado",
		"refundido",
		"refutado",
		"regado",
		"regalado",
		"regañado",
		"regateado",
		"regenerado",
		"regentado",
		"regenteado",
		"regido",
		"regionalizado",
		"registrado",
		"reglado",
		"reglamentado",
		"regocijado",
		"regodeado",
		"regresado",
		"regulado",
		"regularizado",
		"regurgitado",
		"rehabilitado",
		"rehecho",
		"rehogado",
		"rehuido",
		"rehusado",
		"reído",
		"reinado",
		"reincidido",
		"reincorporado",
		"reingresado",
		"reiniciado",
		"reinsertado",
		"reinstalado",
		"reinstaurado",
		"reintegrado",
		"reinventado",
		"reinvertido",
		"reiterado",
		"reivindicado",
		"rejuvenecido",
		"relajado",
		"relamido",
		"relanzado",
		"relatado",
		"relativizado",
		"relegado",
		"releído",
		"relevado",
		"religado",
		"rellenado",
		"remachado",
		"remado",
		"remangado",
		"remarcado",
		"rematado",
		"remecido",
		"remediado",
		"rememorado",
		"remendado",
		"remitido",
		"remodelado",
		"remojado",
		"remolcado",
		"remontado",
		"removido",
		"remplazado",
		"renacido",
		"rendido",
		"renegado",
		"renegociado",
		"reñido",
		"renombrado",
		"renovado",
		"rentabilizado",
		"rentado",
		"renunciado",
		"reordenado",
		"reorganizado",
		"reorientado",
		"reparado",
		"repartido",
		"repasado",
		"repatriado",
		"repelido",
		"repensado",
		"repercutido",
		"repescado",
		"repetido",
		"repicado",
		"repintado",
		"replanteado",
		"replegado",
		"replicado",
		"repoblado",
		"reportado",
		"reporteado",
		"reposado",
		"repreguntado",
		"reprendido",
		"represado",
		"representado",
		"reprimido",
		"reprobado",
		"reprochado",
		"reproducido",
		"repudiado",
		"repuesto",
		"repugnado",
		"repuntado",
		"reputado",
		"requerido",
		"requisado",
		"resaltado",
		"resarcido",
		"resbalado",
		"rescatado",
		"rescindido",
		"resecado",
		"reseñado",
		"reservado",
		"reseteado",
		"resguardado",
		"residido",
		"resignado",
		"resistido",
		"resonado",
		"respaldado",
		"respetado",
		"respirado",
		"resplandecido",
		"respondido",
		"responsabilizado",
		"resquebrajado",
		"restablecido",
		"restado",
		"restaurado",
		"restituido",
		"restregado",
		"resucitado",
		"resuelto",
		"resumido",
		"resurgido",
		"retado",
		"retardado",
		"retenido",
		"retirado",
		"retocado",
		"retomado",
		"retorcido",
		"retornado",
		"retractado",
		"retraído",
		"retransmitido",
		"retrasado",
		"retratado",
		"retribuido",
		"retrotraído",
		"retumbado",
		"reunido",
		"reunificado",
		"reutilizado",
		"revalidado",
		"revalorizado",
		"revaluado",
		"revelado",
		"revendido",
		"reventado",
		"reverdecido",
		"reverenciado",
		"revertido",
		"revestido",
		"revirado",
		"revisado",
		"revitalizado",
		"revivido",
		"revocado",
		"revolcado",
		"revoloteado",
		"revolucionado",
		"revuelto",
		"ridiculizado",
		"rifado",
		"rimado",
		"rivalizado",
		"rizado",
		"robado",
		"robustecido",
		"rociado",
		"rodado",
		"rodeado",
		"rogado",
		"roído",
		"rondado",
		"rotado",
		"roto",
		"rotulado",
		"roturado",
		"rozado",
		"ruborizado",
		"rubricado",
		"rugido",
		"rumiado",
		"rumorado",
		"sabido",
		"saboreado",
		"saboteado",
		"sacado",
		"saciado",
		"sacralizado",
		"sacrificado",
		"sacudido",
		"saldado",
		"salpimentado",
		"salpullido",
		"saltado",
		"salteado",
		"saludado",
		"salvado",
		"salvaguardado",
		"sanado",
		"saneado",
		"sangrado",
		"santificado",
		"saqueado",
		"satanizado",
		"satirizado",
		"satisfecho",
		"sazonado",
		"secado",
		"seccionado",
		"secretado",
		"secuenciado",
		"secuestrado",
		"secundado",
		"sedimentado",
		"seducido",
		"segado",
		"segmentado",
		"segregado",
		"seguido",
		"seleccionado",
		"sembrado",
		"señalado",
		"sensibilizado",
		"sentado",
		"sentenciado",
		"sentido",
		"separado",
		"serenado",
		"serrado",
		"servido",
		"significado",
		"silenciado",
		"simbolizado",
		"simpatizado",
		"simplificado",
		"simulado",
		"sincerado",
		"sincronizado",
		"sindicado",
		"sindicalizado",
		"singularizado",
		"sintetizado",
		"sintonizado",
		"sistematizado",
		"situado",
		"sobado",
		"sobornado",
		"sobrado",
		"sobrecargado",
		"sobrecogido",
		"sobreentendido",
		"sobreestimado",
		"sobrellevado",
		"sobrentendido",
		"sobrepasado",
		"sobrepuesto",
		"sobresalido",
		"sobresaltado",
		"sobrestimado",
		"sobrevenido",
		"sobrevivido",
		"sobrevolado",
		"socavado",
		"socializado",
		"socorrido",
		"sodomizado",
		"sofocado",
		"sojuzgado",
		"solapado",
		"solicitado",
		"solidarizado",
		"solidificado",
		"soliviantado",
		"soltado",
		"solucionado",
		"solventado",
		"sombreado",
		"sometido",
		"sonado",
		"soñado",
		"sondeado",
		"sonreído",
		"sonrojado",
		"sopesado",
		"soplado",
		"soportado",
		"sorbido",
		"sorprendido",
		"sorteado",
		"sosegado",
		"soslayado",
		"sospechado",
		"sostenido",
		"suavizado",
		"subastado",
		"subcontratado",
		"subdividido",
		"subestimado",
		"subido",
		"sublevado",
		"sublimado",
		"subrayado",
		"subrogado",
		"subsanado",
		"subsidiado",
		"subsistido",
		"substraído",
		"subsumido",
		"subvertido",
		"subyugado",
		"succionado",
		"sucedido",
		"sucumbido",
		"sudado",
		"sufragado",
		"sufrido",
		"sugerido",
		"sugestionado",
		"suicidado",
		"sujetado",
		"sumado",
		"sumergido",
		"suministrado",
		"supeditado",
		"superado",
		"superpuesto",
		"supervisado",
		"suplantado",
		"suplicado",
		"suplido",
		"suprimido",
		"supuesto",
		"surcado",
		"surtido",
		"suscitado",
		"suspendido",
		"suspirado",
		"sustanciado",
		"sustantivado",
		"sustentado",
		"sustituido",
		"sustraído",
		"susurrado",
		"suturado",
		"tabulado",
		"tachado",
		"talado",
		"taladrado",
		"tallado",
		"tambaleado",
		"tamizado",
		"tañido",
		"tanteado",
		"tapado",
		"tapizado",
		"taponado",
		"tarareado",
		"tardado",
		"tasado",
		"tatuado",
		"tecleado",
		"tejido",
		"telefoneado",
		"televisado",
		"temido",
		"templado",
		"tendido",
		"tenido",
		"tensado",
		"tentado",
		"teorizado",
		"terciado",
		"tergiversado",
		"terminado",
		"territorializado",
		"testado",
		"testeado",
		"testificado",
		"testimoniado",
		"tildado",
		"timado",
		"timbrado",
		"tinturado",
		"tipeado",
		"tipificado",
		"tirado",
		"tiranizado",
		"tironeado",
		"tiroteado",
		"titubeado",
		"tiznado",
		"tocado",
		"tolerado",
		"tomado",
		"tonificado",
		"topado",
		"toqueteado",
		"torcido",
		"toreado",
		"tornado",
		"tornasolado",
		"torneado",
		"torpedeado",
		"torturado",
		"tosido",
		"tostado",
		"totalizado",
		"trabado",
		"trabajado",
		"traducido",
		"traficado",
		"tragado",
		"traicionado",
		"traído",
		"trajinado",
		"tramado",
		"tramitado",
		"trancado",
		"tranquilizado",
		"transcendido",
		"transcurrido",
		"transferido",
		"transfigurado",
		"transformado",
		"transfundido",
		"transgredido",
		"transigido",
		"transitado",
		"transliterado",
		"translucido",
		"transmitido",
		"transmutado",
		"transparentado",
		"transpirado",
		"transportado",
		"transpuesto",
		"trasegado",
		"trasgredido",
		"trasladado",
		"traslapado",
		"traslucido",
		"trasnochado",
		"traspapelado",
		"traspasado",
		"trasplantado",
		"traspuesto",
		"trasquilado",
		"trasteado",
		"trastocado",
		"trastornado",
		"trasvasado",
		"tratado",
		"trazado",
		"trenzado",
		"trepado",
		"tributado",
		"trincado",
		"triplicado",
		"triturado",
		"triunfado",
		"trivializado",
		"trocado",
		"troceado",
		"tronado",
		"tronchado",
		"truncado",
		"tumbado",
		"tuneado",
		"turbado",
		"turnado",
		"tutelado",
		"ufanado",
		"ultimado",
		"uncido",
		"ungido",
		"unido",
		"universalizado",
		"untado",
		"urbanizado",
		"urdido",
		"usado",
		"usufructuado",
		"usurpado",
		"utilizado",
		"vacado",
		"vaciado",
		"vacilado",
		"vacunado",
		"vagado",
		"validado",
		"valido",
		"valorado",
		"valorizado",
		"valuado",
		"vanagloriado",
		"vandalizado",
		"vaporizado",
		"variado",
		"vaticinado",
		"vedado",
		"vehiculado",
		"vejado",
		"velado",
		"vencido",
		"vendado",
		"vendido",
		"venerado",
		"vengado",
		"ventilado",
		"veraneado",
		"verbalizado",
		"verificado",
		"versado",
		"versionado",
		"vertebrado",
		"vertido",
		"vestido",
		"vetado",
		"viabilizado",
		"viajado",
		"vibrado",
		"victimado",
		"victimizado",
		"vigilado",
		"vigorizado",
		"vilipendiado",
		"vindicado",
		"violado",
		"violentado",
		"virado",
		"visado",
		"visibilizado",
		"visitado",
		"vislumbrado",
		"visto",
		"visualizado",
		"vitoreado",
		"vitrificado",
		"vituperado",
		"vivido",
		"vivificado",
		"vocalizado",
		"voceado",
		"vociferado",
		"volado",
		"volatilizado",
		"volcado",
		"volteado",
		"vomitado",
		"votado",
		"vuelto",
		"vulcanizado",
		"vulgarizado",
		"vulnerado",
		"yuxtapuesto",
		"zafado",
		"zambullido",
		"zampado",
		"zanjado",
		"zarandeado",
		"zarpado",
		"zozobrado",
		"zumbado",
		"zurcido",
		"zurrado",
		"abajada",
		"abalanzada",
		"abaleada",
		"abandonada",
		"abaratada",
		"abarcada",
		"abarrotada",
		"abastecida",
		"abatida",
		"abdicada",
		"abierta",
		"abismada",
		"abjurada",
		"ablandada",
		"abocada",
		"abochornada",
		"abofeteada",
		"abolida",
		"abollada",
		"abombada",
		"abominada",
		"abonada",
		"abordada",
		"aborrecida",
		"aborregada",
		"abortada",
		"abotonada",
		"abrasada",
		"abrazada",
		"abrevada",
		"abreviada",
		"abrigada",
		"abrochada",
		"abrogada",
		"abroquelada",
		"abrumada",
		"absorbida",
		"abstenida",
		"abstraída",
		"absuelta",
		"abucheada",
		"abultada",
		"abundada",
		"aburguesada",
		"aburrida",
		"abusada",
		"acabada",
		"acallada",
		"acalorada",
		"acaparada",
		"acariciada",
		"acarreada",
		"acatada",
		"acaudillada",
		"accedida",
		"accionada",
		"acechada",
		"aceitada",
		"acelerada",
		"acentuada",
		"aceptada",
		"acerada",
		"acercada",
		"acertada",
		"achacada",
		"achantada",
		"achatada",
		"achicada",
		"acicalada",
		"acidificada",
		"aclarada",
		"aclimatada",
		"acobardada",
		"acodada",
		"acogida",
		"acojonada",
		"acometida",
		"acomodada",
		"acompañada",
		"acompasada",
		"acongojada",
		"aconsejada",
		"acontecida",
		"acopiada",
		"acoplada",
		"acordada",
		"acordonada",
		"acorralada",
		"acortada",
		"acosada",
		"acostada",
		"acostumbrada",
		"acotada",
		"acrecentada",
		"acreditada",
		"acrisolada",
		"activada",
		"actuada",
		"acuchillada",
		"acuciada",
		"acudida",
		"acuerpada",
		"acumulada",
		"acunada",
		"acuñada",
		"acurrucada",
		"acusada",
		"adaptada",
		"adecentada",
		"adelantada",
		"adelgazada",
		"adentrada",
		"adeudada",
		"adherida",
		"adicionada",
		"adiestrada",
		"adivinada",
		"adjetivada",
		"adjudicada",
		"adjuntada",
		"administrada",
		"admirada",
		"admitida",
		"adoctrinada",
		"adolecida",
		"adoptada",
		"adorada",
		"adormecida",
		"adornada",
		"adquirida",
		"aducida",
		"adueñada",
		"adulada",
		"adulterada",
		"advertida",
		"afanada",
		"afeada",
		"afectada",
		"afeitada",
		"aferrada",
		"afianzada",
		"afinada",
		"afirmada",
		"afligida",
		"aflorada",
		"afrentada",
		"afrontada",
		"agachada",
		"agarrada",
		"agarrotada",
		"agasajada",
		"agenciada",
		"agigantada",
		"agilizada",
		"agitada",
		"aglutinada",
		"agobiada",
		"agolpada",
		"agonizada",
		"agostada",
		"agotada",
		"agradada",
		"agradecida",
		"agrandada",
		"agravada",
		"agraviada",
		"agredida",
		"agregada",
		"agriada",
		"agrietada",
		"agrupada",
		"aguada",
		"aguantada",
		"aguardada",
		"agudizada",
		"aguijoneada",
		"agujereada",
		"aguzada",
		"ahogada",
		"ahondada",
		"ahorcada",
		"ahorrada",
		"ahuecada",
		"ahuyentada",
		"aireada",
		"aislada",
		"ajustada",
		"ajusticiada",
		"alabada",
		"alagada",
		"alambrada",
		"alardeada",
		"alargada",
		"alarmada",
		"albergada",
		"alborotada",
		"alcanzada",
		"aleccionada",
		"alegada",
		"alegrada",
		"alejada",
		"alentada",
		"alertada",
		"alfabetizada",
		"alfombrada",
		"aliada",
		"alienada",
		"aligerada",
		"alimentada",
		"aliñada",
		"alineada",
		"alisada",
		"alistada",
		"aliviada",
		"alivianada",
		"allanada",
		"almacenada",
		"almorzada",
		"alojada",
		"alquilada",
		"alterada",
		"alternada",
		"alucinada",
		"aludida",
		"alumbrada",
		"alzada",
		"amada",
		"amaestrada",
		"amagada",
		"amainada",
		"amalgamada",
		"amamantada",
		"amansada",
		"amargada",
		"amarrada",
		"amasada",
		"ambicionada",
		"amedrentada",
		"amenazada",
		"amenizada",
		"ameritada",
		"ametrallada",
		"amilanada",
		"aminorada",
		"amnistiada",
		"amoldada",
		"amonestada",
		"amontonada",
		"amordazada",
		"amortajada",
		"amortiguada",
		"amortizada",
		"amotinada",
		"amparada",
		"ampayada",
		"ampliada",
		"amplificada",
		"amputada",
		"amueblada",
		"añadida",
		"analizada",
		"anatematizada",
		"andada",
		"anegada",
		"anestesiada",
		"anexada",
		"anexionada",
		"anhelada",
		"anidada",
		"anillada",
		"animada",
		"aniquilada",
		"anisada",
		"añorada",
		"anotada",
		"anoticiada",
		"ansiada",
		"antecedida",
		"antepuesta",
		"anticipada",
		"antojada",
		"anudada",
		"anulada",
		"anunciada",
		"apabullada",
		"apachurrada",
		"apaciguada",
		"apadrinada",
		"apagada",
		"apalancada",
		"apaleada",
		"apañada",
		"apantallada",
		"aparcada",
		"apareada",
		"aparecida",
		"aparentada",
		"apartada",
		"apeada",
		"apedreada",
		"apelada",
		"apellidada",
		"apelmazada",
		"apercibida",
		"apersonada",
		"apestada",
		"apetecida",
		"apiadada",
		"apilada",
		"apiñada",
		"apisonada",
		"aplacada",
		"aplanada",
		"aplastada",
		"aplaudida",
		"aplazada",
		"aplicada",
		"apoderada",
		"apoltronada",
		"aporreada",
		"aportada",
		"aposentada",
		"apostada",
		"apostatada",
		"apostillada",
		"apoyada",
		"apreciada",
		"aprehendida",
		"apremiada",
		"aprendida",
		"apresada",
		"apresurada",
		"apretada",
		"apretujada",
		"aprisionada",
		"aprobada",
		"aprovechada",
		"aprovisionada",
		"aproximada",
		"apuñalada",
		"apuñaleada",
		"apuntada",
		"apuntalada",
		"apuntillada",
		"apurada",
		"aquejada",
		"aquietada",
		"aquilatada",
		"arañada",
		"arbitrada",
		"archivada",
		"arengada",
		"argüida",
		"argumentada",
		"armada",
		"armonizada",
		"aromatizada",
		"arqueada",
		"arrancada",
		"arrasada",
		"arrastrada",
		"arreada",
		"arrebatada",
		"arreciada",
		"arreglada",
		"arrellanada",
		"arremangada",
		"arremetida",
		"arrendada",
		"arrepentida",
		"arrestada",
		"arriada",
		"arribada",
		"arriesgada",
		"arrimada",
		"arrinconada",
		"arrodillada",
		"arrogada",
		"arrojada",
		"arrollada",
		"arropada",
		"arruinada",
		"arrullada",
		"articulada",
		"asada",
		"asaltada",
		"ascendida",
		"aseada",
		"asechada",
		"asediada",
		"asegurada",
		"asemejada",
		"asentada",
		"asentida",
		"aserrada",
		"asesinada",
		"asesorada",
		"asestada",
		"aseverada",
		"asfixiada",
		"asida",
		"asignada",
		"asilada",
		"asimilada",
		"asistida",
		"asolada",
		"asoleada",
		"asomada",
		"asombrada",
		"aspirada",
		"astillada",
		"asumida",
		"asustada",
		"atacada",
		"atada",
		"atajada",
		"atarantada",
		"atascada",
		"atemorizada",
		"atemperada",
		"atenazada",
		"atendida",
		"atenida",
		"atentada",
		"atenuada",
		"aterrada",
		"aterrorizada",
		"atesorada",
		"atestiguada",
		"atiborrada",
		"atisbada",
		"atizada",
		"atomizada",
		"atontada",
		"atorada",
		"atormentada",
		"atornillada",
		"atosigada",
		"atracada",
		"atragantada",
		"atraída",
		"atrancada",
		"atrapada",
		"atrasada",
		"atravesada",
		"atrevida",
		"atribuida",
		"atrincherada",
		"atrofiada",
		"atropellada",
		"aturdida",
		"auditada",
		"augurada",
		"aumentada",
		"aunada",
		"aupada",
		"auscultada",
		"ausentada",
		"autenticada",
		"autentificada",
		"autodefinida",
		"autoeditada",
		"automatizada",
		"autorizada",
		"autorregulada",
		"auxiliada",
		"avalada",
		"avanzada",
		"avasallada",
		"avenida",
		"aventada",
		"aventajada",
		"aventurada",
		"averiada",
		"averiguada",
		"avezada",
		"avisada",
		"avispada",
		"avistada",
		"avivada",
		"avizorada",
		"avocada",
		"ayudada",
		"azotada",
		"azuzada",
		"babeada",
		"bailada",
		"bajada",
		"balaceada",
		"balanceada",
		"bañada",
		"banalizada",
		"bancada",
		"bandeada",
		"barajada",
		"barrida",
		"basada",
		"bastardeada",
		"basureada",
		"batallada",
		"bateada",
		"batida",
		"bautizada",
		"beatificada",
		"bebida",
		"beneficiada",
		"besada",
		"bifurcada",
		"birlada",
		"blandida",
		"blanqueada",
		"blasfemada",
		"blindada",
		"bloqueada",
		"boicoteada",
		"bombardeada",
		"bombeada",
		"bonificada",
		"bordeada",
		"borrada",
		"borroneada",
		"bosquejada",
		"bostezada",
		"botada",
		"boxeada",
		"bregada",
		"brillada",
		"brincada",
		"brindada",
		"bromeada",
		"brotada",
		"bruñida",
		"buceada",
		"burlada",
		"buscada",
		"cabeceada",
		"cabida",
		"cabildeada",
		"cabreada",
		"cacareada",
		"cachada",
		"cacheada",
		"cacheteada",
		"caducada",
		"cagada",
		"calada",
		"calculada",
		"caldeada",
		"calefaccionada",
		"calendarizada",
		"calentada",
		"calibrada",
		"calificada",
		"caligrafiada",
		"callada",
		"calmada",
		"calumniada",
		"calzada",
		"cambiada",
		"caminada",
		"camuflada",
		"canalizada",
		"cancelada",
		"canjeada",
		"cansada",
		"cantada",
		"capada",
		"capeada",
		"capitalizada",
		"capitulada",
		"captada",
		"capturada",
		"caracterizada",
		"carburada",
		"carcomida",
		"cardada",
		"careada",
		"carecida",
		"cargada",
		"caricaturizada",
		"cartografiada",
		"cascada",
		"castigada",
		"castrada",
		"catada",
		"catalizada",
		"catalogada",
		"catapultada",
		"cateada",
		"categorizada",
		"causada",
		"cauterizada",
		"cautivada",
		"cavada",
		"cavilada",
		"cazada",
		"cebada",
		"cedida",
		"cegada",
		"cejada",
		"celebrada",
		"cenada",
		"ceñida",
		"censurada",
		"centrifugada",
		"centuplicada",
		"cepillada",
		"cercada",
		"cercenada",
		"cerciorada",
		"cernida",
		"cerrada",
		"cesada",
		"chafada",
		"chamuscada",
		"chantajeada",
		"chapada",
		"charlada",
		"chateada",
		"chequeada",
		"chiflada",
		"chillada",
		"chingada",
		"chirriada",
		"chivada",
		"chocada",
		"chorreada",
		"choteada",
		"chupada",
		"chutada",
		"cicatrizada",
		"cifrada",
		"cimentada",
		"cincelada",
		"circulada",
		"circuncidada",
		"circundada",
		"citada",
		"clamada",
		"clarificada",
		"clasificada",
		"claudicada",
		"clausurada",
		"clavada",
		"clicada",
		"clonada",
		"coaccionada",
		"coadyuvada",
		"coagulada",
		"coaligada",
		"coartada",
		"cobijada",
		"cobrada",
		"cocida",
		"cocinada",
		"codeada",
		"codiciada",
		"codificada",
		"codirigida",
		"coexistida",
		"cofinanciada",
		"cogida",
		"cohabitada",
		"cohibida",
		"coincidida",
		"colaborada",
		"colacionada",
		"colada",
		"colapsada",
		"coleccionada",
		"colectada",
		"colectivizada",
		"colgada",
		"colisionada",
		"colmada",
		"colocada",
		"colonizada",
		"coloreada",
		"columpiada",
		"combatida",
		"combinada",
		"comentada",
		"comenzada",
		"comerciada",
		"comercializada",
		"cometida",
		"comida",
		"comisionada",
		"compactada",
		"compadecida",
		"compaginada",
		"comparada",
		"comparecida",
		"compartida",
		"compatibilizada",
		"compelida",
		"compendiada",
		"compenetrada",
		"compensada",
		"compilada",
		"complacida",
		"complementada",
		"completada",
		"complotada",
		"comportada",
		"comprada",
		"comprendida",
		"comprimida",
		"comprobada",
		"comprometida",
		"compuesta",
		"compulsada",
		"computada",
		"comulgada",
		"comunicada",
		"concatenada",
		"concebida",
		"concedida",
		"concelebrada",
		"concentrada",
		"conceptuada",
		"conceptualizada",
		"concertada",
		"concienciada",
		"concientizada",
		"conciliada",
		"concitada",
		"concluida",
		"concordada",
		"concretada",
		"concretizada",
		"conculcada",
		"concursada",
		"condenada",
		"condensada",
		"condicionada",
		"condimentada",
		"condolida",
		"condonada",
		"conducida",
		"conectada",
		"conexionada",
		"confabulada",
		"confeccionada",
		"conferida",
		"confesada",
		"confiada",
		"configurada",
		"confirmada",
		"confiscada",
		"confluida",
		"conformada",
		"confortada",
		"confrontada",
		"confundida",
		"congeniada",
		"congestionada",
		"congratulada",
		"congregada",
		"conjeturada",
		"conjugada",
		"conjuntada",
		"conjurada",
		"conllevada",
		"conmemorada",
		"conminada",
		"conmocionada",
		"conmovida",
		"conmutada",
		"connotada",
		"conquistada",
		"consagrada",
		"conseguida",
		"consensuada",
		"consentida",
		"conservada",
		"considerada",
		"consignada",
		"consistida",
		"consolada",
		"consolidada",
		"conspirada",
		"constada",
		"constatada",
		"constelada",
		"constitucionalizada",
		"constituida",
		"constreñida",
		"construida",
		"consultada",
		"consumada",
		"consumida",
		"contabilizada",
		"contactada",
		"contada",
		"contagiada",
		"contemplada",
		"contendida",
		"contenida",
		"contentada",
		"contestada",
		"contextualizada",
		"continuada",
		"contorneada",
		"contraatacada",
		"contrabandeada",
		"contradicha",
		"contrahecha",
		"contraída",
		"contrapesada",
		"contrapuesta",
		"contrariada",
		"contrarrestada",
		"contrastada",
		"contratada",
		"contravenida",
		"contribuida",
		"contristada",
		"controlada",
		"convalidada",
		"convencida",
		"convenida",
		"convergida",
		"conversada",
		"convertida",
		"convidada",
		"convivida",
		"convocada",
		"convulsionada",
		"cooperada",
		"cooptada",
		"coordinada",
		"copada",
		"copiada",
		"coproducida",
		"copulada",
		"coqueteada",
		"corchada",
		"coreada",
		"coreografiada",
		"corneada",
		"coronada",
		"corporizada",
		"corregida",
		"correlacionada",
		"correspondida",
		"correteada",
		"corrida",
		"corroborada",
		"corroída",
		"corrompida",
		"cortada",
		"cortejada",
		"cosechada",
		"cosida",
		"cosificada",
		"costada",
		"costeada",
		"cotejada",
		"cotizada",
		"creada",
		"creída",
		"criada",
		"cribada",
		"criminalizada",
		"crispada",
		"cristalizada",
		"cristianizada",
		"criticada",
		"cronometrada",
		"crucificada",
		"crujida",
		"cruzada",
		"cuadriplicada",
		"cuadruplicada",
		"cuajada",
		"cuantificada",
		"cuarteada",
		"cubierta",
		"cuestionada",
		"cuidada",
		"culeada",
		"culminada",
		"culpabilizada",
		"culpada",
		"cultivada",
		"culturizada",
		"cumplida",
		"cumplimentada",
		"cundida",
		"curada",
		"curioseada",
		"currada",
		"cursada",
		"curvada",
		"custodiada",
		"dada",
		"dañada",
		"danzada",
		"datada",
		"dateada",
		"debatida",
		"debida",
		"debilitada",
		"debitada",
		"debutada",
		"decaída",
		"decantada",
		"decapitada",
		"decepcionada",
		"decidida",
		"declamada",
		"declarada",
		"declinada",
		"decodificada",
		"decolorada",
		"decomisada",
		"decrecida",
		"decretada",
		"dedicada",
		"deducida",
		"defecada",
		"defendida",
		"defenestrada",
		"deferida",
		"definida",
		"deformada",
		"defraudada",
		"degenerada",
		"deglutida",
		"degollada",
		"degradada",
		"degustada",
		"deificada",
		"dejada",
		"delatada",
		"delegada",
		"deleitada",
		"deletreada",
		"deliberada",
		"delimitada",
		"delineada",
		"delinquida",
		"demandada",
		"demarcada",
		"demediada",
		"demeritada",
		"democratizada",
		"demolida",
		"demonizada",
		"demorada",
		"demostrada",
		"demudada",
		"denegada",
		"denigrada",
		"denominada",
		"denostada",
		"denotada",
		"denunciada",
		"deparada",
		"departida",
		"dependida",
		"depilada",
		"deplorada",
		"deportada",
		"depositada",
		"depreciada",
		"depredada",
		"deprimida",
		"depuesta",
		"depurada",
		"derechizada",
		"derivada",
		"derogada",
		"derramada",
		"derretida",
		"derribada",
		"derrocada",
		"derrochada",
		"derrotada",
		"derruida",
		"derrumbada",
		"desabrochada",
		"desacatada",
		"desacelerada",
		"desacomodada",
		"desaconsejada",
		"desacoplada",
		"desacralizada",
		"desacreditada",
		"desactivada",
		"desafiada",
		"desafinada",
		"desaguada",
		"desahogada",
		"desairada",
		"desajustada",
		"desalentada",
		"desalineada",
		"desalojada",
		"desandada",
		"desangrada",
		"desanimada",
		"desaparecida",
		"desapegada",
		"desaprendida",
		"desaprobada",
		"desaprovechada",
		"desarmada",
		"desarraigada",
		"desarreglada",
		"desarrollada",
		"desarticulada",
		"desaseada",
		"desasida",
		"desasosegada",
		"desatada",
		"desatendida",
		"desautorizada",
		"desayunada",
		"desbancada",
		"desbandada",
		"desbaratada",
		"desbarrancada",
		"desbastada",
		"desbloqueada",
		"desbocada",
		"desbordada",
		"desbrozada",
		"descabalgada",
		"descabezada",
		"descaderada",
		"descalabrada",
		"descalificada",
		"descansada",
		"descargada",
		"descarriada",
		"descarrilada",
		"descartada",
		"descascarada",
		"descascarillada",
		"descendida",
		"descentrada",
		"descifrada",
		"descocida",
		"descodificada",
		"descojonada",
		"descolgada",
		"descolocada",
		"descolonizada",
		"descompensada",
		"descomprimida",
		"descompuesta",
		"desconectada",
		"desconfiada",
		"descongelada",
		"desconocida",
		"descontada",
		"descontaminada",
		"descontextualizada",
		"descontinuada",
		"desconvocada",
		"descorazonada",
		"descorchada",
		"descorrida",
		"descosida",
		"descoyuntada",
		"descreída",
		"descristianizada",
		"descuadrada",
		"descuartizada",
		"descubierta",
		"descuidada",
		"desdeñada",
		"desdibujada",
		"desdicha",
		"desdoblada",
		"deseada",
		"desecada",
		"desechada",
		"desembarazada",
		"desembarcada",
		"desembocada",
		"desembolsada",
		"desempacada",
		"desempañada",
		"desempaquetada",
		"desempeñada",
		"desempolvada",
		"desenamorada",
		"desencadenada",
		"desencajada",
		"desencarnada",
		"desenchufada",
		"desenfocada",
		"desenfundada",
		"desenganchada",
		"desengrasada",
		"desenmascarada",
		"desenredada",
		"desenrollada",
		"desentendida",
		"desenterrada",
		"desentonada",
		"desentrañada",
		"desenvainada",
		"desenvuelta",
		"desequilibrada",
		"desertada",
		"desestabilizada",
		"desestimada",
		"desfalcada",
		"desfallecida",
		"desfigurada",
		"desfondada",
		"desgajada",
		"desgañitada",
		"desgarrada",
		"desgastada",
		"desglosada",
		"desgobernada",
		"desgranada",
		"desguazada",
		"deshecha",
		"desheredada",
		"deshidratada",
		"deshilachada",
		"deshojada",
		"deshonrada",
		"deshuesada",
		"deshumanizada",
		"designada",
		"desilusionada",
		"desincentivada",
		"desinfectada",
		"desinflada",
		"desinflamada",
		"desinformada",
		"desinhibida",
		"desinstalada",
		"desintegrada",
		"desintoxicada",
		"desistida",
		"desjarretada",
		"deslegitimada",
		"desleída",
		"desligada",
		"deslindada",
		"deslizada",
		"deslucida",
		"deslumbrada",
		"desmadrada",
		"desmalezada",
		"desmantelada",
		"desmaquillada",
		"desmarcada",
		"desmayada",
		"desmejorada",
		"desmembrada",
		"desmentida",
		"desmenuzada",
		"desmerecida",
		"desmigada",
		"desmitificada",
		"desmoldada",
		"desmontada",
		"desmoralizada",
		"desmoronada",
		"desmotivada",
		"desmovilizada",
		"desnaturalizada",
		"desnivelada",
		"desnucada",
		"desnudada",
		"desobedecida",
		"desobligada",
		"desoída",
		"desollada",
		"desorganizada",
		"desorientada",
		"despachada",
		"desparasitada",
		"desparecida",
		"desparramada",
		"despedazada",
		"despedida",
		"despegada",
		"despeinada",
		"despejada",
		"despellejada",
		"despeñada",
		"despenalizada",
		"desperdiciada",
		"despersonalizada",
		"despertada",
		"despilfarrada",
		"despintada",
		"despiojada",
		"despistada",
		"desplazada",
		"desplegada",
		"desplomada",
		"desplumada",
		"despojada",
		"despolitizada",
		"desposada",
		"desposeída",
		"despotricada",
		"despreciada",
		"desprendida",
		"despreocupada",
		"desprestigiada",
		"desprogramada",
		"despulpada",
		"despuntada",
		"desquiciada",
		"desquitada",
		"destacada",
		"destapada",
		"desteñida",
		"desterrada",
		"destetada",
		"destilada",
		"destituida",
		"destrabada",
		"destripada",
		"destronada",
		"destrozada",
		"destruida",
		"desunida",
		"desvalijada",
		"desvalorizada",
		"desvanecida",
		"desvelada",
		"desvestida",
		"desviada",
		"desvinculada",
		"desvirtuada",
		"desvivida",
		"detectada",
		"detenida",
		"detentada",
		"deteriorada",
		"determinada",
		"detestada",
		"detonada",
		"devaluada",
		"devanada",
		"devastada",
		"develada",
		"devengada",
		"devenida",
		"devorada",
		"devuelta",
		"diagnosticada",
		"diagramada",
		"dializada",
		"dialogada",
		"dibujada",
		"dicha",
		"dictada",
		"dictaminada",
		"diezmada",
		"difamada",
		"diferenciada",
		"diferida",
		"dificultada",
		"difuminada",
		"difundida",
		"digerida",
		"digitada",
		"dignada",
		"dignificada",
		"dilapidada",
		"dilatada",
		"diligenciada",
		"dilucidada",
		"diluida",
		"dimensionada",
		"dimitida",
		"dinamitada",
		"dinamizada",
		"dirimida",
		"discernida",
		"disciplinada",
		"discontinuada",
		"discrepada",
		"discriminada",
		"disculpada",
		"discurrida",
		"discutida",
		"diseccionada",
		"diseminada",
		"diseñada",
		"disentida",
		"disertada",
		"disfrazada",
		"disfrutada",
		"disgregada",
		"disgustada",
		"disimulada",
		"disipada",
		"dislocada",
		"disminuida",
		"disociada",
		"dispensada",
		"dispersada",
		"dispuesta",
		"disputada",
		"distada",
		"distanciada",
		"distendida",
		"distinguida",
		"distorsionada",
		"distraída",
		"distribuida",
		"disuadida",
		"disuelta",
		"divagada",
		"diversificada",
		"divertida",
		"dividida",
		"divinizada",
		"divisada",
		"divorciada",
		"divulgada",
		"doblada",
		"doblegada",
		"doctorada",
		"documentada",
		"dogmatizada",
		"dolida",
		"domada",
		"domesticada",
		"dominada",
		"donada",
		"dopada",
		"dormida",
		"dosificada",
		"dotada",
		"dragada",
		"dramatizada",
		"drenada",
		"drogada",
		"duchada",
		"dudada",
		"dulcificada",
		"duplicada",
		"durada",
		"echada",
		"eclipsada",
		"eclosionada",
		"economizada",
		"ecualizada",
		"edificada",
		"editada",
		"educada",
		"efectuada",
		"ejecutada",
		"ejemplificada",
		"ejercida",
		"ejercitada",
		"elaborada",
		"electrizada",
		"electrocutada",
		"elevada",
		"elidida",
		"eliminada",
		"elogiada",
		"elucubrada",
		"eludida",
		"emanada",
		"emancipada",
		"embadurnada",
		"embalada",
		"embalsamada",
		"embanderada",
		"embarcada",
		"embargada",
		"embarrada",
		"embarrancada",
		"embaucada",
		"embebida",
		"embelesada",
		"embellecida",
		"embestida",
		"embolada",
		"embolsada",
		"emborrachada",
		"emborronada",
		"emboscada",
		"embotada",
		"embriagada",
		"embrollada",
		"embrutecida",
		"embuchada",
		"emergida",
		"emigrada",
		"emitida",
		"emocionada",
		"empacada",
		"empachada",
		"empadronada",
		"empalada",
		"empalmada",
		"empanada",
		"empañada",
		"empantanada",
		"empapelada",
		"empaquetada",
		"emparejada",
		"empastada",
		"empatada",
		"empecinada",
		"empeñada",
		"empeorada",
		"empequeñecida",
		"emperrada",
		"empezada",
		"empinada",
		"emplazada",
		"empleada",
		"empobrecida",
		"empoderada",
		"empollada",
		"empolvada",
		"emponzoñada",
		"emprendida",
		"empujada",
		"empuñada",
		"emputada",
		"emulada",
		"emulsionada",
		"enajenada",
		"enaltecida",
		"enamorada",
		"enarbolada",
		"enardecida",
		"encabezada",
		"encabritada",
		"encabronada",
		"encadenada",
		"encajada",
		"encajonada",
		"encallada",
		"encamada",
		"encaminada",
		"encandilada",
		"encanecida",
		"encañonada",
		"encantada",
		"encaprichada",
		"encapsulada",
		"encarada",
		"encaramada",
		"encarecida",
		"encargada",
		"encariñada",
		"encarnada",
		"encarrilada",
		"encartada",
		"encasillada",
		"encasquetada",
		"encasquillada",
		"encastrada",
		"encausada",
		"encauzada",
		"enceguecida",
		"encendida",
		"encerada",
		"encerrada",
		"encharcada",
		"enchufada",
		"encimada",
		"encogida",
		"encolada",
		"encolerizada",
		"encolumnada",
		"encomendada",
		"enconada",
		"encontrada",
		"encordada",
		"encrespada",
		"encuadrada",
		"encubierta",
		"encuerada",
		"encumbrada",
		"enderezada",
		"endeudada",
		"endilgada",
		"endiosada",
		"endosada",
		"endulzada",
		"endurecida",
		"enemistada",
		"energizada",
		"enervada",
		"enfadada",
		"enfangada",
		"enfatizada",
		"enfermada",
		"enfiestada",
		"enfilada",
		"enflaquecida",
		"enfocada",
		"enfrascada",
		"enfrentada",
		"enfriada",
		"enfurecida",
		"engalanada",
		"engañada",
		"enganchada",
		"engarzada",
		"engatusada",
		"engendrada",
		"englobada",
		"engolosinada",
		"engordada",
		"engranada",
		"engrandecida",
		"engrasada",
		"engreída",
		"engrosada",
		"engullida",
		"enharinada",
		"enhebrada",
		"enjuagada",
		"enjugada",
		"enjuiciada",
		"enlazada",
		"enlistada",
		"enlodada",
		"enloquecida",
		"enlozada",
		"enlutada",
		"enmarañada",
		"enmascarada",
		"enmendada",
		"enmohecida",
		"enmudecida",
		"ennegrecida",
		"ennoblecida",
		"enorgullecida",
		"enrarecida",
		"enredada",
		"enripiada",
		"enriquecida",
		"enrocada",
		"enrojecida",
		"enrolada",
		"enrollada",
		"enroscada",
		"enrumbada",
		"ensalzada",
		"ensamblada",
		"ensañada",
		"ensanchada",
		"ensartada",
		"ensayada",
		"ensebada",
		"enseñada",
		"enseñoreada",
		"ensillada",
		"ensoberbecida",
		"ensogada",
		"ensombrecida",
		"ensoñada",
		"ensordecida",
		"ensuciada",
		"entablada",
		"entallada",
		"entendida",
		"enterada",
		"enternecida",
		"enterrada",
		"entibiada",
		"entintada",
		"entonada",
		"entorpecida",
		"entrada",
		"entrampada",
		"entrañada",
		"entreabierta",
		"entrecomillada",
		"entrecruzada",
		"entregada",
		"entrelazada",
		"entremetida",
		"entremezclada",
		"entrenada",
		"entresacada",
		"entretejida",
		"entretenida",
		"entreverada",
		"entrevistada",
		"entristecida",
		"entrometida",
		"entronada",
		"entroncada",
		"entronizada",
		"entumecida",
		"enturbiada",
		"entusiasmada",
		"enumerada",
		"enunciada",
		"envainada",
		"envalentonada",
		"envanecida",
		"envasada",
		"envejecida",
		"envenenada",
		"envestida",
		"enviada",
		"enviciada",
		"envidiada",
		"envilecida",
		"enviudada",
		"envuelta",
		"enzarzada",
		"equilibrada",
		"equiparada",
		"equivocada",
		"erigida",
		"erizada",
		"erogada",
		"erosionada",
		"erotizada",
		"erradicada",
		"errada",
		"esbozada",
		"escabullida",
		"escalada",
		"escaldada",
		"escalfada",
		"escamada",
		"escamoteada",
		"escampada",
		"escandalizada",
		"escaneada",
		"escapada",
		"escaqueada",
		"escarbada",
		"escarchada",
		"escarmentada",
		"escarnecida",
		"escaseada",
		"escatimada",
		"escenificada",
		"escindida",
		"esclarecida",
		"esclavizada",
		"escocida",
		"escogida",
		"escolarizada",
		"escoltada",
		"escondida",
		"escorada",
		"escrachada",
		"escrita",
		"escrutada",
		"escuchada",
		"escudada",
		"escudriñada",
		"esculpida",
		"escupida",
		"escurrida",
		"esforzada",
		"esfumada",
		"esgrimida",
		"esmerada",
		"esmerilada",
		"espabilada",
		"espaciada",
		"españolizada",
		"espantada",
		"esparcida",
		"especificada",
		"especulada",
		"esperada",
		"espesada",
		"espetada",
		"espiada",
		"espigada",
		"espinada",
		"espirada",
		"espiritualizada",
		"espoleada",
		"espolvoreada",
		"esponjada",
		"esponsorizada",
		"esposada",
		"esquematizada",
		"esquiada",
		"esquilada",
		"esquilmada",
		"esquivada",
		"estabilizada",
		"establecida",
		"estacionada",
		"estafada",
		"estallada",
		"estampada",
		"estancada",
		"estaqueada",
		"estatizada",
		"estatuida",
		"esterificada",
		"esterilizada",
		"estigmatizada",
		"estilizada",
		"estimada",
		"estimulada",
		"estipulada",
		"estirada",
		"estorbada",
		"estornudada",
		"estragada",
		"estrangulada",
		"estrechada",
		"estrellada",
		"estremecida",
		"estrenada",
		"estresada",
		"estriada",
		"estropeada",
		"estructurada",
		"estrujada",
		"estudiada",
		"eternizada",
		"etiquetada",
		"evacuada",
		"evadida",
		"evaluada",
		"evangelizada",
		"evaporada",
		"evidenciada",
		"eviscerada",
		"evitada",
		"evocada",
		"evolucionada",
		"exacerbada",
		"exagerada",
		"exaltada",
		"examinada",
		"exasperada",
		"excarcelada",
		"excavada",
		"excedida",
		"exceptuada",
		"excitada",
		"exclamada",
		"excluida",
		"excretada",
		"exculpada",
		"excusada",
		"execrada",
		"exhalada",
		"exhibida",
		"exhortada",
		"exhumada",
		"exigida",
		"exilada",
		"eximida",
		"existida",
		"exonerada",
		"exorcizada",
		"expandida",
		"expedida",
		"expedientada",
		"expelida",
		"expendida",
		"experimentada",
		"expiada",
		"expirada",
		"explayada",
		"explicada",
		"explicitada",
		"explorada",
		"explosionada",
		"explotada",
		"expoliada",
		"exportada",
		"expresada",
		"exprimida",
		"expropiada",
		"expuesta",
		"expulsada",
		"expurgada",
		"extendida",
		"exteriorizada",
		"exterminada",
		"externada",
		"externalizada",
		"extinguida",
		"extirpada",
		"extorsionada",
		"extractada",
		"extraditada",
		"extraída",
		"extralimitada",
		"extrañada",
		"extrapolada",
		"extraviada",
		"extremada",
		"extruida",
		"exudada",
		"eyaculada",
		"eyectada",
		"fabricada",
		"fabulada",
		"facilitada",
		"facturada",
		"facultada",
		"fagocitada",
		"fajada",
		"fallada",
		"fallecida",
		"falsada",
		"falseada",
		"falsificada",
		"familiarizada",
		"fantaseada",
		"fascinada",
		"fastidiada",
		"fatigada",
		"favorecida",
		"fecundada",
		"felicitada",
		"feminizada",
		"fenecida",
		"fermentada",
		"fertilizada",
		"festejada",
		"fiada",
		"fichada",
		"fidelizada",
		"figurada",
		"fijada",
		"filmada",
		"filosofada",
		"filtrada",
		"finalizada",
		"financiada",
		"fincada",
		"fingida",
		"finiquitada",
		"firmada",
		"fiscalizada",
		"fisurada",
		"flagelada",
		"flameada",
		"flanqueada",
		"flaqueada",
		"fletada",
		"flexibilizada",
		"flexionada",
		"flipada",
		"floreada",
		"florecida",
		"flotada",
		"fluctuada",
		"focalizada",
		"fogueada",
		"foliada",
		"follada",
		"fomentada",
		"fondeada",
		"forcejeada",
		"forestada",
		"forjada",
		"formada",
		"formalizada",
		"formateada",
		"formulada",
		"fornicada",
		"forrada",
		"fortalecida",
		"forzada",
		"fotocopiada",
		"fotografiada",
		"fracasada",
		"fraccionada",
		"fracturada",
		"fragmentada",
		"fraguada",
		"franqueada",
		"frecuentada",
		"fregada",
		"frenada",
		"fresada",
		"friccionada",
		"frotada",
		"fructificada",
		"fruncida",
		"fugada",
		"fulminada",
		"fumada",
		"fumigada",
		"funcionada",
		"fundada",
		"fundamentada",
		"fundida",
		"fungida",
		"fusilada",
		"fusionada",
		"fustigada",
		"gafada",
		"ganada",
		"gangrenada",
		"garabateada",
		"garantida",
		"garantizada",
		"garrida",
		"gaseada",
		"gastada",
		"gemida",
		"generada",
		"generalizada",
		"gerenciada",
		"germinada",
		"gestada",
		"gestionada",
		"girada",
		"glorificada",
		"glosada",
		"gobernada",
		"goleada",
		"golpeada",
		"gozada",
		"grabada",
		"graduada",
		"graficada",
		"granjeada",
		"grapada",
		"gratificada",
		"gravada",
		"gravitada",
		"gritada",
		"gruñida",
		"guardada",
		"guarecida",
		"guarnecida",
		"guerreada",
		"guiada",
		"guillotinada",
		"guiñada",
		"guindada",
		"guisada",
		"gustada",
		"habilitada",
		"habitada",
		"habituada",
		"hablada",
		"halada",
		"halagada",
		"hallada",
		"hartada",
		"hechizada",
		"hecha",
		"helenizada",
		"henchida",
		"hendida",
		"heredada",
		"herida",
		"hermanada",
		"herrada",
		"hervida",
		"hibernada",
		"hibridada",
		"hidratada",
		"higienizada",
		"hilada",
		"hilvanada",
		"hincada",
		"hinchada",
		"hipnotizada",
		"hipotecada",
		"historiada",
		"hojeada",
		"holgada",
		"hollada",
		"homenajeada",
		"homogeneizada",
		"homologada",
		"honrada",
		"horadada",
		"horneada",
		"horrorizada",
		"hospedada",
		"hostigada",
		"hostilizada",
		"huida",
		"humanada",
		"humanizada",
		"humectada",
		"humedecida",
		"humillada",
		"hundida",
		"hurgada",
		"hurtada",
		"ideada",
		"idealizada",
		"identificada",
		"ideologizada",
		"idiotizada",
		"idolatrada",
		"ignorada",
		"igualada",
		"ilegalizada",
		"iluminada",
		"ilusionada",
		"ilustrada",
		"imaginada",
		"imbricada",
		"imitada",
		"impactada",
		"impartida",
		"impedida",
		"impelida",
		"imperada",
		"impermeabilizada",
		"implantada",
		"implementada",
		"implicada",
		"implorada",
		"importada",
		"importunada",
		"imposibilitada",
		"impresionada",
		"improvisada",
		"impuesta",
		"impugnada",
		"impulsada",
		"imputada",
		"inaugurada",
		"incautada",
		"incendiada",
		"incentivada",
		"incinerada",
		"incitada",
		"inclinada",
		"incluida",
		"incoada",
		"incomodada",
		"incorporada",
		"incrementada",
		"increpada",
		"incriminada",
		"incubada",
		"inculcada",
		"inculpada",
		"incumplida",
		"incurrida",
		"incursionada",
		"indagada",
		"indemnizada",
		"independizada",
		"indexada",
		"indicada",
		"indigestada",
		"indignada",
		"indispuesta",
		"individuada",
		"inducida",
		"indultada",
		"inervada",
		"infamada",
		"infartada",
		"infectada",
		"inferida",
		"inficionada",
		"infiltrada",
		"inflada",
		"inflamada",
		"infligida",
		"influenciada",
		"influida",
		"informada",
		"infravalorada",
		"infringida",
		"infundida",
		"ingeniada",
		"ingerida",
		"ingresada",
		"inhabilitada",
		"inhalada",
		"inhibida",
		"inhumada",
		"iniciada",
		"inicializada",
		"injertada",
		"injuriada",
		"inmigrada",
		"inmiscuida",
		"inmolada",
		"inmortalizada",
		"inmovilizada",
		"inmunizada",
		"innovada",
		"inoculada",
		"inquietada",
		"inquirida",
		"insensibilizada",
		"insertada",
		"insinuada",
		"insistida",
		"inspeccionada",
		"inspirada",
		"instada",
		"instalada",
		"instaurada",
		"instigada",
		"instituida",
		"instruida",
		"instrumentada",
		"instrumentalizada",
		"insuflada",
		"insultada",
		"insumida",
		"integrada",
		"intelectualizada",
		"intensificada",
		"intentada",
		"interactuada",
		"intercalada",
		"intercambiada",
		"intercedida",
		"interceptada",
		"interesada",
		"interferida",
		"interiorizada",
		"intermediada",
		"internacionalizada",
		"internalizada",
		"interpelada",
		"interpolada",
		"interpretada",
		"interpuesta",
		"interrogada",
		"interrumpida",
		"intervenida",
		"intimada",
		"intimidada",
		"intitulada",
		"intoxicada",
		"intrigada",
		"introducida",
		"intuida",
		"inundada",
		"inutilizada",
		"invadida",
		"invalidada",
		"inventada",
		"inventariada",
		"invertida",
		"investida",
		"investigada",
		"invitada",
		"invocada",
		"involucionada",
		"inyectada",
		"ionizada",
		"ironizada",
		"irradiada",
		"irrespetada",
		"irrigada",
		"irritada",
		"irrogada",
		"irrumpida",
		"jactada",
		"jalada",
		"jaleada",
		"jalonada",
		"jaqueada",
		"jerarquizada",
		"jodida",
		"jorobada",
		"jubilada",
		"jugada",
		"juntada",
		"jurada",
		"juramentada",
		"justificada",
		"juzgada",
		"laborada",
		"labrada",
		"laburada",
		"lacada",
		"lacerada",
		"lactada",
		"ladeada",
		"ladrada",
		"lamentada",
		"lamida",
		"laminada",
		"languidecida",
		"lanzada",
		"lapidada",
		"laqueada",
		"largada",
		"lastimada",
		"lastrada",
		"latida",
		"laudada",
		"lavada",
		"legalizada",
		"legislada",
		"legitimada",
		"leída",
		"lesionada",
		"leudada",
		"levantada",
		"liada",
		"liberada",
		"liberalizada",
		"libertada",
		"librada",
		"licitada",
		"licuada",
		"liderizada",
		"lidiada",
		"ligada",
		"lijada",
		"limada",
		"limitada",
		"limpiada",
		"linchada",
		"liquidada",
		"litigada",
		"llagada",
		"llamada",
		"llegada",
		"llenada",
		"llevada",
		"llorada",
		"localizada",
		"lograda",
		"lubricada",
		"luchada",
		"lucida",
		"lucrada",
		"lustrada",
		"macerada",
		"machacada",
		"macheteada",
		"machucada",
		"madreada",
		"madrugada",
		"madurada",
		"magnetizada",
		"magnificada",
		"malacostumbrada",
		"malbaratada",
		"malcriada",
		"maleada",
		"malentendida",
		"malgastada",
		"malinterpretada",
		"malograda",
		"maltratada",
		"malversada",
		"mamada",
		"manchada",
		"mancillada",
		"mandada",
		"manejada",
		"mangada",
		"mangoneada",
		"manifestada",
		"maniobrada",
		"manipulada",
		"manoseada",
		"manteada",
		"mantenida",
		"manufacturada",
		"maquillada",
		"maquinada",
		"maravillada",
		"marcada",
		"marchitada",
		"mareada",
		"marginada",
		"maridada",
		"martillada",
		"martirizada",
		"masacrada",
		"masajeada",
		"mascada",
		"masificada",
		"masticada",
		"masturbada",
		"matada",
		"materializada",
		"matizada",
		"matriculada",
		"maximizada",
		"meada",
		"mecanografiada",
		"mechada",
		"mecida",
		"mediada",
		"mediatizada",
		"medicada",
		"medida",
		"meditada",
		"medrada",
		"mejorada",
		"mellada",
		"memorizada",
		"mencionada",
		"meneada",
		"menguada",
		"menoscabada",
		"menospreciada",
		"menstruada",
		"mensualizada",
		"mensurada",
		"mentada",
		"mentalizada",
		"mentida",
		"mercadeada",
		"mercantilizada",
		"merecida",
		"merendada",
		"mermada",
		"merodeada",
		"mesurada",
		"metamorfoseada",
		"metida",
		"mezclada",
		"migrada",
		"militada",
		"militarizada",
		"mimada",
		"mimetizada",
		"minada",
		"minimizada",
		"ministrada",
		"minusvalorada",
		"mirada",
		"mistificada",
		"mitificada",
		"mitigada",
		"modelada",
		"modernizada",
		"modificada",
		"modulada",
		"mofada",
		"mojada",
		"moldeada",
		"molestada",
		"molida",
		"monetizada",
		"monitorizada",
		"monopolizada",
		"montada",
		"morada",
		"moralizada",
		"mordida",
		"mordisqueada",
		"mortificada",
		"mosqueada",
		"mostrada",
		"motejada",
		"motivada",
		"movida",
		"movilizada",
		"mudada",
		"muestreada",
		"multada",
		"multiplicada",
		"munida",
		"murmurada",
		"mutada",
		"mutilada",
		"nacionalizada",
		"narcotizada",
		"narrada",
		"naufragada",
		"navegada",
		"necesitada",
		"negada",
		"negociada",
		"neutralizada",
		"ninguneada",
		"nivelada",
		"nombrada",
		"nominada",
		"noqueada",
		"normada",
		"normalizada",
		"notada",
		"notificada",
		"nutrida",
		"obcecada",
		"obedecida",
		"objetada",
		"objetivada",
		"obligada",
		"obliterada",
		"obnubilada",
		"obrada",
		"obsequiada",
		"observada",
		"obsesionada",
		"obstaculizada",
		"obstruida",
		"obtenida",
		"obturada",
		"obviada",
		"ocasionada",
		"ocluida",
		"ocultada",
		"ocupada",
		"odiada",
		"ofendida",
		"ofertada",
		"oficiada",
		"oficializada",
		"ofrecida",
		"ofrendada",
		"ofuscada",
		"oída",
		"ojeada",
		"olfateada",
		"olida",
		"olvidada",
		"omitida",
		"ondeada",
		"ondulada",
		"opacada",
		"operada",
		"opinada",
		"oprimida",
		"optada",
		"optimizada",
		"opuesta",
		"orada",
		"orbitada",
		"ordenada",
		"ordeñada",
		"organizada",
		"orientada",
		"originada",
		"orillada",
		"orinada",
		"ornada",
		"ornamentada",
		"orquestada",
		"osada",
		"oscilada",
		"oscurecida",
		"osificada",
		"ostentada",
		"otorgada",
		"ovacionada",
		"ovulada",
		"oxidada",
		"oxigenada",
		"pacificada",
		"pactada",
		"padecida",
		"paganizada",
		"paginada",
		"paladeada",
		"paliada",
		"palpada",
		"parada",
		"parafraseada",
		"paralizada",
		"parapetada",
		"parasitada",
		"parcelada",
		"parchada",
		"parcheada",
		"pareada",
		"parida",
		"parodiada",
		"parqueada",
		"participada",
		"particularizada",
		"partida",
		"pasada",
		"paseada",
		"pastoreada",
		"pataleada",
		"pateada",
		"patentada",
		"patentizada",
		"patinada",
		"patrullada",
		"pecada",
		"pedaleada",
		"pedida",
		"pegada",
		"peinada",
		"pellizcada",
		"penalizada",
		"penetrada",
		"pensada",
		"percatada",
		"percibida",
		"percutida",
		"perdida",
		"perdonada",
		"perdurada",
		"perecida",
		"peregrinada",
		"perfeccionada",
		"perfilada",
		"perforada",
		"perfumada",
		"pergeñada",
		"peritada",
		"perjudicada",
		"perjurada",
		"permeada",
		"permitida",
		"permutada",
		"pernoctada",
		"perpetrada",
		"perpetuada",
		"perseguida",
		"perseverada",
		"persistida",
		"personada",
		"personalizada",
		"personificada",
		"persuadida",
		"pertenecida",
		"pertrechada",
		"perturbada",
		"pervertida",
		"pervivida",
		"pescada",
		"petada",
		"peticionada",
		"picada",
		"picaneada",
		"picoteada",
		"pifiada",
		"pignorada",
		"pillada",
		"pilotada",
		"piloteada",
		"pincelada",
		"pinchada",
		"pintada",
		"pintarrajeada",
		"pinzada",
		"pirada",
		"pirateada",
		"pisada",
		"pisoteada",
		"pitada",
		"placida",
		"plagiada",
		"planchada",
		"planeada",
		"plantada",
		"planteada",
		"plasmada",
		"platicada",
		"plegada",
		"pluralizada",
		"podada",
		"poetizada",
		"polemizada",
		"politizada",
		"pololeada",
		"ponderada",
		"pontificada",
		"popularizada",
		"porfiada",
		"portada",
		"porteada",
		"posada",
		"posesionada",
		"posibilitada",
		"posicionada",
		"pospuesta",
		"posteada",
		"postergada",
		"postrada",
		"postulada",
		"potenciada",
		"practicada",
		"precarizada",
		"precedida",
		"preceptuada",
		"precintada",
		"precipitada",
		"precisada",
		"preconizada",
		"predicada",
		"predicha",
		"predispuesta",
		"predominada",
		"preferida",
		"prefigurada",
		"pregonada",
		"preguntada",
		"prejuzgada",
		"premiada",
		"prendada",
		"prendida",
		"preocupada",
		"preparada",
		"presagiada",
		"prescindida",
		"presenciada",
		"presentada",
		"presentida",
		"preservada",
		"presidida",
		"presionada",
		"prestada",
		"prestigiada",
		"presumida",
		"presurizada",
		"pretendida",
		"preterida",
		"prevalecida",
		"prevalida",
		"prevaricada",
		"prevenida",
		"prevista",
		"primada",
		"principiada",
		"pringada",
		"priorizada",
		"privatizada",
		"probada",
		"problematizada",
		"procedida",
		"procesada",
		"proclamada",
		"procreada",
		"procurada",
		"prodigada",
		"producida",
		"profanada",
		"proferida",
		"profesada",
		"profesionalizada",
		"profetizada",
		"profundizada",
		"programada",
		"progresada",
		"prohibida",
		"prohijada",
		"proletarizada",
		"proliferada",
		"prologada",
		"prolongada",
		"promediada",
		"prometida",
		"promocionada",
		"promovida",
		"promulgada",
		"pronosticada",
		"pronunciada",
		"propagada",
		"propalada",
		"propendida",
		"propiciada",
		"propinada",
		"proporcionada",
		"propuesta",
		"propugnada",
		"propulsada",
		"prorrateada",
		"prorrogada",
		"proseguida",
		"prosperada",
		"prostituida",
		"protegida",
		"protestada",
		"protocolizada",
		"provenida",
		"provocada",
		"proyectada",
		"psicoanalizada",
		"publicada",
		"publicitada",
		"puesta",
		"pugnada",
		"pujada",
		"pulida",
		"pulsada",
		"pululada",
		"pulverizada",
		"punada",
		"punteada",
		"puntuada",
		"puntualizada",
		"punzada",
		"purgada",
		"purificada",
		"puteada",
		"quebrada",
		"quebrantada",
		"quejada",
		"quemada",
		"querellada",
		"querida",
		"quintuplicada",
		"quitada",
		"racionada",
		"racionalizada",
		"radiada",
		"radicada",
		"radicalizada",
		"raída",
		"rajada",
		"ralentizada",
		"rapada",
		"rapeada",
		"raptada",
		"rascada",
		"rasgada",
		"rasguñada",
		"raspada",
		"rastreada",
		"rasurada",
		"ratificada",
		"rayada",
		"razonada",
		"reabierta",
		"reabsorbida",
		"reaccionada",
		"reactivada",
		"readaptada",
		"readmitida",
		"reafirmada",
		"reagrupada",
		"reajustada",
		"realimentada",
		"realizada",
		"realzada",
		"reanimada",
		"reanudada",
		"reaparecida",
		"rearmada",
		"reasumida",
		"reavivada",
		"rebajada",
		"rebalsada",
		"rebanada",
		"rebasada",
		"rebatida",
		"rebautizada",
		"rebelada",
		"reblandecida",
		"rebobinada",
		"rebosada",
		"rebotada",
		"rebozada",
		"rebuscada",
		"recabada",
		"recaída",
		"recalada",
		"recalcada",
		"recalentada",
		"recalificada",
		"recapacitada",
		"recapitulada",
		"recargada",
		"recatada",
		"recaudada",
		"receptada",
		"recetada",
		"rechazada",
		"recibida",
		"reciclada",
		"recitada",
		"reclamada",
		"reclinada",
		"reclutada",
		"recobrada",
		"recocida",
		"recogida",
		"recolectada",
		"recomendada",
		"recomenzada",
		"recompensada",
		"recompuesta",
		"reconcentrada",
		"reconciliada",
		"reconducida",
		"reconfortada",
		"reconocida",
		"reconquistada",
		"reconsiderada",
		"reconstituida",
		"reconstruida",
		"reconvenida",
		"reconvertida",
		"recopilada",
		"recordada",
		"recorrida",
		"recortada",
		"recreada",
		"recriminada",
		"recrudecida",
		"rectificada",
		"recubierta",
		"reculada",
		"recuperada",
		"recurrida",
		"recusada",
		"redactada",
		"redefinida",
		"redescubierta",
		"redimensionada",
		"redimida",
		"rediseñada",
		"redistribuida",
		"redituada",
		"redoblada",
		"redondeada",
		"reducida",
		"redundada",
		"reedificada",
		"reeditada",
		"reeducada",
		"reelaborada",
		"reembolsada",
		"reemplazada",
		"reencarnada",
		"reencauchada",
		"reencontrada",
		"reenganchada",
		"reenviada",
		"reescrita",
		"reestructurada",
		"reexaminada",
		"refaccionada",
		"referida",
		"refinada",
		"refinanciada",
		"reflejada",
		"reflexionada",
		"reflotada",
		"reforestada",
		"reformada",
		"reforzada",
		"refractada",
		"refrenada",
		"refrendada",
		"refrescada",
		"refrigerada",
		"refundida",
		"refutada",
		"regada",
		"regalada",
		"regañada",
		"regateada",
		"regenerada",
		"regentada",
		"regenteada",
		"regida",
		"regionalizada",
		"registrada",
		"reglada",
		"reglamentada",
		"regocijada",
		"regodeada",
		"regresada",
		"regulada",
		"regularizada",
		"regurgitada",
		"rehabilitada",
		"rehecha",
		"rehogada",
		"rehuida",
		"rehusada",
		"reída",
		"reinada",
		"reincidida",
		"reincorporada",
		"reingresada",
		"reiniciada",
		"reinsertada",
		"reinstalada",
		"reinstaurada",
		"reintegrada",
		"reinventada",
		"reinvertida",
		"reiterada",
		"reivindicada",
		"rejuvenecida",
		"relajada",
		"relamida",
		"relanzada",
		"relatada",
		"relativizada",
		"relegada",
		"releída",
		"relevada",
		"religada",
		"rellenada",
		"remachada",
		"remada",
		"remangada",
		"remarcada",
		"rematada",
		"remecida",
		"remediada",
		"rememorada",
		"remendada",
		"remitida",
		"remodelada",
		"remojada",
		"remolcada",
		"remontada",
		"removida",
		"remplazada",
		"renacida",
		"rendida",
		"renegada",
		"renegociada",
		"reñida",
		"renombrada",
		"renovada",
		"rentabilizada",
		"rentada",
		"renunciada",
		"reordenada",
		"reorganizada",
		"reorientada",
		"reparada",
		"repartida",
		"repasada",
		"repatriada",
		"repelida",
		"repensada",
		"repercutida",
		"repescada",
		"repetida",
		"repicada",
		"repintada",
		"replanteada",
		"replegada",
		"replicada",
		"repoblada",
		"reportada",
		"reporteada",
		"reposada",
		"repreguntada",
		"reprendida",
		"represada",
		"representada",
		"reprimida",
		"reprobada",
		"reprochada",
		"reproducida",
		"repudiada",
		"repuesta",
		"repugnada",
		"repuntada",
		"reputada",
		"requerida",
		"requisada",
		"resaltada",
		"resarcida",
		"resbalada",
		"rescatada",
		"rescindida",
		"resecada",
		"reseñada",
		"reservada",
		"reseteada",
		"resguardada",
		"residida",
		"resignada",
		"resistida",
		"resonada",
		"respaldada",
		"respetada",
		"respirada",
		"resplandecida",
		"respondida",
		"responsabilizada",
		"resquebrajada",
		"restablecida",
		"restada",
		"restaurada",
		"restituida",
		"restregada",
		"resucitada",
		"resuelta",
		"resumida",
		"resurgida",
		"retada",
		"retardada",
		"retenida",
		"retirada",
		"retocada",
		"retomada",
		"retorcida",
		"retornada",
		"retractada",
		"retraída",
		"retransmitida",
		"retrasada",
		"retratada",
		"retribuida",
		"retrotraída",
		"retumbada",
		"reunida",
		"reunificada",
		"reutilizada",
		"revalidada",
		"revalorizada",
		"revaluada",
		"revelada",
		"revendida",
		"reventada",
		"reverdecida",
		"reverenciada",
		"revertida",
		"revestida",
		"revirada",
		"revisada",
		"revitalizada",
		"revivida",
		"revocada",
		"revolcada",
		"revoloteada",
		"revolucionada",
		"revuelta",
		"ridiculizada",
		"rifada",
		"rimada",
		"rivalizada",
		"rizada",
		"robada",
		"robustecida",
		"rociada",
		"rodada",
		"rodeada",
		"rogada",
		"roída",
		"rondada",
		"rotada",
		"rota",
		"rotulada",
		"roturada",
		"rozada",
		"ruborizada",
		"rubricada",
		"rugida",
		"rumiada",
		"rumorada",
		"sabida",
		"saboreada",
		"saboteada",
		"sacada",
		"saciada",
		"sacralizada",
		"sacrificada",
		"sacudida",
		"saldada",
		"salpimentada",
		"salpullida",
		"saltada",
		"salteada",
		"saludada",
		"salvada",
		"salvaguardada",
		"sanada",
		"saneada",
		"sangrada",
		"santificada",
		"saqueada",
		"satanizada",
		"satirizada",
		"satisfecha",
		"sazonada",
		"secada",
		"seccionada",
		"secretada",
		"secuenciada",
		"secuestrada",
		"secundada",
		"sedimentada",
		"seducida",
		"segada",
		"segmentada",
		"segregada",
		"seguida",
		"seleccionada",
		"sembrada",
		"señalada",
		"sensibilizada",
		"sentada",
		"sentenciada",
		"sentida",
		"separada",
		"serenada",
		"serrada",
		"servida",
		"significada",
		"silenciada",
		"simbolizada",
		"simpatizada",
		"simplificada",
		"simulada",
		"sincerada",
		"sincronizada",
		"sindicada",
		"sindicalizada",
		"singularizada",
		"sintetizada",
		"sintonizada",
		"sistematizada",
		"situada",
		"sobada",
		"sobornada",
		"sobrada",
		"sobrecargada",
		"sobrecogida",
		"sobreentendida",
		"sobreestimada",
		"sobrellevada",
		"sobrentendida",
		"sobrepasada",
		"sobrepuesta",
		"sobresalida",
		"sobresaltada",
		"sobrestimada",
		"sobrevenida",
		"sobrevivida",
		"sobrevolada",
		"socavada",
		"socializada",
		"socorrida",
		"sodomizada",
		"sofocada",
		"sojuzgada",
		"solapada",
		"solicitada",
		"solidarizada",
		"solidificada",
		"soliviantada",
		"soltada",
		"solucionada",
		"solventada",
		"sombreada",
		"sometida",
		"sonada",
		"soñada",
		"sondeada",
		"sonreída",
		"sonrojada",
		"sopesada",
		"soplada",
		"soportada",
		"sorbida",
		"sorprendida",
		"sorteada",
		"sosegada",
		"soslayada",
		"sospechada",
		"sostenida",
		"suavizada",
		"subastada",
		"subcontratada",
		"subdividida",
		"subestimada",
		"subida",
		"sublevada",
		"sublimada",
		"subrayada",
		"subrogada",
		"subsanada",
		"subsidiada",
		"subsistida",
		"substraída",
		"subsumida",
		"subvertida",
		"subyugada",
		"succionada",
		"sucedida",
		"sucumbida",
		"sudada",
		"sufragada",
		"sufrida",
		"sugerida",
		"sugestionada",
		"suicidada",
		"sujetada",
		"sumada",
		"sumergida",
		"suministrada",
		"supeditada",
		"superada",
		"superpuesta",
		"supervisada",
		"suplantada",
		"suplicada",
		"suplida",
		"suprimida",
		"supuesta",
		"surcada",
		"surtida",
		"suscitada",
		"suspendida",
		"suspirada",
		"sustanciada",
		"sustantivada",
		"sustentada",
		"sustituida",
		"sustraída",
		"susurrada",
		"suturada",
		"tabulada",
		"tachada",
		"talada",
		"taladrada",
		"tallada",
		"tambaleada",
		"tamizada",
		"tañida",
		"tanteada",
		"tapada",
		"tapizada",
		"taponada",
		"tarareada",
		"tardada",
		"tasada",
		"tatuada",
		"tecleada",
		"tejida",
		"telefoneada",
		"televisada",
		"temida",
		"templada",
		"tendida",
		"tenida",
		"tensada",
		"tentada",
		"teorizada",
		"terciada",
		"tergiversada",
		"terminada",
		"territorializada",
		"testada",
		"testeada",
		"testificada",
		"testimoniada",
		"tildada",
		"timada",
		"timbrada",
		"tinturada",
		"tipeada",
		"tipificada",
		"tirada",
		"tiranizada",
		"tironeada",
		"tiroteada",
		"titubeada",
		"tiznada",
		"tocada",
		"tolerada",
		"tomada",
		"tonificada",
		"topada",
		"toqueteada",
		"torcida",
		"toreada",
		"tornada",
		"tornasolada",
		"torneada",
		"torpedeada",
		"torturada",
		"tosida",
		"tostada",
		"totalizada",
		"trabada",
		"trabajada",
		"traducida",
		"traficada",
		"tragada",
		"traicionada",
		"traída",
		"trajinada",
		"tramada",
		"tramitada",
		"trancada",
		"tranquilizada",
		"transcendida",
		"transcurrida",
		"transferida",
		"transfigurada",
		"transformada",
		"transfundida",
		"transgredida",
		"transigida",
		"transitada",
		"transliterada",
		"translucida",
		"transmitida",
		"transmutada",
		"transparentada",
		"transpirada",
		"transportada",
		"transpuesta",
		"trasegada",
		"trasgredida",
		"trasladada",
		"traslapada",
		"traslucida",
		"trasnochada",
		"traspapelada",
		"traspasada",
		"trasplantada",
		"traspuesta",
		"trasquilada",
		"trasteada",
		"trastocada",
		"trastornada",
		"trasvasada",
		"tratada",
		"trazada",
		"trenzada",
		"trepada",
		"tributada",
		"trincada",
		"triplicada",
		"triturada",
		"triunfada",
		"trivializada",
		"trocada",
		"troceada",
		"tronada",
		"tronchada",
		"truncada",
		"tumbada",
		"tuneada",
		"turbada",
		"turnada",
		"tutelada",
		"ufanada",
		"ultimada",
		"uncida",
		"ungida",
		"unida",
		"universalizada",
		"untada",
		"urbanizada",
		"urdida",
		"usada",
		"usufructuada",
		"usurpada",
		"utilizada",
		"vacada",
		"vaciada",
		"vacilada",
		"vacunada",
		"vagada",
		"validada",
		"valida",
		"valorada",
		"valorizada",
		"valuada",
		"vanagloriada",
		"vandalizada",
		"vaporizada",
		"variada",
		"vaticinada",
		"vedada",
		"vehiculada",
		"vejada",
		"velada",
		"vencida",
		"vendada",
		"vendida",
		"venerada",
		"vengada",
		"ventilada",
		"veraneada",
		"verbalizada",
		"verificada",
		"versada",
		"versionada",
		"vertebrada",
		"vertida",
		"vestida",
		"vetada",
		"viabilizada",
		"viajada",
		"vibrada",
		"victimada",
		"victimizada",
		"vigilada",
		"vigorizada",
		"vilipendiada",
		"vindicada",
		"violada",
		"violentada",
		"virada",
		"visada",
		"visibilizada",
		"visitada",
		"vislumbrada",
		"vista",
		"visualizada",
		"vitoreada",
		"vitrificada",
		"vituperada",
		"vivida",
		"vivificada",
		"vocalizada",
		"voceada",
		"vociferada",
		"volada",
		"volatilizada",
		"volcada",
		"volteada",
		"vomitada",
		"votada",
		"vuelta",
		"vulcanizada",
		"vulgarizada",
		"vulnerada",
		"yuxtapuesta",
		"zafada",
		"zambullida",
		"zampada",
		"zanjada",
		"zarandeada",
		"zarpada",
		"zozobrada",
		"zumbada",
		"zurcida",
		"zurrada",
		"abajados",
		"abalanzados",
		"abaleados",
		"abandonados",
		"abaratados",
		"abarcados",
		"abarrotados",
		"abastecidos",
		"abatidos",
		"abdicados",
		"abiertos",
		"abismados",
		"abjurados",
		"ablandados",
		"abocados",
		"abochornados",
		"abofeteados",
		"abolidos",
		"abollados",
		"abombados",
		"abominados",
		"abonados",
		"abordados",
		"aborrecidos",
		"aborregados",
		"abortados",
		"abotonados",
		"abrasados",
		"abrazados",
		"abrevados",
		"abreviados",
		"abrigados",
		"abrochados",
		"abrogados",
		"abroquelados",
		"abrumados",
		"absorbidos",
		"abstenidos",
		"abstraídos",
		"absueltos",
		"abucheados",
		"abultados",
		"abundados",
		"aburguesados",
		"aburridos",
		"abusados",
		"acabados",
		"acallados",
		"acalorados",
		"acaparados",
		"acariciados",
		"acarreados",
		"acatados",
		"acaudillados",
		"accedidos",
		"accionados",
		"acechados",
		"aceitados",
		"acelerados",
		"acentuados",
		"aceptados",
		"acerados",
		"acercados",
		"acertados",
		"achacados",
		"achantados",
		"achatados",
		"achicados",
		"acicalados",
		"acidificados",
		"aclarados",
		"aclimatados",
		"acobardados",
		"acodados",
		"acogidos",
		"acojonados",
		"acometidos",
		"acomodados",
		"acompañados",
		"acompasados",
		"acongojados",
		"aconsejados",
		"acontecidos",
		"acopiados",
		"acoplados",
		"acordados",
		"acordonados",
		"acorralados",
		"acortados",
		"acosados",
		"acostados",
		"acostumbrados",
		"acotados",
		"acrecentados",
		"acreditados",
		"acrisolados",
		"activados",
		"actuados",
		"acuchillados",
		"acuciados",
		"acudidos",
		"acuerpados",
		"acumulados",
		"acunados",
		"acuñados",
		"acurrucados",
		"acusados",
		"adaptados",
		"adecentados",
		"adelantados",
		"adelgazados",
		"adentrados",
		"adeudados",
		"adheridos",
		"adicionados",
		"adiestrados",
		"adivinados",
		"adjetivados",
		"adjudicados",
		"adjuntados",
		"administrados",
		"admirados",
		"admitidos",
		"adoctrinados",
		"adolecidos",
		"adoptados",
		"adorados",
		"adormecidos",
		"adornados",
		"adquiridos",
		"aducidos",
		"adueñados",
		"adulados",
		"adulterados",
		"advertidos",
		"afanados",
		"afeados",
		"afectados",
		"afeitados",
		"aferrados",
		"afianzados",
		"afinados",
		"afirmados",
		"afligidos",
		"aflorados",
		"afrentados",
		"afrontados",
		"agachados",
		"agarrados",
		"agarrotados",
		"agasajados",
		"agenciados",
		"agigantados",
		"agilizados",
		"agitados",
		"aglutinados",
		"agobiados",
		"agolpados",
		"agonizados",
		"agostados",
		"agotados",
		"agradados",
		"agradecidos",
		"agrandados",
		"agravados",
		"agraviados",
		"agredidos",
		"agregados",
		"agriados",
		"agrietados",
		"agrupados",
		"aguados",
		"aguantados",
		"aguardados",
		"agudizados",
		"aguijoneados",
		"agujereados",
		"aguzados",
		"ahogados",
		"ahondados",
		"ahorcados",
		"ahorrados",
		"ahuecados",
		"ahuyentados",
		"aireados",
		"aislados",
		"ajustados",
		"ajusticiados",
		"alabados",
		"alagados",
		"alambrados",
		"alardeados",
		"alargados",
		"alarmados",
		"albergados",
		"alborotados",
		"alcanzados",
		"aleccionados",
		"alegados",
		"alegrados",
		"alejados",
		"alentados",
		"alertados",
		"alfabetizados",
		"alfombrados",
		"aliados",
		"alienados",
		"aligerados",
		"alimentados",
		"aliñados",
		"alineados",
		"alisados",
		"alistados",
		"aliviados",
		"alivianados",
		"allanados",
		"almacenados",
		"almorzados",
		"alojados",
		"alquilados",
		"alterados",
		"alternados",
		"alucinados",
		"aludidos",
		"alumbrados",
		"alzados",
		"amados",
		"amaestrados",
		"amagados",
		"amainados",
		"amalgamados",
		"amamantados",
		"amansados",
		"amargados",
		"amarrados",
		"amasados",
		"ambicionados",
		"amedrentados",
		"amenazados",
		"amenizados",
		"ameritados",
		"ametrallados",
		"amilanados",
		"aminorados",
		"amnistiados",
		"amoldados",
		"amonestados",
		"amontonados",
		"amordazados",
		"amortajados",
		"amortiguados",
		"amortizados",
		"amotinados",
		"amparados",
		"ampayados",
		"ampliados",
		"amplificados",
		"amputados",
		"amueblados",
		"añadidos",
		"analizados",
		"anatematizados",
		"andados",
		"anegados",
		"anestesiados",
		"anexados",
		"anexionados",
		"anhelados",
		"anidados",
		"anillados",
		"animados",
		"aniquilados",
		"anisados",
		"añorados",
		"anotados",
		"anoticiados",
		"ansiados",
		"antecedidos",
		"antepuestos",
		"anticipados",
		"antojados",
		"anudados",
		"anulados",
		"anunciados",
		"apabullados",
		"apachurrados",
		"apaciguados",
		"apadrinados",
		"apagados",
		"apalancados",
		"apaleados",
		"apañados",
		"apantallados",
		"aparcados",
		"apareados",
		"aparecidos",
		"aparentados",
		"apartados",
		"apeados",
		"apedreados",
		"apelados",
		"apellidados",
		"apelmazados",
		"apercibidos",
		"apersonados",
		"apestados",
		"apetecidos",
		"apiadados",
		"apilados",
		"apiñados",
		"apisonados",
		"aplacados",
		"aplanados",
		"aplastados",
		"aplaudidos",
		"aplazados",
		"aplicados",
		"apoderados",
		"apoltronados",
		"aporreados",
		"aportados",
		"aposentados",
		"apostados",
		"apostatados",
		"apostillados",
		"apoyados",
		"apreciados",
		"aprehendidos",
		"apremiados",
		"aprendidos",
		"apresados",
		"apresurados",
		"apretados",
		"apretujados",
		"aprisionados",
		"aprobados",
		"aprovechados",
		"aprovisionados",
		"aproximados",
		"apuñalados",
		"apuñaleados",
		"apuntados",
		"apuntalados",
		"apuntillados",
		"apurados",
		"aquejados",
		"aquietados",
		"aquilatados",
		"arañados",
		"arbitrados",
		"archivados",
		"arengados",
		"argüidos",
		"argumentados",
		"armados",
		"armonizados",
		"aromatizados",
		"arqueados",
		"arrancados",
		"arrasados",
		"arrastrados",
		"arreados",
		"arrebatados",
		"arreciados",
		"arreglados",
		"arrellanados",
		"arremangados",
		"arremetidos",
		"arrendados",
		"arrepentidos",
		"arrestados",
		"arriados",
		"arribados",
		"arriesgados",
		"arrimados",
		"arrinconados",
		"arrodillados",
		"arrogados",
		"arrojados",
		"arrollados",
		"arropados",
		"arruinados",
		"arrullados",
		"articulados",
		"asados",
		"asaltados",
		"ascendidos",
		"aseados",
		"asechados",
		"asediados",
		"asegurados",
		"asemejados",
		"asentados",
		"asentidos",
		"aserrados",
		"asesinados",
		"asesorados",
		"asestados",
		"aseverados",
		"asfixiados",
		"asidos",
		"asignados",
		"asilados",
		"asimilados",
		"asistidos",
		"asolados",
		"asoleados",
		"asomados",
		"asombrados",
		"aspirados",
		"astillados",
		"asumidos",
		"asustados",
		"atacados",
		"atados",
		"atajados",
		"atarantados",
		"atascados",
		"atemorizados",
		"atemperados",
		"atenazados",
		"atendidos",
		"atenidos",
		"atentados",
		"atenuados",
		"aterrados",
		"aterrorizados",
		"atesorados",
		"atestiguados",
		"atiborrados",
		"atisbados",
		"atizados",
		"atomizados",
		"atontados",
		"atorados",
		"atormentados",
		"atornillados",
		"atosigados",
		"atracados",
		"atragantados",
		"atraídos",
		"atrancados",
		"atrapados",
		"atrasados",
		"atravesados",
		"atrevidos",
		"atribuidos",
		"atrincherados",
		"atrofiados",
		"atropellados",
		"aturdidos",
		"auditados",
		"augurados",
		"aumentados",
		"aunados",
		"aupados",
		"auscultados",
		"ausentados",
		"autenticados",
		"autentificados",
		"autodefinidos",
		"autoeditados",
		"automatizados",
		"autorizados",
		"autorregulados",
		"auxiliados",
		"avalados",
		"avanzados",
		"avasallados",
		"avenidos",
		"aventados",
		"aventajados",
		"aventurados",
		"averiados",
		"averiguados",
		"avezados",
		"avisados",
		"avispados",
		"avistados",
		"avivados",
		"avizorados",
		"avocados",
		"ayudados",
		"azotados",
		"azuzados",
		"babeados",
		"bailados",
		"bajados",
		"balaceados",
		"balanceados",
		"bañados",
		"banalizados",
		"bancados",
		"bandeados",
		"barajados",
		"barridos",
		"basados",
		"bastardeados",
		"basureados",
		"batallados",
		"bateados",
		"batidos",
		"bautizados",
		"beatificados",
		"bebidos",
		"beneficiados",
		"besados",
		"bifurcados",
		"birlados",
		"blandidos",
		"blanqueados",
		"blasfemados",
		"blindados",
		"bloqueados",
		"boicoteados",
		"bombardeados",
		"bombeados",
		"bonificados",
		"bordeados",
		"borrados",
		"borroneados",
		"bosquejados",
		"bostezados",
		"botados",
		"boxeados",
		"bregados",
		"brillados",
		"brincados",
		"brindados",
		"bromeados",
		"brotados",
		"bruñidos",
		"buceados",
		"burlados",
		"buscados",
		"cabeceados",
		"cabidos",
		"cabildeados",
		"cabreados",
		"cacareados",
		"cachados",
		"cacheados",
		"cacheteados",
		"caducados",
		"cagados",
		"calados",
		"calculados",
		"caldeados",
		"calefaccionados",
		"calendarizados",
		"calentados",
		"calibrados",
		"calificados",
		"caligrafiados",
		"callados",
		"calmados",
		"calumniados",
		"calzados",
		"cambiados",
		"caminados",
		"camuflados",
		"canalizados",
		"cancelados",
		"canjeados",
		"cansados",
		"cantados",
		"capados",
		"capeados",
		"capitalizados",
		"capitulados",
		"captados",
		"capturados",
		"caracterizados",
		"carburados",
		"carcomidos",
		"cardados",
		"careados",
		"carecidos",
		"cargados",
		"caricaturizados",
		"cartografiados",
		"cascados",
		"castigados",
		"castrados",
		"catados",
		"catalizados",
		"catalogados",
		"catapultados",
		"cateados",
		"categorizados",
		"causados",
		"cauterizados",
		"cautivados",
		"cavados",
		"cavilados",
		"cazados",
		"cebados",
		"cedidos",
		"cegados",
		"cejados",
		"celebrados",
		"cenados",
		"ceñidos",
		"censurados",
		"centrifugados",
		"centuplicados",
		"cepillados",
		"cercados",
		"cercenados",
		"cerciorados",
		"cernidos",
		"cerrados",
		"cesados",
		"chafados",
		"chamuscados",
		"chantajeados",
		"chapados",
		"charlados",
		"chateados",
		"chequeados",
		"chiflados",
		"chillados",
		"chingados",
		"chirriados",
		"chivados",
		"chocados",
		"chorreados",
		"choteados",
		"chupados",
		"chutados",
		"cicatrizados",
		"cifrados",
		"cimentados",
		"cincelados",
		"circulados",
		"circuncidados",
		"circundados",
		"citados",
		"clamados",
		"clarificados",
		"clasificados",
		"claudicados",
		"clausurados",
		"clavados",
		"clicados",
		"clonados",
		"coaccionados",
		"coadyuvados",
		"coagulados",
		"coaligados",
		"coartados",
		"cobijados",
		"cobrados",
		"cocidos",
		"cocinados",
		"codeados",
		"codiciados",
		"codificados",
		"codirigidos",
		"coexistidos",
		"cofinanciados",
		"cogidos",
		"cohabitados",
		"cohibidos",
		"coincididos",
		"colaborados",
		"colacionados",
		"colados",
		"colapsados",
		"coleccionados",
		"colectados",
		"colectivizados",
		"colgados",
		"colisionados",
		"colmados",
		"colocados",
		"colonizados",
		"coloreados",
		"columpiados",
		"combatidos",
		"combinados",
		"comentados",
		"comenzados",
		"comerciados",
		"comercializados",
		"cometidos",
		"comidos",
		"comisionados",
		"compactados",
		"compadecidos",
		"compaginados",
		"comparados",
		"comparecidos",
		"compartidos",
		"compatibilizados",
		"compelidos",
		"compendiados",
		"compenetrados",
		"compensados",
		"compilados",
		"complacidos",
		"complementados",
		"completados",
		"complotados",
		"comportados",
		"comprados",
		"comprendidos",
		"comprimidos",
		"comprobados",
		"comprometidos",
		"compuestos",
		"compulsados",
		"computados",
		"comulgados",
		"comunicados",
		"concatenados",
		"concebidos",
		"concedidos",
		"concelebrados",
		"concentrados",
		"conceptuados",
		"conceptualizados",
		"concertados",
		"concienciados",
		"concientizados",
		"conciliados",
		"concitados",
		"concluidos",
		"concordados",
		"concretados",
		"concretizados",
		"conculcados",
		"concursados",
		"condenados",
		"condensados",
		"condicionados",
		"condimentados",
		"condolidos",
		"condonados",
		"conducidos",
		"conectados",
		"conexionados",
		"confabulados",
		"confeccionados",
		"conferidos",
		"confesados",
		"confiados",
		"configurados",
		"confirmados",
		"confiscados",
		"confluidos",
		"conformados",
		"confortados",
		"confrontados",
		"confundidos",
		"congeniados",
		"congestionados",
		"congratulados",
		"congregados",
		"conjeturados",
		"conjugados",
		"conjuntados",
		"conjurados",
		"conllevados",
		"conmemorados",
		"conminados",
		"conmocionados",
		"conmovidos",
		"conmutados",
		"connotados",
		"conquistados",
		"consagrados",
		"conseguidos",
		"consensuados",
		"consentidos",
		"conservados",
		"considerados",
		"consignados",
		"consistidos",
		"consolados",
		"consolidados",
		"conspirados",
		"constados",
		"constatados",
		"constelados",
		"constitucionalizados",
		"constituidos",
		"constreñidos",
		"construidos",
		"consultados",
		"consumados",
		"consumidos",
		"contabilizados",
		"contactados",
		"contados",
		"contagiados",
		"contemplados",
		"contendidos",
		"contenidos",
		"contentados",
		"contestados",
		"contextualizados",
		"continuados",
		"contorneados",
		"contraatacados",
		"contrabandeados",
		"contradichos",
		"contrahechos",
		"contraídos",
		"contrapesados",
		"contrapuestos",
		"contrariados",
		"contrarrestados",
		"contrastados",
		"contratados",
		"contravenidos",
		"contribuidos",
		"contristados",
		"controlados",
		"convalidados",
		"convencidos",
		"convenidos",
		"convergidos",
		"conversados",
		"convertidos",
		"convidados",
		"convividos",
		"convocados",
		"convulsionados",
		"cooperados",
		"cooptados",
		"coordinados",
		"copados",
		"copiados",
		"coproducidos",
		"copulados",
		"coqueteados",
		"corchados",
		"coreados",
		"coreografiados",
		"corneados",
		"coronados",
		"corporizados",
		"corregidos",
		"correlacionados",
		"correspondidos",
		"correteados",
		"corridos",
		"corroborados",
		"corroídos",
		"corrompidos",
		"cortados",
		"cortejados",
		"cosechados",
		"cosidos",
		"cosificados",
		"costados",
		"costeados",
		"cotejados",
		"cotizados",
		"creados",
		"creídos",
		"criados",
		"cribados",
		"criminalizados",
		"crispados",
		"cristalizados",
		"cristianizados",
		"criticados",
		"cronometrados",
		"crucificados",
		"crujidos",
		"cruzados",
		"cuadriplicados",
		"cuadruplicados",
		"cuajados",
		"cuantificados",
		"cuarteados",
		"cubiertos",
		"cuestionados",
		"cuidados",
		"culeados",
		"culminados",
		"culpabilizados",
		"culpados",
		"cultivados",
		"culturizados",
		"cumplidos",
		"cumplimentados",
		"cundidos",
		"curados",
		"curioseados",
		"currados",
		"cursados",
		"curvados",
		"custodiados",
		"dados",
		"dañados",
		"danzados",
		"datados",
		"dateados",
		"debatidos",
		"debidos",
		"debilitados",
		"debitados",
		"debutados",
		"decaídos",
		"decantados",
		"decapitados",
		"decepcionados",
		"decididos",
		"declamados",
		"declarados",
		"declinados",
		"decodificados",
		"decolorados",
		"decomisados",
		"decrecidos",
		"decretados",
		"dedicados",
		"deducidos",
		"defecados",
		"defendidos",
		"defenestrados",
		"deferidos",
		"definidos",
		"deformados",
		"defraudados",
		"degenerados",
		"deglutidos",
		"degollados",
		"degradados",
		"degustados",
		"deificados",
		"dejados",
		"delatados",
		"delegados",
		"deleitados",
		"deletreados",
		"deliberados",
		"delimitados",
		"delineados",
		"delinquidos",
		"demandados",
		"demarcados",
		"demediados",
		"demeritados",
		"democratizados",
		"demolidos",
		"demonizados",
		"demorados",
		"demostrados",
		"demudados",
		"denegados",
		"denigrados",
		"denominados",
		"denostados",
		"denotados",
		"denunciados",
		"deparados",
		"departidos",
		"dependidos",
		"depilados",
		"deplorados",
		"deportados",
		"depositados",
		"depreciados",
		"depredados",
		"deprimidos",
		"depuestos",
		"depurados",
		"derechizados",
		"derivados",
		"derogados",
		"derramados",
		"derretidos",
		"derribados",
		"derrocados",
		"derrochados",
		"derrotados",
		"derruidos",
		"derrumbados",
		"desabrochados",
		"desacatados",
		"desacelerados",
		"desacomodados",
		"desaconsejados",
		"desacoplados",
		"desacralizados",
		"desacreditados",
		"desactivados",
		"desafiados",
		"desafinados",
		"desaguados",
		"desahogados",
		"desairados",
		"desajustados",
		"desalentados",
		"desalineados",
		"desalojados",
		"desandados",
		"desangrados",
		"desanimados",
		"desaparecidos",
		"desapegados",
		"desaprendidos",
		"desaprobados",
		"desaprovechados",
		"desarmados",
		"desarraigados",
		"desarreglados",
		"desarrollados",
		"desarticulados",
		"desaseados",
		"desasidos",
		"desasosegados",
		"desatados",
		"desatendidos",
		"desautorizados",
		"desayunados",
		"desbancados",
		"desbandados",
		"desbaratados",
		"desbarrancados",
		"desbastados",
		"desbloqueados",
		"desbocados",
		"desbordados",
		"desbrozados",
		"descabalgados",
		"descabezados",
		"descaderados",
		"descalabrados",
		"descalificados",
		"descansados",
		"descargados",
		"descarriados",
		"descarrilados",
		"descartados",
		"descascarados",
		"descascarillados",
		"descendidos",
		"descentrados",
		"descifrados",
		"descocidos",
		"descodificados",
		"descojonados",
		"descolgados",
		"descolocados",
		"descolonizados",
		"descompensados",
		"descomprimidos",
		"descompuestos",
		"desconectados",
		"desconfiados",
		"descongelados",
		"desconocidos",
		"descontados",
		"descontaminados",
		"descontextualizados",
		"descontinuados",
		"desconvocados",
		"descorazonados",
		"descorchados",
		"descorridos",
		"descosidos",
		"descoyuntados",
		"descreídos",
		"descristianizados",
		"descuadrados",
		"descuartizados",
		"descubiertos",
		"descuidados",
		"desdeñados",
		"desdibujados",
		"desdichos",
		"desdoblados",
		"deseados",
		"desecados",
		"desechados",
		"desembarazados",
		"desembarcados",
		"desembocados",
		"desembolsados",
		"desempacados",
		"desempañados",
		"desempaquetados",
		"desempeñados",
		"desempolvados",
		"desenamorados",
		"desencadenados",
		"desencajados",
		"desencarnados",
		"desenchufados",
		"desenfocados",
		"desenfundados",
		"desenganchados",
		"desengrasados",
		"desenmascarados",
		"desenredados",
		"desenrollados",
		"desentendidos",
		"desenterrados",
		"desentonados",
		"desentrañados",
		"desenvainados",
		"desenvueltos",
		"desequilibrados",
		"desertados",
		"desestabilizados",
		"desestimados",
		"desfalcados",
		"desfallecidos",
		"desfigurados",
		"desfondados",
		"desgajados",
		"desgañitados",
		"desgarrados",
		"desgastados",
		"desglosados",
		"desgobernados",
		"desgranados",
		"desguazados",
		"deshechos",
		"desheredados",
		"deshidratados",
		"deshilachados",
		"deshojados",
		"deshonrados",
		"deshuesados",
		"deshumanizados",
		"designados",
		"desilusionados",
		"desincentivados",
		"desinfectados",
		"desinflados",
		"desinflamados",
		"desinformados",
		"desinhibidos",
		"desinstalados",
		"desintegrados",
		"desintoxicados",
		"desistidos",
		"desjarretados",
		"deslegitimados",
		"desleídos",
		"desligados",
		"deslindados",
		"deslizados",
		"deslucidos",
		"deslumbrados",
		"desmadrados",
		"desmalezados",
		"desmantelados",
		"desmaquillados",
		"desmarcados",
		"desmayados",
		"desmejorados",
		"desmembrados",
		"desmentidos",
		"desmenuzados",
		"desmerecidos",
		"desmigados",
		"desmitificados",
		"desmoldados",
		"desmontados",
		"desmoralizados",
		"desmoronados",
		"desmotivados",
		"desmovilizados",
		"desnaturalizados",
		"desnivelados",
		"desnucados",
		"desnudados",
		"desobedecidos",
		"desobligados",
		"desoídos",
		"desollados",
		"desorganizados",
		"desorientados",
		"despachados",
		"desparasitados",
		"desparecidos",
		"desparramados",
		"despedazados",
		"despedidos",
		"despegados",
		"despeinados",
		"despejados",
		"despellejados",
		"despeñados",
		"despenalizados",
		"desperdiciados",
		"despersonalizados",
		"despertados",
		"despilfarrados",
		"despintados",
		"despiojados",
		"despistados",
		"desplazados",
		"desplegados",
		"desplomados",
		"desplumados",
		"despojados",
		"despolitizados",
		"desposados",
		"desposeídos",
		"despotricados",
		"despreciados",
		"desprendidos",
		"despreocupados",
		"desprestigiados",
		"desprogramados",
		"despulpados",
		"despuntados",
		"desquiciados",
		"desquitados",
		"destacados",
		"destapados",
		"desteñidos",
		"desterrados",
		"destetados",
		"destilados",
		"destituidos",
		"destrabados",
		"destripados",
		"destronados",
		"destrozados",
		"destruidos",
		"desunidos",
		"desvalijados",
		"desvalorizados",
		"desvanecidos",
		"desvelados",
		"desvestidos",
		"desviados",
		"desvinculados",
		"desvirtuados",
		"desvividos",
		"detectados",
		"detenidos",
		"detentados",
		"deteriorados",
		"determinados",
		"detestados",
		"detonados",
		"devaluados",
		"devanados",
		"devastados",
		"develados",
		"devengados",
		"devenidos",
		"devorados",
		"devueltos",
		"diagnosticados",
		"diagramados",
		"dializados",
		"dialogados",
		"dibujados",
		"dichos",
		"dictados",
		"dictaminados",
		"diezmados",
		"difamados",
		"diferenciados",
		"diferidos",
		"dificultados",
		"difuminados",
		"difundidos",
		"digeridos",
		"digitados",
		"dignados",
		"dignificados",
		"dilapidados",
		"dilatados",
		"diligenciados",
		"dilucidados",
		"diluidos",
		"dimensionados",
		"dimitidos",
		"dinamitados",
		"dinamizados",
		"dirimidos",
		"discernidos",
		"disciplinados",
		"discontinuados",
		"discrepados",
		"discriminados",
		"disculpados",
		"discurridos",
		"discutidos",
		"diseccionados",
		"diseminados",
		"diseñados",
		"disentidos",
		"disertados",
		"disfrazados",
		"disfrutados",
		"disgregados",
		"disgustados",
		"disimulados",
		"disipados",
		"dislocados",
		"disminuidos",
		"disociados",
		"dispensados",
		"dispersados",
		"dispuestos",
		"disputados",
		"distados",
		"distanciados",
		"distendidos",
		"distinguidos",
		"distorsionados",
		"distraídos",
		"distribuidos",
		"disuadidos",
		"disueltos",
		"divagados",
		"diversificados",
		"divertidos",
		"divididos",
		"divinizados",
		"divisados",
		"divorciados",
		"divulgados",
		"doblados",
		"doblegados",
		"doctorados",
		"documentados",
		"dogmatizados",
		"dolidos",
		"domados",
		"domesticados",
		"dominados",
		"donados",
		"dopados",
		"dormidos",
		"dosificados",
		"dotados",
		"dragados",
		"dramatizados",
		"drenados",
		"drogados",
		"duchados",
		"dudados",
		"dulcificados",
		"duplicados",
		"durados",
		"echados",
		"eclipsados",
		"eclosionados",
		"economizados",
		"ecualizados",
		"edificados",
		"editados",
		"educados",
		"efectuados",
		"ejecutados",
		"ejemplificados",
		"ejercidos",
		"ejercitados",
		"elaborados",
		"electrizados",
		"electrocutados",
		"elevados",
		"elididos",
		"eliminados",
		"elogiados",
		"elucubrados",
		"eludidos",
		"emanados",
		"emancipados",
		"embadurnados",
		"embalados",
		"embalsamados",
		"embanderados",
		"embarcados",
		"embargados",
		"embarrados",
		"embarrancados",
		"embaucados",
		"embebidos",
		"embelesados",
		"embellecidos",
		"embestidos",
		"embolados",
		"embolsados",
		"emborrachados",
		"emborronados",
		"emboscados",
		"embotados",
		"embriagados",
		"embrollados",
		"embrutecidos",
		"embuchados",
		"emergidos",
		"emigrados",
		"emitidos",
		"emocionados",
		"empacados",
		"empachados",
		"empadronados",
		"empalados",
		"empalmados",
		"empanados",
		"empañados",
		"empantanados",
		"empapelados",
		"empaquetados",
		"emparejados",
		"empastados",
		"empatados",
		"empecinados",
		"empeñados",
		"empeorados",
		"empequeñecidos",
		"emperrados",
		"empezados",
		"empinados",
		"emplazados",
		"empleados",
		"empobrecidos",
		"empoderados",
		"empollados",
		"empolvados",
		"emponzoñados",
		"emprendidos",
		"empujados",
		"empuñados",
		"emputados",
		"emulados",
		"emulsionados",
		"enajenados",
		"enaltecidos",
		"enamorados",
		"enarbolados",
		"enardecidos",
		"encabezados",
		"encabritados",
		"encabronados",
		"encadenados",
		"encajados",
		"encajonados",
		"encallados",
		"encamados",
		"encaminados",
		"encandilados",
		"encanecidos",
		"encañonados",
		"encantados",
		"encaprichados",
		"encapsulados",
		"encarados",
		"encaramados",
		"encarecidos",
		"encargados",
		"encariñados",
		"encarnados",
		"encarrilados",
		"encartados",
		"encasillados",
		"encasquetados",
		"encasquillados",
		"encastrados",
		"encausados",
		"encauzados",
		"enceguecidos",
		"encendidos",
		"encerados",
		"encerrados",
		"encharcados",
		"enchufados",
		"encimados",
		"encogidos",
		"encolados",
		"encolerizados",
		"encolumnados",
		"encomendados",
		"enconados",
		"encontrados",
		"encordados",
		"encrespados",
		"encuadrados",
		"encubiertos",
		"encuerados",
		"encumbrados",
		"enderezados",
		"endeudados",
		"endilgados",
		"endiosados",
		"endosados",
		"endulzados",
		"endurecidos",
		"enemistados",
		"energizados",
		"enervados",
		"enfadados",
		"enfangados",
		"enfatizados",
		"enfermados",
		"enfiestados",
		"enfilados",
		"enflaquecidos",
		"enfocados",
		"enfrascados",
		"enfrentados",
		"enfriados",
		"enfurecidos",
		"engalanados",
		"engañados",
		"enganchados",
		"engarzados",
		"engatusados",
		"engendrados",
		"englobados",
		"engolosinados",
		"engordados",
		"engranados",
		"engrandecidos",
		"engrasados",
		"engreídos",
		"engrosados",
		"engullidos",
		"enharinados",
		"enhebrados",
		"enjuagados",
		"enjugados",
		"enjuiciados",
		"enlazados",
		"enlistados",
		"enlodados",
		"enloquecidos",
		"enlozados",
		"enlutados",
		"enmarañados",
		"enmascarados",
		"enmendados",
		"enmohecidos",
		"enmudecidos",
		"ennegrecidos",
		"ennoblecidos",
		"enorgullecidos",
		"enrarecidos",
		"enredados",
		"enripiados",
		"enriquecidos",
		"enrocados",
		"enrojecidos",
		"enrolados",
		"enrollados",
		"enroscados",
		"enrumbados",
		"ensalzados",
		"ensamblados",
		"ensañados",
		"ensanchados",
		"ensartados",
		"ensayados",
		"ensebados",
		"enseñados",
		"enseñoreados",
		"ensillados",
		"ensoberbecidos",
		"ensogados",
		"ensombrecidos",
		"ensoñados",
		"ensordecidos",
		"ensuciados",
		"entablados",
		"entallados",
		"entendidos",
		"enterados",
		"enternecidos",
		"enterrados",
		"entibiados",
		"entintados",
		"entonados",
		"entorpecidos",
		"entrados",
		"entrampados",
		"entrañados",
		"entreabiertos",
		"entrecomillados",
		"entrecruzados",
		"entregados",
		"entrelazados",
		"entremetidos",
		"entremezclados",
		"entrenados",
		"entresacados",
		"entretejidos",
		"entretenidos",
		"entreverados",
		"entrevistados",
		"entristecidos",
		"entrometidos",
		"entronados",
		"entroncados",
		"entronizados",
		"entumecidos",
		"enturbiados",
		"entusiasmados",
		"enumerados",
		"enunciados",
		"envainados",
		"envalentonados",
		"envanecidos",
		"envasados",
		"envejecidos",
		"envenenados",
		"envestidos",
		"enviados",
		"enviciados",
		"envidiados",
		"envilecidos",
		"enviudados",
		"envueltos",
		"enzarzados",
		"equilibrados",
		"equiparados",
		"equivocados",
		"erigidos",
		"erizados",
		"erogados",
		"erosionados",
		"erotizados",
		"erradicados",
		"errados",
		"esbozados",
		"escabullidos",
		"escalados",
		"escaldados",
		"escalfados",
		"escamados",
		"escamoteados",
		"escampados",
		"escandalizados",
		"escaneados",
		"escapados",
		"escaqueados",
		"escarbados",
		"escarchados",
		"escarmentados",
		"escarnecidos",
		"escaseados",
		"escatimados",
		"escenificados",
		"escindidos",
		"esclarecidos",
		"esclavizados",
		"escocidos",
		"escogidos",
		"escolarizados",
		"escoltados",
		"escondidos",
		"escorados",
		"escrachados",
		"escritos",
		"escrutados",
		"escuchados",
		"escudados",
		"escudriñados",
		"esculpidos",
		"escupidos",
		"escurridos",
		"esforzados",
		"esfumados",
		"esgrimidos",
		"esmerados",
		"esmerilados",
		"espabilados",
		"espaciados",
		"españolizados",
		"espantados",
		"esparcidos",
		"especificados",
		"especulados",
		"esperados",
		"espesados",
		"espetados",
		"espiados",
		"espigados",
		"espinados",
		"espirados",
		"espiritualizados",
		"espoleados",
		"espolvoreados",
		"esponjados",
		"esponsorizados",
		"esposados",
		"esquematizados",
		"esquiados",
		"esquilados",
		"esquilmados",
		"esquivados",
		"estabilizados",
		"establecidos",
		"estacionados",
		"estafados",
		"estallados",
		"estampados",
		"estancados",
		"estaqueados",
		"estatizados",
		"estatuidos",
		"esterificados",
		"esterilizados",
		"estigmatizados",
		"estilizados",
		"estimados",
		"estimulados",
		"estipulados",
		"estirados",
		"estorbados",
		"estornudados",
		"estragados",
		"estrangulados",
		"estrechados",
		"estrellados",
		"estremecidos",
		"estrenados",
		"estresados",
		"estriados",
		"estropeados",
		"estructurados",
		"estrujados",
		"estudiados",
		"eternizados",
		"etiquetados",
		"evacuados",
		"evadidos",
		"evaluados",
		"evangelizados",
		"evaporados",
		"evidenciados",
		"eviscerados",
		"evitados",
		"evocados",
		"evolucionados",
		"exacerbados",
		"exagerados",
		"exaltados",
		"examinados",
		"exasperados",
		"excarcelados",
		"excavados",
		"excedidos",
		"exceptuados",
		"excitados",
		"exclamados",
		"excluidos",
		"excretados",
		"exculpados",
		"excusados",
		"execrados",
		"exhalados",
		"exhibidos",
		"exhortados",
		"exhumados",
		"exigidos",
		"exilados",
		"eximidos",
		"existidos",
		"exonerados",
		"exorcizados",
		"expandidos",
		"expedidos",
		"expedientados",
		"expelidos",
		"expendidos",
		"experimentados",
		"expiados",
		"expirados",
		"explayados",
		"explicados",
		"explicitados",
		"explorados",
		"explosionados",
		"explotados",
		"expoliados",
		"exportados",
		"expresados",
		"exprimidos",
		"expropiados",
		"expuestos",
		"expulsados",
		"expurgados",
		"extendidos",
		"exteriorizados",
		"exterminados",
		"externados",
		"externalizados",
		"extinguidos",
		"extirpados",
		"extorsionados",
		"extractados",
		"extraditados",
		"extraídos",
		"extralimitados",
		"extrañados",
		"extrapolados",
		"extraviados",
		"extremados",
		"extruidos",
		"exudados",
		"eyaculados",
		"eyectados",
		"fabricados",
		"fabulados",
		"facilitados",
		"facturados",
		"facultados",
		"fagocitados",
		"fajados",
		"fallados",
		"fallecidos",
		"falsados",
		"falseados",
		"falsificados",
		"familiarizados",
		"fantaseados",
		"fascinados",
		"fastidiados",
		"fatigados",
		"favorecidos",
		"fecundados",
		"felicitados",
		"feminizados",
		"fenecidos",
		"fermentados",
		"fertilizados",
		"festejados",
		"fiados",
		"fichados",
		"fidelizados",
		"figurados",
		"fijados",
		"filmados",
		"filosofados",
		"filtrados",
		"finalizados",
		"financiados",
		"fincados",
		"fingidos",
		"finiquitados",
		"firmados",
		"fiscalizados",
		"fisurados",
		"flagelados",
		"flameados",
		"flanqueados",
		"flaqueados",
		"fletados",
		"flexibilizados",
		"flexionados",
		"flipados",
		"floreados",
		"florecidos",
		"flotados",
		"fluctuados",
		"focalizados",
		"fogueados",
		"foliados",
		"follados",
		"fomentados",
		"fondeados",
		"forcejeados",
		"forestados",
		"forjados",
		"formados",
		"formalizados",
		"formateados",
		"formulados",
		"fornicados",
		"forrados",
		"fortalecidos",
		"forzados",
		"fotocopiados",
		"fotografiados",
		"fracasados",
		"fraccionados",
		"fracturados",
		"fragmentados",
		"fraguados",
		"franqueados",
		"frecuentados",
		"fregados",
		"frenados",
		"fresados",
		"friccionados",
		"frotados",
		"fructificados",
		"fruncidos",
		"fugados",
		"fulminados",
		"fumados",
		"fumigados",
		"funcionados",
		"fundados",
		"fundamentados",
		"fundidos",
		"fungidos",
		"fusilados",
		"fusionados",
		"fustigados",
		"gafados",
		"ganados",
		"gangrenados",
		"garabateados",
		"garantidos",
		"garantizados",
		"garridos",
		"gaseados",
		"gastados",
		"gemidos",
		"generados",
		"generalizados",
		"gerenciados",
		"germinados",
		"gestados",
		"gestionados",
		"girados",
		"glorificados",
		"glosados",
		"gobernados",
		"goleados",
		"golpeados",
		"gozados",
		"grabados",
		"graduados",
		"graficados",
		"granjeados",
		"grapados",
		"gratificados",
		"gravados",
		"gravitados",
		"gritados",
		"gruñidos",
		"guardados",
		"guarecidos",
		"guarnecidos",
		"guerreados",
		"guiados",
		"guillotinados",
		"guiñados",
		"guindados",
		"guisados",
		"gustados",
		"habilitados",
		"habitados",
		"habituados",
		"hablados",
		"halados",
		"halagados",
		"hallados",
		"hartados",
		"hechizados",
		"hechos",
		"helenizados",
		"henchidos",
		"hendidos",
		"heredados",
		"heridos",
		"hermanados",
		"herrados",
		"hervidos",
		"hibernados",
		"hibridados",
		"hidratados",
		"higienizados",
		"hilados",
		"hilvanados",
		"hincados",
		"hinchados",
		"hipnotizados",
		"hipotecados",
		"historiados",
		"hojeados",
		"holgados",
		"hollados",
		"homenajeados",
		"homogeneizados",
		"homologados",
		"honrados",
		"horadados",
		"horneados",
		"horrorizados",
		"hospedados",
		"hostigados",
		"hostilizados",
		"huidos",
		"humanados",
		"humanizados",
		"humectados",
		"humedecidos",
		"humillados",
		"hundidos",
		"hurgados",
		"hurtados",
		"ideados",
		"idealizados",
		"identificados",
		"ideologizados",
		"idiotizados",
		"idolatrados",
		"ignorados",
		"igualados",
		"ilegalizados",
		"iluminados",
		"ilusionados",
		"ilustrados",
		"imaginados",
		"imbricados",
		"imitados",
		"impactados",
		"impartidos",
		"impedidos",
		"impelidos",
		"imperados",
		"impermeabilizados",
		"implantados",
		"implementados",
		"implicados",
		"implorados",
		"importados",
		"importunados",
		"imposibilitados",
		"impresionados",
		"improvisados",
		"impuestos",
		"impugnados",
		"impulsados",
		"imputados",
		"inaugurados",
		"incautados",
		"incendiados",
		"incentivados",
		"incinerados",
		"incitados",
		"inclinados",
		"incluidos",
		"incoados",
		"incomodados",
		"incorporados",
		"incrementados",
		"increpados",
		"incriminados",
		"incubados",
		"inculcados",
		"inculpados",
		"incumplidos",
		"incurridos",
		"incursionados",
		"indagados",
		"indemnizados",
		"independizados",
		"indexados",
		"indicados",
		"indigestados",
		"indignados",
		"indispuestos",
		"individuados",
		"inducidos",
		"indultados",
		"inervados",
		"infamados",
		"infartados",
		"infectados",
		"inferidos",
		"inficionados",
		"infiltrados",
		"inflados",
		"inflamados",
		"infligidos",
		"influenciados",
		"influidos",
		"informados",
		"infravalorados",
		"infringidos",
		"infundidos",
		"ingeniados",
		"ingeridos",
		"ingresados",
		"inhabilitados",
		"inhalados",
		"inhibidos",
		"inhumados",
		"iniciados",
		"inicializados",
		"injertados",
		"injuriados",
		"inmigrados",
		"inmiscuidos",
		"inmolados",
		"inmortalizados",
		"inmovilizados",
		"inmunizados",
		"innovados",
		"inoculados",
		"inquietados",
		"inquiridos",
		"insensibilizados",
		"insertados",
		"insinuados",
		"insistidos",
		"inspeccionados",
		"inspirados",
		"instados",
		"instalados",
		"instaurados",
		"instigados",
		"instituidos",
		"instruidos",
		"instrumentados",
		"instrumentalizados",
		"insuflados",
		"insultados",
		"insumidos",
		"integrados",
		"intelectualizados",
		"intensificados",
		"intentados",
		"interactuados",
		"intercalados",
		"intercambiados",
		"intercedidos",
		"interceptados",
		"interesados",
		"interferidos",
		"interiorizados",
		"intermediados",
		"internacionalizados",
		"internalizados",
		"interpelados",
		"interpolados",
		"interpretados",
		"interpuestos",
		"interrogados",
		"interrumpidos",
		"intervenidos",
		"intimados",
		"intimidados",
		"intitulados",
		"intoxicados",
		"intrigados",
		"introducidos",
		"intuidos",
		"inundados",
		"inutilizados",
		"invadidos",
		"invalidados",
		"inventados",
		"inventariados",
		"invertidos",
		"investidos",
		"investigados",
		"invitados",
		"invocados",
		"involucionados",
		"inyectados",
		"ionizados",
		"ironizados",
		"irradiados",
		"irrespetados",
		"irrigados",
		"irritados",
		"irrogados",
		"irrumpidos",
		"jactados",
		"jalados",
		"jaleados",
		"jalonados",
		"jaqueados",
		"jerarquizados",
		"jodidos",
		"jorobados",
		"jubilados",
		"jugados",
		"juntados",
		"jurados",
		"juramentados",
		"justificados",
		"juzgados",
		"laborados",
		"labrados",
		"laburados",
		"lacados",
		"lacerados",
		"lactados",
		"ladeados",
		"ladrados",
		"lamentados",
		"lamidos",
		"laminados",
		"languidecidos",
		"lanzados",
		"lapidados",
		"laqueados",
		"largados",
		"lastimados",
		"lastrados",
		"latidos",
		"laudados",
		"lavados",
		"legalizados",
		"legislados",
		"legitimados",
		"leídos",
		"lesionados",
		"leudados",
		"levantados",
		"liados",
		"liberados",
		"liberalizados",
		"libertados",
		"librados",
		"licitados",
		"licuados",
		"liderizados",
		"lidiados",
		"ligados",
		"lijados",
		"limados",
		"limitados",
		"limpiados",
		"linchados",
		"liquidados",
		"litigados",
		"llagados",
		"llamados",
		"llegados",
		"llenados",
		"llevados",
		"llorados",
		"localizados",
		"logrados",
		"lubricados",
		"luchados",
		"lucidos",
		"lucrados",
		"lustrados",
		"macerados",
		"machacados",
		"macheteados",
		"machucados",
		"madreados",
		"madrugados",
		"madurados",
		"magnetizados",
		"magnificados",
		"malacostumbrados",
		"malbaratados",
		"malcriados",
		"maleados",
		"malentendidos",
		"malgastados",
		"malinterpretados",
		"malogrados",
		"maltratados",
		"malversados",
		"mamados",
		"manchados",
		"mancillados",
		"mandados",
		"manejados",
		"mangados",
		"mangoneados",
		"manifestados",
		"maniobrados",
		"manipulados",
		"manoseados",
		"manteados",
		"mantenidos",
		"manufacturados",
		"maquillados",
		"maquinados",
		"maravillados",
		"marcados",
		"marchitados",
		"mareados",
		"marginados",
		"maridados",
		"martillados",
		"martirizados",
		"masacrados",
		"masajeados",
		"mascados",
		"masificados",
		"masticados",
		"masturbados",
		"matados",
		"materializados",
		"matizados",
		"matriculados",
		"maximizados",
		"meados",
		"mecanografiados",
		"mechados",
		"mecidos",
		"mediados",
		"mediatizados",
		"medicados",
		"medidos",
		"meditados",
		"medrados",
		"mejorados",
		"mellados",
		"memorizados",
		"mencionados",
		"meneados",
		"menguados",
		"menoscabados",
		"menospreciados",
		"menstruados",
		"mensualizados",
		"mensurados",
		"mentados",
		"mentalizados",
		"mentidos",
		"mercadeados",
		"mercantilizados",
		"merecidos",
		"merendados",
		"mermados",
		"merodeados",
		"mesurados",
		"metamorfoseados",
		"metidos",
		"mezclados",
		"migrados",
		"militados",
		"militarizados",
		"mimados",
		"mimetizados",
		"minados",
		"minimizados",
		"ministrados",
		"minusvalorados",
		"mirados",
		"mistificados",
		"mitificados",
		"mitigados",
		"modelados",
		"modernizados",
		"modificados",
		"modulados",
		"mofados",
		"mojados",
		"moldeados",
		"molestados",
		"molidos",
		"monetizados",
		"monitorizados",
		"monopolizados",
		"montados",
		"morados",
		"moralizados",
		"mordidos",
		"mordisqueados",
		"mortificados",
		"mosqueados",
		"mostrados",
		"motejados",
		"motivados",
		"movidos",
		"movilizados",
		"mudados",
		"muestreados",
		"multados",
		"multiplicados",
		"munidos",
		"murmurados",
		"mutados",
		"mutilados",
		"nacionalizados",
		"narcotizados",
		"narrados",
		"naufragados",
		"navegados",
		"necesitados",
		"negados",
		"negociados",
		"neutralizados",
		"ninguneados",
		"nivelados",
		"nombrados",
		"nominados",
		"noqueados",
		"normados",
		"normalizados",
		"notados",
		"notificados",
		"nutridos",
		"obcecados",
		"obedecidos",
		"objetados",
		"objetivados",
		"obligados",
		"obliterados",
		"obnubilados",
		"obrados",
		"obsequiados",
		"observados",
		"obsesionados",
		"obstaculizados",
		"obstruidos",
		"obtenidos",
		"obturados",
		"obviados",
		"ocasionados",
		"ocluidos",
		"ocultados",
		"ocupados",
		"odiados",
		"ofendidos",
		"ofertados",
		"oficiados",
		"oficializados",
		"ofrecidos",
		"ofrendados",
		"ofuscados",
		"oídos",
		"ojeados",
		"olfateados",
		"olidos",
		"olvidados",
		"omitidos",
		"ondeados",
		"ondulados",
		"opacados",
		"operados",
		"opinados",
		"oprimidos",
		"optados",
		"optimizados",
		"opuestos",
		"orados",
		"orbitados",
		"ordenados",
		"ordeñados",
		"organizados",
		"orientados",
		"originados",
		"orillados",
		"orinados",
		"ornados",
		"ornamentados",
		"orquestados",
		"osados",
		"oscilados",
		"oscurecidos",
		"osificados",
		"ostentados",
		"otorgados",
		"ovacionados",
		"ovulados",
		"oxidados",
		"oxigenados",
		"pacificados",
		"pactados",
		"padecidos",
		"paganizados",
		"paginados",
		"paladeados",
		"paliados",
		"palpados",
		"parados",
		"parafraseados",
		"paralizados",
		"parapetados",
		"parasitados",
		"parcelados",
		"parchados",
		"parcheados",
		"pareados",
		"paridos",
		"parodiados",
		"parqueados",
		"participados",
		"particularizados",
		"partidos",
		"pasados",
		"paseados",
		"pastoreados",
		"pataleados",
		"pateados",
		"patentados",
		"patentizados",
		"patinados",
		"patrullados",
		"pecados",
		"pedaleados",
		"pedidos",
		"pegados",
		"peinados",
		"pellizcados",
		"penalizados",
		"penetrados",
		"pensados",
		"percatados",
		"percibidos",
		"percutidos",
		"perdidos",
		"perdonados",
		"perdurados",
		"perecidos",
		"peregrinados",
		"perfeccionados",
		"perfilados",
		"perforados",
		"perfumados",
		"pergeñados",
		"peritados",
		"perjudicados",
		"perjurados",
		"permeados",
		"permitidos",
		"permutados",
		"pernoctados",
		"perpetrados",
		"perpetuados",
		"perseguidos",
		"perseverados",
		"persistidos",
		"personados",
		"personalizados",
		"personificados",
		"persuadidos",
		"pertenecidos",
		"pertrechados",
		"perturbados",
		"pervertidos",
		"pervividos",
		"pescados",
		"petados",
		"peticionados",
		"picados",
		"picaneados",
		"picoteados",
		"pifiados",
		"pignorados",
		"pillados",
		"pilotados",
		"piloteados",
		"pincelados",
		"pinchados",
		"pintados",
		"pintarrajeados",
		"pinzados",
		"pirados",
		"pirateados",
		"pisados",
		"pisoteados",
		"pitados",
		"placidos",
		"plagiados",
		"planchados",
		"planeados",
		"plantados",
		"planteados",
		"plasmados",
		"platicados",
		"plegados",
		"pluralizados",
		"podados",
		"poetizados",
		"polemizados",
		"politizados",
		"pololeados",
		"ponderados",
		"pontificados",
		"popularizados",
		"porfiados",
		"portados",
		"porteados",
		"posados",
		"posesionados",
		"posibilitados",
		"posicionados",
		"pospuestos",
		"posteados",
		"postergados",
		"postrados",
		"postulados",
		"potenciados",
		"practicados",
		"precarizados",
		"precedidos",
		"preceptuados",
		"precintados",
		"precipitados",
		"precisados",
		"preconizados",
		"predicados",
		"predichos",
		"predispuestos",
		"predominados",
		"preferidos",
		"prefigurados",
		"pregonados",
		"preguntados",
		"prejuzgados",
		"premiados",
		"prendados",
		"prendidos",
		"preocupados",
		"preparados",
		"presagiados",
		"prescindidos",
		"presenciados",
		"presentados",
		"presentidos",
		"preservados",
		"presididos",
		"presionados",
		"prestados",
		"prestigiados",
		"presumidos",
		"presurizados",
		"pretendidos",
		"preteridos",
		"prevalecidos",
		"prevalidos",
		"prevaricados",
		"prevenidos",
		"previstos",
		"primados",
		"principiados",
		"pringados",
		"priorizados",
		"privatizados",
		"probados",
		"problematizados",
		"procedidos",
		"procesados",
		"proclamados",
		"procreados",
		"procurados",
		"prodigados",
		"producidos",
		"profanados",
		"proferidos",
		"profesados",
		"profesionalizados",
		"profetizados",
		"profundizados",
		"programados",
		"progresados",
		"prohibidos",
		"prohijados",
		"proletarizados",
		"proliferados",
		"prologados",
		"prolongados",
		"promediados",
		"prometidos",
		"promocionados",
		"promovidos",
		"promulgados",
		"pronosticados",
		"pronunciados",
		"propagados",
		"propalados",
		"propendidos",
		"propiciados",
		"propinados",
		"proporcionados",
		"propuestos",
		"propugnados",
		"propulsados",
		"prorrateados",
		"prorrogados",
		"proseguidos",
		"prosperados",
		"prostituidos",
		"protegidos",
		"protestados",
		"protocolizados",
		"provenidos",
		"provocados",
		"proyectados",
		"psicoanalizados",
		"publicados",
		"publicitados",
		"puestos",
		"pugnados",
		"pujados",
		"pulidos",
		"pulsados",
		"pululados",
		"pulverizados",
		"punados",
		"punteados",
		"puntuados",
		"puntualizados",
		"punzados",
		"purgados",
		"purificados",
		"puteados",
		"quebrados",
		"quebrantados",
		"quejados",
		"quemados",
		"querellados",
		"queridos",
		"quintuplicados",
		"quitados",
		"racionados",
		"racionalizados",
		"radiados",
		"radicados",
		"radicalizados",
		"raídos",
		"rajados",
		"ralentizados",
		"rapados",
		"rapeados",
		"raptados",
		"rascados",
		"rasgados",
		"rasguñados",
		"raspados",
		"rastreados",
		"rasurados",
		"ratificados",
		"rayados",
		"razonados",
		"reabiertos",
		"reabsorbidos",
		"reaccionados",
		"reactivados",
		"readaptados",
		"readmitidos",
		"reafirmados",
		"reagrupados",
		"reajustados",
		"realimentados",
		"realizados",
		"realzados",
		"reanimados",
		"reanudados",
		"reaparecidos",
		"rearmados",
		"reasumidos",
		"reavivados",
		"rebajados",
		"rebalsados",
		"rebanados",
		"rebasados",
		"rebatidos",
		"rebautizados",
		"rebelados",
		"reblandecidos",
		"rebobinados",
		"rebosados",
		"rebotados",
		"rebozados",
		"rebuscados",
		"recabados",
		"recaídos",
		"recalados",
		"recalcados",
		"recalentados",
		"recalificados",
		"recapacitados",
		"recapitulados",
		"recargados",
		"recatados",
		"recaudados",
		"receptados",
		"recetados",
		"rechazados",
		"recibidos",
		"reciclados",
		"recitados",
		"reclamados",
		"reclinados",
		"reclutados",
		"recobrados",
		"recocidos",
		"recogidos",
		"recolectados",
		"recomendados",
		"recomenzados",
		"recompensados",
		"recompuestos",
		"reconcentrados",
		"reconciliados",
		"reconducidos",
		"reconfortados",
		"reconocidos",
		"reconquistados",
		"reconsiderados",
		"reconstituidos",
		"reconstruidos",
		"reconvenidos",
		"reconvertidos",
		"recopilados",
		"recordados",
		"recorridos",
		"recortados",
		"recreados",
		"recriminados",
		"recrudecidos",
		"rectificados",
		"recubiertos",
		"reculados",
		"recuperados",
		"recurridos",
		"recusados",
		"redactados",
		"redefinidos",
		"redescubiertos",
		"redimensionados",
		"redimidos",
		"rediseñados",
		"redistribuidos",
		"redituados",
		"redoblados",
		"redondeados",
		"reducidos",
		"redundados",
		"reedificados",
		"reeditados",
		"reeducados",
		"reelaborados",
		"reembolsados",
		"reemplazados",
		"reencarnados",
		"reencauchados",
		"reencontrados",
		"reenganchados",
		"reenviados",
		"reescritos",
		"reestructurados",
		"reexaminados",
		"refaccionados",
		"referidos",
		"refinados",
		"refinanciados",
		"reflejados",
		"reflexionados",
		"reflotados",
		"reforestados",
		"reformados",
		"reforzados",
		"refractados",
		"refrenados",
		"refrendados",
		"refrescados",
		"refrigerados",
		"refundidos",
		"refutados",
		"regados",
		"regalados",
		"regañados",
		"regateados",
		"regenerados",
		"regentados",
		"regenteados",
		"regidos",
		"regionalizados",
		"registrados",
		"reglados",
		"reglamentados",
		"regocijados",
		"regodeados",
		"regresados",
		"regulados",
		"regularizados",
		"regurgitados",
		"rehabilitados",
		"rehechos",
		"rehogados",
		"rehuidos",
		"rehusados",
		"reídos",
		"reinados",
		"reincididos",
		"reincorporados",
		"reingresados",
		"reiniciados",
		"reinsertados",
		"reinstalados",
		"reinstaurados",
		"reintegrados",
		"reinventados",
		"reinvertidos",
		"reiterados",
		"reivindicados",
		"rejuvenecidos",
		"relajados",
		"relamidos",
		"relanzados",
		"relatados",
		"relativizados",
		"relegados",
		"releídos",
		"relevados",
		"religados",
		"rellenados",
		"remachados",
		"remados",
		"remangados",
		"remarcados",
		"rematados",
		"remecidos",
		"remediados",
		"rememorados",
		"remendados",
		"remitidos",
		"remodelados",
		"remojados",
		"remolcados",
		"remontados",
		"removidos",
		"remplazados",
		"renacidos",
		"rendidos",
		"renegados",
		"renegociados",
		"reñidos",
		"renombrados",
		"renovados",
		"rentabilizados",
		"rentados",
		"renunciados",
		"reordenados",
		"reorganizados",
		"reorientados",
		"reparados",
		"repartidos",
		"repasados",
		"repatriados",
		"repelidos",
		"repensados",
		"repercutidos",
		"repescados",
		"repetidos",
		"repicados",
		"repintados",
		"replanteados",
		"replegados",
		"replicados",
		"repoblados",
		"reportados",
		"reporteados",
		"reposados",
		"repreguntados",
		"reprendidos",
		"represados",
		"representados",
		"reprimidos",
		"reprobados",
		"reprochados",
		"reproducidos",
		"repudiados",
		"repuestos",
		"repugnados",
		"repuntados",
		"reputados",
		"requeridos",
		"requisados",
		"resaltados",
		"resarcidos",
		"resbalados",
		"rescatados",
		"rescindidos",
		"resecados",
		"reseñados",
		"reservados",
		"reseteados",
		"resguardados",
		"resididos",
		"resignados",
		"resistidos",
		"resonados",
		"respaldados",
		"respetados",
		"respirados",
		"resplandecidos",
		"respondidos",
		"responsabilizados",
		"resquebrajados",
		"restablecidos",
		"restados",
		"restaurados",
		"restituidos",
		"restregados",
		"resucitados",
		"resueltos",
		"resumidos",
		"resurgidos",
		"retados",
		"retardados",
		"retenidos",
		"retirados",
		"retocados",
		"retomados",
		"retorcidos",
		"retornados",
		"retractados",
		"retraídos",
		"retransmitidos",
		"retrasados",
		"retratados",
		"retribuidos",
		"retrotraídos",
		"retumbados",
		"reunidos",
		"reunificados",
		"reutilizados",
		"revalidados",
		"revalorizados",
		"revaluados",
		"revelados",
		"revendidos",
		"reventados",
		"reverdecidos",
		"reverenciados",
		"revertidos",
		"revestidos",
		"revirados",
		"revisados",
		"revitalizados",
		"revividos",
		"revocados",
		"revolcados",
		"revoloteados",
		"revolucionados",
		"revueltos",
		"ridiculizados",
		"rifados",
		"rimados",
		"rivalizados",
		"rizados",
		"robados",
		"robustecidos",
		"rociados",
		"rodados",
		"rodeados",
		"rogados",
		"roídos",
		"rondados",
		"rotados",
		"rotos",
		"rotulados",
		"roturados",
		"rozados",
		"ruborizados",
		"rubricados",
		"rugidos",
		"rumiados",
		"rumorados",
		"sabidos",
		"saboreados",
		"saboteados",
		"sacados",
		"saciados",
		"sacralizados",
		"sacrificados",
		"sacudidos",
		"saldados",
		"salpimentados",
		"salpullidos",
		"saltados",
		"salteados",
		"saludados",
		"salvados",
		"salvaguardados",
		"sanados",
		"saneados",
		"sangrados",
		"santificados",
		"saqueados",
		"satanizados",
		"satirizados",
		"satisfechos",
		"sazonados",
		"secados",
		"seccionados",
		"secretados",
		"secuenciados",
		"secuestrados",
		"secundados",
		"sedimentados",
		"seducidos",
		"segados",
		"segmentados",
		"segregados",
		"seguidos",
		"seleccionados",
		"sembrados",
		"señalados",
		"sensibilizados",
		"sentados",
		"sentenciados",
		"sentidos",
		"separados",
		"serenados",
		"serrados",
		"servidos",
		"significados",
		"silenciados",
		"simbolizados",
		"simpatizados",
		"simplificados",
		"simulados",
		"sincerados",
		"sincronizados",
		"sindicados",
		"sindicalizados",
		"singularizados",
		"sintetizados",
		"sintonizados",
		"sistematizados",
		"situados",
		"sobados",
		"sobornados",
		"sobrados",
		"sobrecargados",
		"sobrecogidos",
		"sobreentendidos",
		"sobreestimados",
		"sobrellevados",
		"sobrentendidos",
		"sobrepasados",
		"sobrepuestos",
		"sobresalidos",
		"sobresaltados",
		"sobrestimados",
		"sobrevenidos",
		"sobrevividos",
		"sobrevolados",
		"socavados",
		"socializados",
		"socorridos",
		"sodomizados",
		"sofocados",
		"sojuzgados",
		"solapados",
		"solicitados",
		"solidarizados",
		"solidificados",
		"soliviantados",
		"soltados",
		"solucionados",
		"solventados",
		"sombreados",
		"sometidos",
		"sonados",
		"soñados",
		"sondeados",
		"sonreídos",
		"sonrojados",
		"sopesados",
		"soplados",
		"soportados",
		"sorbidos",
		"sorprendidos",
		"sorteados",
		"sosegados",
		"soslayados",
		"sospechados",
		"sostenidos",
		"suavizados",
		"subastados",
		"subcontratados",
		"subdivididos",
		"subestimados",
		"subidos",
		"sublevados",
		"sublimados",
		"subrayados",
		"subrogados",
		"subsanados",
		"subsidiados",
		"subsistidos",
		"substraídos",
		"subsumidos",
		"subvertidos",
		"subyugados",
		"succionados",
		"sucedidos",
		"sucumbidos",
		"sudados",
		"sufragados",
		"sufridos",
		"sugeridos",
		"sugestionados",
		"suicidados",
		"sujetados",
		"sumados",
		"sumergidos",
		"suministrados",
		"supeditados",
		"superados",
		"superpuestos",
		"supervisados",
		"suplantados",
		"suplicados",
		"suplidos",
		"suprimidos",
		"supuestos",
		"surcados",
		"surtidos",
		"suscitados",
		"suspendidos",
		"suspirados",
		"sustanciados",
		"sustantivados",
		"sustentados",
		"sustituidos",
		"sustraídos",
		"susurrados",
		"suturados",
		"tabulados",
		"tachados",
		"talados",
		"taladrados",
		"tallados",
		"tambaleados",
		"tamizados",
		"tañidos",
		"tanteados",
		"tapados",
		"tapizados",
		"taponados",
		"tarareados",
		"tardados",
		"tasados",
		"tatuados",
		"tecleados",
		"tejidos",
		"telefoneados",
		"televisados",
		"temidos",
		"templados",
		"tendidos",
		"tenidos",
		"tensados",
		"tentados",
		"teorizados",
		"terciados",
		"tergiversados",
		"terminados",
		"territorializados",
		"testados",
		"testeados",
		"testificados",
		"testimoniados",
		"tildados",
		"timados",
		"timbrados",
		"tinturados",
		"tipeados",
		"tipificados",
		"tirados",
		"tiranizados",
		"tironeados",
		"tiroteados",
		"titubeados",
		"tiznados",
		"tocados",
		"tolerados",
		"tomados",
		"tonificados",
		"topados",
		"toqueteados",
		"torcidos",
		"toreados",
		"tornados",
		"tornasolados",
		"torneados",
		"torpedeados",
		"torturados",
		"tosidos",
		"tostados",
		"totalizados",
		"trabados",
		"trabajados",
		"traducidos",
		"traficados",
		"tragados",
		"traicionados",
		"traídos",
		"trajinados",
		"tramados",
		"tramitados",
		"trancados",
		"tranquilizados",
		"transcendidos",
		"transcurridos",
		"transferidos",
		"transfigurados",
		"transformados",
		"transfundidos",
		"transgredidos",
		"transigidos",
		"transitados",
		"transliterados",
		"translucidos",
		"transmitidos",
		"transmutados",
		"transparentados",
		"transpirados",
		"transportados",
		"transpuestos",
		"trasegados",
		"trasgredidos",
		"trasladados",
		"traslapados",
		"traslucidos",
		"trasnochados",
		"traspapelados",
		"traspasados",
		"trasplantados",
		"traspuestos",
		"trasquilados",
		"trasteados",
		"trastocados",
		"trastornados",
		"trasvasados",
		"tratados",
		"trazados",
		"trenzados",
		"trepados",
		"tributados",
		"trincados",
		"triplicados",
		"triturados",
		"triunfados",
		"trivializados",
		"trocados",
		"troceados",
		"tronados",
		"tronchados",
		"truncados",
		"tumbados",
		"tuneados",
		"turbados",
		"turnados",
		"tutelados",
		"ufanados",
		"ultimados",
		"uncidos",
		"ungidos",
		"unidos",
		"universalizados",
		"untados",
		"urbanizados",
		"urdidos",
		"usados",
		"usufructuados",
		"usurpados",
		"utilizados",
		"vacados",
		"vaciados",
		"vacilados",
		"vacunados",
		"vagados",
		"validados",
		"validos",
		"valorados",
		"valorizados",
		"valuados",
		"vanagloriados",
		"vandalizados",
		"vaporizados",
		"variados",
		"vaticinados",
		"vedados",
		"vehiculados",
		"vejados",
		"velados",
		"vencidos",
		"vendados",
		"vendidos",
		"venerados",
		"vengados",
		"ventilados",
		"veraneados",
		"verbalizados",
		"verificados",
		"versados",
		"versionados",
		"vertebrados",
		"vertidos",
		"vestidos",
		"vetados",
		"viabilizados",
		"viajados",
		"vibrados",
		"victimados",
		"victimizados",
		"vigilados",
		"vigorizados",
		"vilipendiados",
		"vindicados",
		"violados",
		"violentados",
		"virados",
		"visados",
		"visibilizados",
		"visitados",
		"vislumbrados",
		"vistos",
		"visualizados",
		"vitoreados",
		"vitrificados",
		"vituperados",
		"vividos",
		"vivificados",
		"vocalizados",
		"voceados",
		"vociferados",
		"volados",
		"volatilizados",
		"volcados",
		"volteados",
		"vomitados",
		"votados",
		"vueltos",
		"vulcanizados",
		"vulgarizados",
		"vulnerados",
		"yuxtapuestos",
		"zafados",
		"zambullidos",
		"zampados",
		"zanjados",
		"zarandeados",
		"zarpados",
		"zozobrados",
		"zumbados",
		"zurcidos",
		"zurrados",
		"abajadas",
		"abalanzadas",
		"abaleadas",
		"abandonadas",
		"abaratadas",
		"abarcadas",
		"abarrotadas",
		"abastecidas",
		"abatidas",
		"abdicadas",
		"abiertas",
		"abismadas",
		"abjuradas",
		"ablandadas",
		"abocadas",
		"abochornadas",
		"abofeteadas",
		"abolidas",
		"abolladas",
		"abombadas",
		"abominadas",
		"abonadas",
		"abordadas",
		"aborrecidas",
		"aborregadas",
		"abortadas",
		"abotonadas",
		"abrasadas",
		"abrazadas",
		"abrevadas",
		"abreviadas",
		"abrigadas",
		"abrochadas",
		"abrogadas",
		"abroqueladas",
		"abrumadas",
		"absorbidas",
		"abstenidas",
		"abstraídas",
		"absueltas",
		"abucheadas",
		"abultadas",
		"abundadas",
		"aburguesadas",
		"aburridas",
		"abusadas",
		"acabadas",
		"acalladas",
		"acaloradas",
		"acaparadas",
		"acariciadas",
		"acarreadas",
		"acatadas",
		"acaudilladas",
		"accedidas",
		"accionadas",
		"acechadas",
		"aceitadas",
		"aceleradas",
		"acentuadas",
		"aceptadas",
		"aceradas",
		"acercadas",
		"acertadas",
		"achacadas",
		"achantadas",
		"achatadas",
		"achicadas",
		"acicaladas",
		"acidificadas",
		"aclaradas",
		"aclimatadas",
		"acobardadas",
		"acodadas",
		"acogidas",
		"acojonadas",
		"acometidas",
		"acomodadas",
		"acompañadas",
		"acompasadas",
		"acongojadas",
		"aconsejadas",
		"acontecidas",
		"acopiadas",
		"acopladas",
		"acordadas",
		"acordonadas",
		"acorraladas",
		"acortadas",
		"acosadas",
		"acostadas",
		"acostumbradas",
		"acotadas",
		"acrecentadas",
		"acreditadas",
		"acrisoladas",
		"activadas",
		"actuadas",
		"acuchilladas",
		"acuciadas",
		"acudidas",
		"acuerpadas",
		"acumuladas",
		"acunadas",
		"acuñadas",
		"acurrucadas",
		"acusadas",
		"adaptadas",
		"adecentadas",
		"adelantadas",
		"adelgazadas",
		"adentradas",
		"adeudadas",
		"adheridas",
		"adicionadas",
		"adiestradas",
		"adivinadas",
		"adjetivadas",
		"adjudicadas",
		"adjuntadas",
		"administradas",
		"admiradas",
		"admitidas",
		"adoctrinadas",
		"adolecidas",
		"adoptadas",
		"adoradas",
		"adormecidas",
		"adornadas",
		"adquiridas",
		"aducidas",
		"adueñadas",
		"aduladas",
		"adulteradas",
		"advertidas",
		"afanadas",
		"afeadas",
		"afectadas",
		"afeitadas",
		"aferradas",
		"afianzadas",
		"afinadas",
		"afirmadas",
		"afligidas",
		"afloradas",
		"afrentadas",
		"afrontadas",
		"agachadas",
		"agarradas",
		"agarrotadas",
		"agasajadas",
		"agenciadas",
		"agigantadas",
		"agilizadas",
		"agitadas",
		"aglutinadas",
		"agobiadas",
		"agolpadas",
		"agonizadas",
		"agostadas",
		"agotadas",
		"agradadas",
		"agradecidas",
		"agrandadas",
		"agravadas",
		"agraviadas",
		"agredidas",
		"agregadas",
		"agriadas",
		"agrietadas",
		"agrupadas",
		"aguadas",
		"aguantadas",
		"aguardadas",
		"agudizadas",
		"aguijoneadas",
		"agujereadas",
		"aguzadas",
		"ahogadas",
		"ahondadas",
		"ahorcadas",
		"ahorradas",
		"ahuecadas",
		"ahuyentadas",
		"aireadas",
		"aisladas",
		"ajustadas",
		"ajusticiadas",
		"alabadas",
		"alagadas",
		"alambradas",
		"alardeadas",
		"alargadas",
		"alarmadas",
		"albergadas",
		"alborotadas",
		"alcanzadas",
		"aleccionadas",
		"alegadas",
		"alegradas",
		"alejadas",
		"alentadas",
		"alertadas",
		"alfabetizadas",
		"alfombradas",
		"aliadas",
		"alienadas",
		"aligeradas",
		"alimentadas",
		"aliñadas",
		"alineadas",
		"alisadas",
		"alistadas",
		"aliviadas",
		"alivianadas",
		"allanadas",
		"almacenadas",
		"almorzadas",
		"alojadas",
		"alquiladas",
		"alteradas",
		"alternadas",
		"alucinadas",
		"aludidas",
		"alumbradas",
		"alzadas",
		"amadas",
		"amaestradas",
		"amagadas",
		"amainadas",
		"amalgamadas",
		"amamantadas",
		"amansadas",
		"amargadas",
		"amarradas",
		"amasadas",
		"ambicionadas",
		"amedrentadas",
		"amenazadas",
		"amenizadas",
		"ameritadas",
		"ametralladas",
		"amilanadas",
		"aminoradas",
		"amnistiadas",
		"amoldadas",
		"amonestadas",
		"amontonadas",
		"amordazadas",
		"amortajadas",
		"amortiguadas",
		"amortizadas",
		"amotinadas",
		"amparadas",
		"ampayadas",
		"ampliadas",
		"amplificadas",
		"amputadas",
		"amuebladas",
		"añadidas",
		"analizadas",
		"anatematizadas",
		"andadas",
		"anegadas",
		"anestesiadas",
		"anexadas",
		"anexionadas",
		"anheladas",
		"anidadas",
		"anilladas",
		"animadas",
		"aniquiladas",
		"anisadas",
		"añoradas",
		"anotadas",
		"anoticiadas",
		"ansiadas",
		"antecedidas",
		"antepuestas",
		"anticipadas",
		"antojadas",
		"anudadas",
		"anuladas",
		"anunciadas",
		"apabulladas",
		"apachurradas",
		"apaciguadas",
		"apadrinadas",
		"apagadas",
		"apalancadas",
		"apaleadas",
		"apañadas",
		"apantalladas",
		"aparcadas",
		"apareadas",
		"aparecidas",
		"aparentadas",
		"apartadas",
		"apeadas",
		"apedreadas",
		"apeladas",
		"apellidadas",
		"apelmazadas",
		"apercibidas",
		"apersonadas",
		"apestadas",
		"apetecidas",
		"apiadadas",
		"apiladas",
		"apiñadas",
		"apisonadas",
		"aplacadas",
		"aplanadas",
		"aplastadas",
		"aplaudidas",
		"aplazadas",
		"aplicadas",
		"apoderadas",
		"apoltronadas",
		"aporreadas",
		"aportadas",
		"aposentadas",
		"apostadas",
		"apostatadas",
		"apostilladas",
		"apoyadas",
		"apreciadas",
		"aprehendidas",
		"apremiadas",
		"aprendidas",
		"apresadas",
		"apresuradas",
		"apretadas",
		"apretujadas",
		"aprisionadas",
		"aprobadas",
		"aprovechadas",
		"aprovisionadas",
		"aproximadas",
		"apuñaladas",
		"apuñaleadas",
		"apuntadas",
		"apuntaladas",
		"apuntilladas",
		"apuradas",
		"aquejadas",
		"aquietadas",
		"aquilatadas",
		"arañadas",
		"arbitradas",
		"archivadas",
		"arengadas",
		"argüidas",
		"argumentadas",
		"armadas",
		"armonizadas",
		"aromatizadas",
		"arqueadas",
		"arrancadas",
		"arrasadas",
		"arrastradas",
		"arreadas",
		"arrebatadas",
		"arreciadas",
		"arregladas",
		"arrellanadas",
		"arremangadas",
		"arremetidas",
		"arrendadas",
		"arrepentidas",
		"arrestadas",
		"arriadas",
		"arribadas",
		"arriesgadas",
		"arrimadas",
		"arrinconadas",
		"arrodilladas",
		"arrogadas",
		"arrojadas",
		"arrolladas",
		"arropadas",
		"arruinadas",
		"arrulladas",
		"articuladas",
		"asadas",
		"asaltadas",
		"ascendidas",
		"aseadas",
		"asechadas",
		"asediadas",
		"aseguradas",
		"asemejadas",
		"asentadas",
		"asentidas",
		"aserradas",
		"asesinadas",
		"asesoradas",
		"asestadas",
		"aseveradas",
		"asfixiadas",
		"asidas",
		"asignadas",
		"asiladas",
		"asimiladas",
		"asistidas",
		"asoladas",
		"asoleadas",
		"asomadas",
		"asombradas",
		"aspiradas",
		"astilladas",
		"asumidas",
		"asustadas",
		"atacadas",
		"atadas",
		"atajadas",
		"atarantadas",
		"atascadas",
		"atemorizadas",
		"atemperadas",
		"atenazadas",
		"atendidas",
		"atenidas",
		"atentadas",
		"atenuadas",
		"aterradas",
		"aterrorizadas",
		"atesoradas",
		"atestiguadas",
		"atiborradas",
		"atisbadas",
		"atizadas",
		"atomizadas",
		"atontadas",
		"atoradas",
		"atormentadas",
		"atornilladas",
		"atosigadas",
		"atracadas",
		"atragantadas",
		"atraídas",
		"atrancadas",
		"atrapadas",
		"atrasadas",
		"atravesadas",
		"atrevidas",
		"atribuidas",
		"atrincheradas",
		"atrofiadas",
		"atropelladas",
		"aturdidas",
		"auditadas",
		"auguradas",
		"aumentadas",
		"aunadas",
		"aupadas",
		"auscultadas",
		"ausentadas",
		"autenticadas",
		"autentificadas",
		"autodefinidas",
		"autoeditadas",
		"automatizadas",
		"autorizadas",
		"autorreguladas",
		"auxiliadas",
		"avaladas",
		"avanzadas",
		"avasalladas",
		"avenidas",
		"aventadas",
		"aventajadas",
		"aventuradas",
		"averiadas",
		"averiguadas",
		"avezadas",
		"avisadas",
		"avispadas",
		"avistadas",
		"avivadas",
		"avizoradas",
		"avocadas",
		"ayudadas",
		"azotadas",
		"azuzadas",
		"babeadas",
		"bailadas",
		"bajadas",
		"balaceadas",
		"balanceadas",
		"bañadas",
		"banalizadas",
		"bancadas",
		"bandeadas",
		"barajadas",
		"barridas",
		"basadas",
		"bastardeadas",
		"basureadas",
		"batalladas",
		"bateadas",
		"batidas",
		"bautizadas",
		"beatificadas",
		"bebidas",
		"beneficiadas",
		"besadas",
		"bifurcadas",
		"birladas",
		"blandidas",
		"blanqueadas",
		"blasfemadas",
		"blindadas",
		"bloqueadas",
		"boicoteadas",
		"bombardeadas",
		"bombeadas",
		"bonificadas",
		"bordeadas",
		"borradas",
		"borroneadas",
		"bosquejadas",
		"bostezadas",
		"botadas",
		"boxeadas",
		"bregadas",
		"brilladas",
		"brincadas",
		"brindadas",
		"bromeadas",
		"brotadas",
		"bruñidas",
		"buceadas",
		"burladas",
		"buscadas",
		"cabeceadas",
		"cabidas",
		"cabildeadas",
		"cabreadas",
		"cacareadas",
		"cachadas",
		"cacheadas",
		"cacheteadas",
		"caducadas",
		"cagadas",
		"caladas",
		"calculadas",
		"caldeadas",
		"calefaccionadas",
		"calendarizadas",
		"calentadas",
		"calibradas",
		"calificadas",
		"caligrafiadas",
		"calladas",
		"calmadas",
		"calumniadas",
		"calzadas",
		"cambiadas",
		"caminadas",
		"camufladas",
		"canalizadas",
		"canceladas",
		"canjeadas",
		"cansadas",
		"cantadas",
		"capadas",
		"capeadas",
		"capitalizadas",
		"capituladas",
		"captadas",
		"capturadas",
		"caracterizadas",
		"carburadas",
		"carcomidas",
		"cardadas",
		"careadas",
		"carecidas",
		"cargadas",
		"caricaturizadas",
		"cartografiadas",
		"cascadas",
		"castigadas",
		"castradas",
		"catadas",
		"catalizadas",
		"catalogadas",
		"catapultadas",
		"cateadas",
		"categorizadas",
		"causadas",
		"cauterizadas",
		"cautivadas",
		"cavadas",
		"caviladas",
		"cazadas",
		"cebadas",
		"cedidas",
		"cegadas",
		"cejadas",
		"celebradas",
		"cenadas",
		"ceñidas",
		"censuradas",
		"centrifugadas",
		"centuplicadas",
		"cepilladas",
		"cercadas",
		"cercenadas",
		"cercioradas",
		"cernidas",
		"cerradas",
		"cesadas",
		"chafadas",
		"chamuscadas",
		"chantajeadas",
		"chapadas",
		"charladas",
		"chateadas",
		"chequeadas",
		"chifladas",
		"chilladas",
		"chingadas",
		"chirriadas",
		"chivadas",
		"chocadas",
		"chorreadas",
		"choteadas",
		"chupadas",
		"chutadas",
		"cicatrizadas",
		"cifradas",
		"cimentadas",
		"cinceladas",
		"circuladas",
		"circuncidadas",
		"circundadas",
		"citadas",
		"clamadas",
		"clarificadas",
		"clasificadas",
		"claudicadas",
		"clausuradas",
		"clavadas",
		"clicadas",
		"clonadas",
		"coaccionadas",
		"coadyuvadas",
		"coaguladas",
		"coaligadas",
		"coartadas",
		"cobijadas",
		"cobradas",
		"cocidas",
		"cocinadas",
		"codeadas",
		"codiciadas",
		"codificadas",
		"codirigidas",
		"coexistidas",
		"cofinanciadas",
		"cogidas",
		"cohabitadas",
		"cohibidas",
		"coincididas",
		"colaboradas",
		"colacionadas",
		"coladas",
		"colapsadas",
		"coleccionadas",
		"colectadas",
		"colectivizadas",
		"colgadas",
		"colisionadas",
		"colmadas",
		"colocadas",
		"colonizadas",
		"coloreadas",
		"columpiadas",
		"combatidas",
		"combinadas",
		"comentadas",
		"comenzadas",
		"comerciadas",
		"comercializadas",
		"cometidas",
		"comidas",
		"comisionadas",
		"compactadas",
		"compadecidas",
		"compaginadas",
		"comparadas",
		"comparecidas",
		"compartidas",
		"compatibilizadas",
		"compelidas",
		"compendiadas",
		"compenetradas",
		"compensadas",
		"compiladas",
		"complacidas",
		"complementadas",
		"completadas",
		"complotadas",
		"comportadas",
		"compradas",
		"comprendidas",
		"comprimidas",
		"comprobadas",
		"comprometidas",
		"compuestas",
		"compulsadas",
		"computadas",
		"comulgadas",
		"comunicadas",
		"concatenadas",
		"concebidas",
		"concedidas",
		"concelebradas",
		"concentradas",
		"conceptuadas",
		"conceptualizadas",
		"concertadas",
		"concienciadas",
		"concientizadas",
		"conciliadas",
		"concitadas",
		"concluidas",
		"concordadas",
		"concretadas",
		"concretizadas",
		"conculcadas",
		"concursadas",
		"condenadas",
		"condensadas",
		"condicionadas",
		"condimentadas",
		"condolidas",
		"condonadas",
		"conducidas",
		"conectadas",
		"conexionadas",
		"confabuladas",
		"confeccionadas",
		"conferidas",
		"confesadas",
		"confiadas",
		"configuradas",
		"confirmadas",
		"confiscadas",
		"confluidas",
		"conformadas",
		"confortadas",
		"confrontadas",
		"confundidas",
		"congeniadas",
		"congestionadas",
		"congratuladas",
		"congregadas",
		"conjeturadas",
		"conjugadas",
		"conjuntadas",
		"conjuradas",
		"conllevadas",
		"conmemoradas",
		"conminadas",
		"conmocionadas",
		"conmovidas",
		"conmutadas",
		"connotadas",
		"conquistadas",
		"consagradas",
		"conseguidas",
		"consensuadas",
		"consentidas",
		"conservadas",
		"consideradas",
		"consignadas",
		"consistidas",
		"consoladas",
		"consolidadas",
		"conspiradas",
		"constadas",
		"constatadas",
		"consteladas",
		"constitucionalizadas",
		"constituidas",
		"constreñidas",
		"construidas",
		"consultadas",
		"consumadas",
		"consumidas",
		"contabilizadas",
		"contactadas",
		"contadas",
		"contagiadas",
		"contempladas",
		"contendidas",
		"contenidas",
		"contentadas",
		"contestadas",
		"contextualizadas",
		"continuadas",
		"contorneadas",
		"contraatacadas",
		"contrabandeadas",
		"contradichas",
		"contrahechas",
		"contraídas",
		"contrapesadas",
		"contrapuestas",
		"contrariadas",
		"contrarrestadas",
		"contrastadas",
		"contratadas",
		"contravenidas",
		"contribuidas",
		"contristadas",
		"controladas",
		"convalidadas",
		"convencidas",
		"convenidas",
		"convergidas",
		"conversadas",
		"convertidas",
		"convidadas",
		"convividas",
		"convocadas",
		"convulsionadas",
		"cooperadas",
		"cooptadas",
		"coordinadas",
		"copadas",
		"copiadas",
		"coproducidas",
		"copuladas",
		"coqueteadas",
		"corchadas",
		"coreadas",
		"coreografiadas",
		"corneadas",
		"coronadas",
		"corporizadas",
		"corregidas",
		"correlacionadas",
		"correspondidas",
		"correteadas",
		"corridas",
		"corroboradas",
		"corroídas",
		"corrompidas",
		"cortadas",
		"cortejadas",
		"cosechadas",
		"cosidas",
		"cosificadas",
		"costadas",
		"costeadas",
		"cotejadas",
		"cotizadas",
		"creadas",
		"creídas",
		"criadas",
		"cribadas",
		"criminalizadas",
		"crispadas",
		"cristalizadas",
		"cristianizadas",
		"criticadas",
		"cronometradas",
		"crucificadas",
		"crujidas",
		"cruzadas",
		"cuadriplicadas",
		"cuadruplicadas",
		"cuajadas",
		"cuantificadas",
		"cuarteadas",
		"cubiertas",
		"cuestionadas",
		"cuidadas",
		"culeadas",
		"culminadas",
		"culpabilizadas",
		"culpadas",
		"cultivadas",
		"culturizadas",
		"cumplidas",
		"cumplimentadas",
		"cundidas",
		"curadas",
		"curioseadas",
		"curradas",
		"cursadas",
		"curvadas",
		"custodiadas",
		"dadas",
		"dañadas",
		"danzadas",
		"datadas",
		"dateadas",
		"debatidas",
		"debidas",
		"debilitadas",
		"debitadas",
		"debutadas",
		"decaídas",
		"decantadas",
		"decapitadas",
		"decepcionadas",
		"decididas",
		"declamadas",
		"declaradas",
		"declinadas",
		"decodificadas",
		"decoloradas",
		"decomisadas",
		"decrecidas",
		"decretadas",
		"dedicadas",
		"deducidas",
		"defecadas",
		"defendidas",
		"defenestradas",
		"deferidas",
		"definidas",
		"deformadas",
		"defraudadas",
		"degeneradas",
		"deglutidas",
		"degolladas",
		"degradadas",
		"degustadas",
		"deificadas",
		"dejadas",
		"delatadas",
		"delegadas",
		"deleitadas",
		"deletreadas",
		"deliberadas",
		"delimitadas",
		"delineadas",
		"delinquidas",
		"demandadas",
		"demarcadas",
		"demediadas",
		"demeritadas",
		"democratizadas",
		"demolidas",
		"demonizadas",
		"demoradas",
		"demostradas",
		"demudadas",
		"denegadas",
		"denigradas",
		"denominadas",
		"denostadas",
		"denotadas",
		"denunciadas",
		"deparadas",
		"departidas",
		"dependidas",
		"depiladas",
		"deploradas",
		"deportadas",
		"depositadas",
		"depreciadas",
		"depredadas",
		"deprimidas",
		"depuestas",
		"depuradas",
		"derechizadas",
		"derivadas",
		"derogadas",
		"derramadas",
		"derretidas",
		"derribadas",
		"derrocadas",
		"derrochadas",
		"derrotadas",
		"derruidas",
		"derrumbadas",
		"desabrochadas",
		"desacatadas",
		"desaceleradas",
		"desacomodadas",
		"desaconsejadas",
		"desacopladas",
		"desacralizadas",
		"desacreditadas",
		"desactivadas",
		"desafiadas",
		"desafinadas",
		"desaguadas",
		"desahogadas",
		"desairadas",
		"desajustadas",
		"desalentadas",
		"desalineadas",
		"desalojadas",
		"desandadas",
		"desangradas",
		"desanimadas",
		"desaparecidas",
		"desapegadas",
		"desaprendidas",
		"desaprobadas",
		"desaprovechadas",
		"desarmadas",
		"desarraigadas",
		"desarregladas",
		"desarrolladas",
		"desarticuladas",
		"desaseadas",
		"desasidas",
		"desasosegadas",
		"desatadas",
		"desatendidas",
		"desautorizadas",
		"desayunadas",
		"desbancadas",
		"desbandadas",
		"desbaratadas",
		"desbarrancadas",
		"desbastadas",
		"desbloqueadas",
		"desbocadas",
		"desbordadas",
		"desbrozadas",
		"descabalgadas",
		"descabezadas",
		"descaderadas",
		"descalabradas",
		"descalificadas",
		"descansadas",
		"descargadas",
		"descarriadas",
		"descarriladas",
		"descartadas",
		"descascaradas",
		"descascarilladas",
		"descendidas",
		"descentradas",
		"descifradas",
		"descocidas",
		"descodificadas",
		"descojonadas",
		"descolgadas",
		"descolocadas",
		"descolonizadas",
		"descompensadas",
		"descomprimidas",
		"descompuestas",
		"desconectadas",
		"desconfiadas",
		"descongeladas",
		"desconocidas",
		"descontadas",
		"descontaminadas",
		"descontextualizadas",
		"descontinuadas",
		"desconvocadas",
		"descorazonadas",
		"descorchadas",
		"descorridas",
		"descosidas",
		"descoyuntadas",
		"descreídas",
		"descristianizadas",
		"descuadradas",
		"descuartizadas",
		"descubiertas",
		"descuidadas",
		"desdeñadas",
		"desdibujadas",
		"desdichas",
		"desdobladas",
		"deseadas",
		"desecadas",
		"desechadas",
		"desembarazadas",
		"desembarcadas",
		"desembocadas",
		"desembolsadas",
		"desempacadas",
		"desempañadas",
		"desempaquetadas",
		"desempeñadas",
		"desempolvadas",
		"desenamoradas",
		"desencadenadas",
		"desencajadas",
		"desencarnadas",
		"desenchufadas",
		"desenfocadas",
		"desenfundadas",
		"desenganchadas",
		"desengrasadas",
		"desenmascaradas",
		"desenredadas",
		"desenrolladas",
		"desentendidas",
		"desenterradas",
		"desentonadas",
		"desentrañadas",
		"desenvainadas",
		"desenvueltas",
		"desequilibradas",
		"desertadas",
		"desestabilizadas",
		"desestimadas",
		"desfalcadas",
		"desfallecidas",
		"desfiguradas",
		"desfondadas",
		"desgajadas",
		"desgañitadas",
		"desgarradas",
		"desgastadas",
		"desglosadas",
		"desgobernadas",
		"desgranadas",
		"desguazadas",
		"deshechas",
		"desheredadas",
		"deshidratadas",
		"deshilachadas",
		"deshojadas",
		"deshonradas",
		"deshuesadas",
		"deshumanizadas",
		"designadas",
		"desilusionadas",
		"desincentivadas",
		"desinfectadas",
		"desinfladas",
		"desinflamadas",
		"desinformadas",
		"desinhibidas",
		"desinstaladas",
		"desintegradas",
		"desintoxicadas",
		"desistidas",
		"desjarretadas",
		"deslegitimadas",
		"desleídas",
		"desligadas",
		"deslindadas",
		"deslizadas",
		"deslucidas",
		"deslumbradas",
		"desmadradas",
		"desmalezadas",
		"desmanteladas",
		"desmaquilladas",
		"desmarcadas",
		"desmayadas",
		"desmejoradas",
		"desmembradas",
		"desmentidas",
		"desmenuzadas",
		"desmerecidas",
		"desmigadas",
		"desmitificadas",
		"desmoldadas",
		"desmontadas",
		"desmoralizadas",
		"desmoronadas",
		"desmotivadas",
		"desmovilizadas",
		"desnaturalizadas",
		"desniveladas",
		"desnucadas",
		"desnudadas",
		"desobedecidas",
		"desobligadas",
		"desoídas",
		"desolladas",
		"desorganizadas",
		"desorientadas",
		"despachadas",
		"desparasitadas",
		"desparecidas",
		"desparramadas",
		"despedazadas",
		"despedidas",
		"despegadas",
		"despeinadas",
		"despejadas",
		"despellejadas",
		"despeñadas",
		"despenalizadas",
		"desperdiciadas",
		"despersonalizadas",
		"despertadas",
		"despilfarradas",
		"despintadas",
		"despiojadas",
		"despistadas",
		"desplazadas",
		"desplegadas",
		"desplomadas",
		"desplumadas",
		"despojadas",
		"despolitizadas",
		"desposadas",
		"desposeídas",
		"despotricadas",
		"despreciadas",
		"desprendidas",
		"despreocupadas",
		"desprestigiadas",
		"desprogramadas",
		"despulpadas",
		"despuntadas",
		"desquiciadas",
		"desquitadas",
		"destacadas",
		"destapadas",
		"desteñidas",
		"desterradas",
		"destetadas",
		"destiladas",
		"destituidas",
		"destrabadas",
		"destripadas",
		"destronadas",
		"destrozadas",
		"destruidas",
		"desunidas",
		"desvalijadas",
		"desvalorizadas",
		"desvanecidas",
		"desveladas",
		"desvestidas",
		"desviadas",
		"desvinculadas",
		"desvirtuadas",
		"desvividas",
		"detectadas",
		"detenidas",
		"detentadas",
		"deterioradas",
		"determinadas",
		"detestadas",
		"detonadas",
		"devaluadas",
		"devanadas",
		"devastadas",
		"develadas",
		"devengadas",
		"devenidas",
		"devoradas",
		"devueltas",
		"diagnosticadas",
		"diagramadas",
		"dializadas",
		"dialogadas",
		"dibujadas",
		"dichas",
		"dictadas",
		"dictaminadas",
		"diezmadas",
		"difamadas",
		"diferenciadas",
		"diferidas",
		"dificultadas",
		"difuminadas",
		"difundidas",
		"digeridas",
		"digitadas",
		"dignadas",
		"dignificadas",
		"dilapidadas",
		"dilatadas",
		"diligenciadas",
		"dilucidadas",
		"diluidas",
		"dimensionadas",
		"dimitidas",
		"dinamitadas",
		"dinamizadas",
		"dirimidas",
		"discernidas",
		"disciplinadas",
		"discontinuadas",
		"discrepadas",
		"discriminadas",
		"disculpadas",
		"discurridas",
		"discutidas",
		"diseccionadas",
		"diseminadas",
		"diseñadas",
		"disentidas",
		"disertadas",
		"disfrazadas",
		"disfrutadas",
		"disgregadas",
		"disgustadas",
		"disimuladas",
		"disipadas",
		"dislocadas",
		"disminuidas",
		"disociadas",
		"dispensadas",
		"dispersadas",
		"dispuestas",
		"disputadas",
		"distadas",
		"distanciadas",
		"distendidas",
		"distinguidas",
		"distorsionadas",
		"distraídas",
		"distribuidas",
		"disuadidas",
		"disueltas",
		"divagadas",
		"diversificadas",
		"divertidas",
		"divididas",
		"divinizadas",
		"divisadas",
		"divorciadas",
		"divulgadas",
		"dobladas",
		"doblegadas",
		"doctoradas",
		"documentadas",
		"dogmatizadas",
		"dolidas",
		"domadas",
		"domesticadas",
		"dominadas",
		"donadas",
		"dopadas",
		"dormidas",
		"dosificadas",
		"dotadas",
		"dragadas",
		"dramatizadas",
		"drenadas",
		"drogadas",
		"duchadas",
		"dudadas",
		"dulcificadas",
		"duplicadas",
		"duradas",
		"echadas",
		"eclipsadas",
		"eclosionadas",
		"economizadas",
		"ecualizadas",
		"edificadas",
		"editadas",
		"educadas",
		"efectuadas",
		"ejecutadas",
		"ejemplificadas",
		"ejercidas",
		"ejercitadas",
		"elaboradas",
		"electrizadas",
		"electrocutadas",
		"elevadas",
		"elididas",
		"eliminadas",
		"elogiadas",
		"elucubradas",
		"eludidas",
		"emanadas",
		"emancipadas",
		"embadurnadas",
		"embaladas",
		"embalsamadas",
		"embanderadas",
		"embarcadas",
		"embargadas",
		"embarradas",
		"embarrancadas",
		"embaucadas",
		"embebidas",
		"embelesadas",
		"embellecidas",
		"embestidas",
		"emboladas",
		"embolsadas",
		"emborrachadas",
		"emborronadas",
		"emboscadas",
		"embotadas",
		"embriagadas",
		"embrolladas",
		"embrutecidas",
		"embuchadas",
		"emergidas",
		"emigradas",
		"emitidas",
		"emocionadas",
		"empacadas",
		"empachadas",
		"empadronadas",
		"empaladas",
		"empalmadas",
		"empanadas",
		"empañadas",
		"empantanadas",
		"empapeladas",
		"empaquetadas",
		"emparejadas",
		"empastadas",
		"empatadas",
		"empecinadas",
		"empeñadas",
		"empeoradas",
		"empequeñecidas",
		"emperradas",
		"empezadas",
		"empinadas",
		"emplazadas",
		"empleadas",
		"empobrecidas",
		"empoderadas",
		"empolladas",
		"empolvadas",
		"emponzoñadas",
		"emprendidas",
		"empujadas",
		"empuñadas",
		"emputadas",
		"emuladas",
		"emulsionadas",
		"enajenadas",
		"enaltecidas",
		"enamoradas",
		"enarboladas",
		"enardecidas",
		"encabezadas",
		"encabritadas",
		"encabronadas",
		"encadenadas",
		"encajadas",
		"encajonadas",
		"encalladas",
		"encamadas",
		"encaminadas",
		"encandiladas",
		"encanecidas",
		"encañonadas",
		"encantadas",
		"encaprichadas",
		"encapsuladas",
		"encaradas",
		"encaramadas",
		"encarecidas",
		"encargadas",
		"encariñadas",
		"encarnadas",
		"encarriladas",
		"encartadas",
		"encasilladas",
		"encasquetadas",
		"encasquilladas",
		"encastradas",
		"encausadas",
		"encauzadas",
		"enceguecidas",
		"encendidas",
		"enceradas",
		"encerradas",
		"encharcadas",
		"enchufadas",
		"encimadas",
		"encogidas",
		"encoladas",
		"encolerizadas",
		"encolumnadas",
		"encomendadas",
		"enconadas",
		"encontradas",
		"encordadas",
		"encrespadas",
		"encuadradas",
		"encubiertas",
		"encueradas",
		"encumbradas",
		"enderezadas",
		"endeudadas",
		"endilgadas",
		"endiosadas",
		"endosadas",
		"endulzadas",
		"endurecidas",
		"enemistadas",
		"energizadas",
		"enervadas",
		"enfadadas",
		"enfangadas",
		"enfatizadas",
		"enfermadas",
		"enfiestadas",
		"enfiladas",
		"enflaquecidas",
		"enfocadas",
		"enfrascadas",
		"enfrentadas",
		"enfriadas",
		"enfurecidas",
		"engalanadas",
		"engañadas",
		"enganchadas",
		"engarzadas",
		"engatusadas",
		"engendradas",
		"englobadas",
		"engolosinadas",
		"engordadas",
		"engranadas",
		"engrandecidas",
		"engrasadas",
		"engreídas",
		"engrosadas",
		"engullidas",
		"enharinadas",
		"enhebradas",
		"enjuagadas",
		"enjugadas",
		"enjuiciadas",
		"enlazadas",
		"enlistadas",
		"enlodadas",
		"enloquecidas",
		"enlozadas",
		"enlutadas",
		"enmarañadas",
		"enmascaradas",
		"enmendadas",
		"enmohecidas",
		"enmudecidas",
		"ennegrecidas",
		"ennoblecidas",
		"enorgullecidas",
		"enrarecidas",
		"enredadas",
		"enripiadas",
		"enriquecidas",
		"enrocadas",
		"enrojecidas",
		"enroladas",
		"enrolladas",
		"enroscadas",
		"enrumbadas",
		"ensalzadas",
		"ensambladas",
		"ensañadas",
		"ensanchadas",
		"ensartadas",
		"ensayadas",
		"ensebadas",
		"enseñadas",
		"enseñoreadas",
		"ensilladas",
		"ensoberbecidas",
		"ensogadas",
		"ensombrecidas",
		"ensoñadas",
		"ensordecidas",
		"ensuciadas",
		"entabladas",
		"entalladas",
		"entendidas",
		"enteradas",
		"enternecidas",
		"enterradas",
		"entibiadas",
		"entintadas",
		"entonadas",
		"entorpecidas",
		"entradas",
		"entrampadas",
		"entrañadas",
		"entreabiertas",
		"entrecomilladas",
		"entrecruzadas",
		"entregadas",
		"entrelazadas",
		"entremetidas",
		"entremezcladas",
		"entrenadas",
		"entresacadas",
		"entretejidas",
		"entretenidas",
		"entreveradas",
		"entrevistadas",
		"entristecidas",
		"entrometidas",
		"entronadas",
		"entroncadas",
		"entronizadas",
		"entumecidas",
		"enturbiadas",
		"entusiasmadas",
		"enumeradas",
		"enunciadas",
		"envainadas",
		"envalentonadas",
		"envanecidas",
		"envasadas",
		"envejecidas",
		"envenenadas",
		"envestidas",
		"enviadas",
		"enviciadas",
		"envidiadas",
		"envilecidas",
		"enviudadas",
		"envueltas",
		"enzarzadas",
		"equilibradas",
		"equiparadas",
		"equivocadas",
		"erigidas",
		"erizadas",
		"erogadas",
		"erosionadas",
		"erotizadas",
		"erradicadas",
		"erradas",
		"esbozadas",
		"escabullidas",
		"escaladas",
		"escaldadas",
		"escalfadas",
		"escamadas",
		"escamoteadas",
		"escampadas",
		"escandalizadas",
		"escaneadas",
		"escapadas",
		"escaqueadas",
		"escarbadas",
		"escarchadas",
		"escarmentadas",
		"escarnecidas",
		"escaseadas",
		"escatimadas",
		"escenificadas",
		"escindidas",
		"esclarecidas",
		"esclavizadas",
		"escocidas",
		"escogidas",
		"escolarizadas",
		"escoltadas",
		"escondidas",
		"escoradas",
		"escrachadas",
		"escritas",
		"escrutadas",
		"escuchadas",
		"escudadas",
		"escudriñadas",
		"esculpidas",
		"escupidas",
		"escurridas",
		"esforzadas",
		"esfumadas",
		"esgrimidas",
		"esmeradas",
		"esmeriladas",
		"espabiladas",
		"espaciadas",
		"españolizadas",
		"espantadas",
		"esparcidas",
		"especificadas",
		"especuladas",
		"esperadas",
		"espesadas",
		"espetadas",
		"espiadas",
		"espigadas",
		"espinadas",
		"espiradas",
		"espiritualizadas",
		"espoleadas",
		"espolvoreadas",
		"esponjadas",
		"esponsorizadas",
		"esposadas",
		"esquematizadas",
		"esquiadas",
		"esquiladas",
		"esquilmadas",
		"esquivadas",
		"estabilizadas",
		"establecidas",
		"estacionadas",
		"estafadas",
		"estalladas",
		"estampadas",
		"estancadas",
		"estaqueadas",
		"estatizadas",
		"estatuidas",
		"esterificadas",
		"esterilizadas",
		"estigmatizadas",
		"estilizadas",
		"estimadas",
		"estimuladas",
		"estipuladas",
		"estiradas",
		"estorbadas",
		"estornudadas",
		"estragadas",
		"estranguladas",
		"estrechadas",
		"estrelladas",
		"estremecidas",
		"estrenadas",
		"estresadas",
		"estriadas",
		"estropeadas",
		"estructuradas",
		"estrujadas",
		"estudiadas",
		"eternizadas",
		"etiquetadas",
		"evacuadas",
		"evadidas",
		"evaluadas",
		"evangelizadas",
		"evaporadas",
		"evidenciadas",
		"evisceradas",
		"evitadas",
		"evocadas",
		"evolucionadas",
		"exacerbadas",
		"exageradas",
		"exaltadas",
		"examinadas",
		"exasperadas",
		"excarceladas",
		"excavadas",
		"excedidas",
		"exceptuadas",
		"excitadas",
		"exclamadas",
		"excluidas",
		"excretadas",
		"exculpadas",
		"excusadas",
		"execradas",
		"exhaladas",
		"exhibidas",
		"exhortadas",
		"exhumadas",
		"exigidas",
		"exiladas",
		"eximidas",
		"existidas",
		"exoneradas",
		"exorcizadas",
		"expandidas",
		"expedidas",
		"expedientadas",
		"expelidas",
		"expendidas",
		"experimentadas",
		"expiadas",
		"expiradas",
		"explayadas",
		"explicadas",
		"explicitadas",
		"exploradas",
		"explosionadas",
		"explotadas",
		"expoliadas",
		"exportadas",
		"expresadas",
		"exprimidas",
		"expropiadas",
		"expuestas",
		"expulsadas",
		"expurgadas",
		"extendidas",
		"exteriorizadas",
		"exterminadas",
		"externadas",
		"externalizadas",
		"extinguidas",
		"extirpadas",
		"extorsionadas",
		"extractadas",
		"extraditadas",
		"extraídas",
		"extralimitadas",
		"extrañadas",
		"extrapoladas",
		"extraviadas",
		"extremadas",
		"extruidas",
		"exudadas",
		"eyaculadas",
		"eyectadas",
		"fabricadas",
		"fabuladas",
		"facilitadas",
		"facturadas",
		"facultadas",
		"fagocitadas",
		"fajadas",
		"falladas",
		"fallecidas",
		"falsadas",
		"falseadas",
		"falsificadas",
		"familiarizadas",
		"fantaseadas",
		"fascinadas",
		"fastidiadas",
		"fatigadas",
		"favorecidas",
		"fecundadas",
		"felicitadas",
		"feminizadas",
		"fenecidas",
		"fermentadas",
		"fertilizadas",
		"festejadas",
		"fiadas",
		"fichadas",
		"fidelizadas",
		"figuradas",
		"fijadas",
		"filmadas",
		"filosofadas",
		"filtradas",
		"finalizadas",
		"financiadas",
		"fincadas",
		"fingidas",
		"finiquitadas",
		"firmadas",
		"fiscalizadas",
		"fisuradas",
		"flageladas",
		"flameadas",
		"flanqueadas",
		"flaqueadas",
		"fletadas",
		"flexibilizadas",
		"flexionadas",
		"flipadas",
		"floreadas",
		"florecidas",
		"flotadas",
		"fluctuadas",
		"focalizadas",
		"fogueadas",
		"foliadas",
		"folladas",
		"fomentadas",
		"fondeadas",
		"forcejeadas",
		"forestadas",
		"forjadas",
		"formadas",
		"formalizadas",
		"formateadas",
		"formuladas",
		"fornicadas",
		"forradas",
		"fortalecidas",
		"forzadas",
		"fotocopiadas",
		"fotografiadas",
		"fracasadas",
		"fraccionadas",
		"fracturadas",
		"fragmentadas",
		"fraguadas",
		"franqueadas",
		"frecuentadas",
		"fregadas",
		"frenadas",
		"fresadas",
		"friccionadas",
		"frotadas",
		"fructificadas",
		"fruncidas",
		"fugadas",
		"fulminadas",
		"fumadas",
		"fumigadas",
		"funcionadas",
		"fundadas",
		"fundamentadas",
		"fundidas",
		"fungidas",
		"fusiladas",
		"fusionadas",
		"fustigadas",
		"gafadas",
		"ganadas",
		"gangrenadas",
		"garabateadas",
		"garantidas",
		"garantizadas",
		"garridas",
		"gaseadas",
		"gastadas",
		"gemidas",
		"generadas",
		"generalizadas",
		"gerenciadas",
		"germinadas",
		"gestadas",
		"gestionadas",
		"giradas",
		"glorificadas",
		"glosadas",
		"gobernadas",
		"goleadas",
		"golpeadas",
		"gozadas",
		"grabadas",
		"graduadas",
		"graficadas",
		"granjeadas",
		"grapadas",
		"gratificadas",
		"gravadas",
		"gravitadas",
		"gritadas",
		"gruñidas",
		"guardadas",
		"guarecidas",
		"guarnecidas",
		"guerreadas",
		"guiadas",
		"guillotinadas",
		"guiñadas",
		"guindadas",
		"guisadas",
		"gustadas",
		"habilitadas",
		"habitadas",
		"habituadas",
		"habladas",
		"haladas",
		"halagadas",
		"halladas",
		"hartadas",
		"hechizadas",
		"hechas",
		"helenizadas",
		"henchidas",
		"hendidas",
		"heredadas",
		"heridas",
		"hermanadas",
		"herradas",
		"hervidas",
		"hibernadas",
		"hibridadas",
		"hidratadas",
		"higienizadas",
		"hiladas",
		"hilvanadas",
		"hincadas",
		"hinchadas",
		"hipnotizadas",
		"hipotecadas",
		"historiadas",
		"hojeadas",
		"holgadas",
		"holladas",
		"homenajeadas",
		"homogeneizadas",
		"homologadas",
		"honradas",
		"horadadas",
		"horneadas",
		"horrorizadas",
		"hospedadas",
		"hostigadas",
		"hostilizadas",
		"huidas",
		"humanadas",
		"humanizadas",
		"humectadas",
		"humedecidas",
		"humilladas",
		"hundidas",
		"hurgadas",
		"hurtadas",
		"ideadas",
		"idealizadas",
		"identificadas",
		"ideologizadas",
		"idiotizadas",
		"idolatradas",
		"ignoradas",
		"igualadas",
		"ilegalizadas",
		"iluminadas",
		"ilusionadas",
		"ilustradas",
		"imaginadas",
		"imbricadas",
		"imitadas",
		"impactadas",
		"impartidas",
		"impedidas",
		"impelidas",
		"imperadas",
		"impermeabilizadas",
		"implantadas",
		"implementadas",
		"implicadas",
		"imploradas",
		"importadas",
		"importunadas",
		"imposibilitadas",
		"impresionadas",
		"improvisadas",
		"impuestas",
		"impugnadas",
		"impulsadas",
		"imputadas",
		"inauguradas",
		"incautadas",
		"incendiadas",
		"incentivadas",
		"incineradas",
		"incitadas",
		"inclinadas",
		"incluidas",
		"incoadas",
		"incomodadas",
		"incorporadas",
		"incrementadas",
		"increpadas",
		"incriminadas",
		"incubadas",
		"inculcadas",
		"inculpadas",
		"incumplidas",
		"incurridas",
		"incursionadas",
		"indagadas",
		"indemnizadas",
		"independizadas",
		"indexadas",
		"indicadas",
		"indigestadas",
		"indignadas",
		"indispuestas",
		"individuadas",
		"inducidas",
		"indultadas",
		"inervadas",
		"infamadas",
		"infartadas",
		"infectadas",
		"inferidas",
		"inficionadas",
		"infiltradas",
		"infladas",
		"inflamadas",
		"infligidas",
		"influenciadas",
		"influidas",
		"informadas",
		"infravaloradas",
		"infringidas",
		"infundidas",
		"ingeniadas",
		"ingeridas",
		"ingresadas",
		"inhabilitadas",
		"inhaladas",
		"inhibidas",
		"inhumadas",
		"iniciadas",
		"inicializadas",
		"injertadas",
		"injuriadas",
		"inmigradas",
		"inmiscuidas",
		"inmoladas",
		"inmortalizadas",
		"inmovilizadas",
		"inmunizadas",
		"innovadas",
		"inoculadas",
		"inquietadas",
		"inquiridas",
		"insensibilizadas",
		"insertadas",
		"insinuadas",
		"insistidas",
		"inspeccionadas",
		"inspiradas",
		"instadas",
		"instaladas",
		"instauradas",
		"instigadas",
		"instituidas",
		"instruidas",
		"instrumentadas",
		"instrumentalizadas",
		"insufladas",
		"insultadas",
		"insumidas",
		"integradas",
		"intelectualizadas",
		"intensificadas",
		"intentadas",
		"interactuadas",
		"intercaladas",
		"intercambiadas",
		"intercedidas",
		"interceptadas",
		"interesadas",
		"interferidas",
		"interiorizadas",
		"intermediadas",
		"internacionalizadas",
		"internalizadas",
		"interpeladas",
		"interpoladas",
		"interpretadas",
		"interpuestas",
		"interrogadas",
		"interrumpidas",
		"intervenidas",
		"intimadas",
		"intimidadas",
		"intituladas",
		"intoxicadas",
		"intrigadas",
		"introducidas",
		"intuidas",
		"inundadas",
		"inutilizadas",
		"invadidas",
		"invalidadas",
		"inventadas",
		"inventariadas",
		"invertidas",
		"investidas",
		"investigadas",
		"invitadas",
		"invocadas",
		"involucionadas",
		"inyectadas",
		"ionizadas",
		"ironizadas",
		"irradiadas",
		"irrespetadas",
		"irrigadas",
		"irritadas",
		"irrogadas",
		"irrumpidas",
		"jactadas",
		"jaladas",
		"jaleadas",
		"jalonadas",
		"jaqueadas",
		"jerarquizadas",
		"jodidas",
		"jorobadas",
		"jubiladas",
		"jugadas",
		"juntadas",
		"juradas",
		"juramentadas",
		"justificadas",
		"juzgadas",
		"laboradas",
		"labradas",
		"laburadas",
		"lacadas",
		"laceradas",
		"lactadas",
		"ladeadas",
		"ladradas",
		"lamentadas",
		"lamidas",
		"laminadas",
		"languidecidas",
		"lanzadas",
		"lapidadas",
		"laqueadas",
		"largadas",
		"lastimadas",
		"lastradas",
		"latidas",
		"laudadas",
		"lavadas",
		"legalizadas",
		"legisladas",
		"legitimadas",
		"leídas",
		"lesionadas",
		"leudadas",
		"levantadas",
		"liadas",
		"liberadas",
		"liberalizadas",
		"libertadas",
		"libradas",
		"licitadas",
		"licuadas",
		"liderizadas",
		"lidiadas",
		"ligadas",
		"lijadas",
		"limadas",
		"limitadas",
		"limpiadas",
		"linchadas",
		"liquidadas",
		"litigadas",
		"llagadas",
		"llamadas",
		"llegadas",
		"llenadas",
		"llevadas",
		"lloradas",
		"localizadas",
		"logradas",
		"lubricadas",
		"luchadas",
		"lucidas",
		"lucradas",
		"lustradas",
		"maceradas",
		"machacadas",
		"macheteadas",
		"machucadas",
		"madreadas",
		"madrugadas",
		"maduradas",
		"magnetizadas",
		"magnificadas",
		"malacostumbradas",
		"malbaratadas",
		"malcriadas",
		"maleadas",
		"malentendidas",
		"malgastadas",
		"malinterpretadas",
		"malogradas",
		"maltratadas",
		"malversadas",
		"mamadas",
		"manchadas",
		"mancilladas",
		"mandadas",
		"manejadas",
		"mangadas",
		"mangoneadas",
		"manifestadas",
		"maniobradas",
		"manipuladas",
		"manoseadas",
		"manteadas",
		"mantenidas",
		"manufacturadas",
		"maquilladas",
		"maquinadas",
		"maravilladas",
		"marcadas",
		"marchitadas",
		"mareadas",
		"marginadas",
		"maridadas",
		"martilladas",
		"martirizadas",
		"masacradas",
		"masajeadas",
		"mascadas",
		"masificadas",
		"masticadas",
		"masturbadas",
		"matadas",
		"materializadas",
		"matizadas",
		"matriculadas",
		"maximizadas",
		"meadas",
		"mecanografiadas",
		"mechadas",
		"mecidas",
		"mediadas",
		"mediatizadas",
		"medicadas",
		"medidas",
		"meditadas",
		"medradas",
		"mejoradas",
		"melladas",
		"memorizadas",
		"mencionadas",
		"meneadas",
		"menguadas",
		"menoscabadas",
		"menospreciadas",
		"menstruadas",
		"mensualizadas",
		"mensuradas",
		"mentadas",
		"mentalizadas",
		"mentidas",
		"mercadeadas",
		"mercantilizadas",
		"merecidas",
		"merendadas",
		"mermadas",
		"merodeadas",
		"mesuradas",
		"metamorfoseadas",
		"metidas",
		"mezcladas",
		"migradas",
		"militadas",
		"militarizadas",
		"mimadas",
		"mimetizadas",
		"minadas",
		"minimizadas",
		"ministradas",
		"minusvaloradas",
		"miradas",
		"mistificadas",
		"mitificadas",
		"mitigadas",
		"modeladas",
		"modernizadas",
		"modificadas",
		"moduladas",
		"mofadas",
		"mojadas",
		"moldeadas",
		"molestadas",
		"molidas",
		"monetizadas",
		"monitorizadas",
		"monopolizadas",
		"montadas",
		"moradas",
		"moralizadas",
		"mordidas",
		"mordisqueadas",
		"mortificadas",
		"mosqueadas",
		"mostradas",
		"motejadas",
		"motivadas",
		"movidas",
		"movilizadas",
		"mudadas",
		"muestreadas",
		"multadas",
		"multiplicadas",
		"munidas",
		"murmuradas",
		"mutadas",
		"mutiladas",
		"nacionalizadas",
		"narcotizadas",
		"narradas",
		"naufragadas",
		"navegadas",
		"necesitadas",
		"negadas",
		"negociadas",
		"neutralizadas",
		"ninguneadas",
		"niveladas",
		"nombradas",
		"nominadas",
		"noqueadas",
		"normadas",
		"normalizadas",
		"notadas",
		"notificadas",
		"nutridas",
		"obcecadas",
		"obedecidas",
		"objetadas",
		"objetivadas",
		"obligadas",
		"obliteradas",
		"obnubiladas",
		"obradas",
		"obsequiadas",
		"observadas",
		"obsesionadas",
		"obstaculizadas",
		"obstruidas",
		"obtenidas",
		"obturadas",
		"obviadas",
		"ocasionadas",
		"ocluidas",
		"ocultadas",
		"ocupadas",
		"odiadas",
		"ofendidas",
		"ofertadas",
		"oficiadas",
		"oficializadas",
		"ofrecidas",
		"ofrendadas",
		"ofuscadas",
		"oídas",
		"ojeadas",
		"olfateadas",
		"olidas",
		"olvidadas",
		"omitidas",
		"ondeadas",
		"onduladas",
		"opacadas",
		"operadas",
		"opinadas",
		"oprimidas",
		"optadas",
		"optimizadas",
		"opuestas",
		"oradas",
		"orbitadas",
		"ordenadas",
		"ordeñadas",
		"organizadas",
		"orientadas",
		"originadas",
		"orilladas",
		"orinadas",
		"ornadas",
		"ornamentadas",
		"orquestadas",
		"osadas",
		"osciladas",
		"oscurecidas",
		"osificadas",
		"ostentadas",
		"otorgadas",
		"ovacionadas",
		"ovuladas",
		"oxidadas",
		"oxigenadas",
		"pacificadas",
		"pactadas",
		"padecidas",
		"paganizadas",
		"paginadas",
		"paladeadas",
		"paliadas",
		"palpadas",
		"paradas",
		"parafraseadas",
		"paralizadas",
		"parapetadas",
		"parasitadas",
		"parceladas",
		"parchadas",
		"parcheadas",
		"pareadas",
		"paridas",
		"parodiadas",
		"parqueadas",
		"participadas",
		"particularizadas",
		"partidas",
		"pasadas",
		"paseadas",
		"pastoreadas",
		"pataleadas",
		"pateadas",
		"patentadas",
		"patentizadas",
		"patinadas",
		"patrulladas",
		"pecadas",
		"pedaleadas",
		"pedidas",
		"pegadas",
		"peinadas",
		"pellizcadas",
		"penalizadas",
		"penetradas",
		"pensadas",
		"percatadas",
		"percibidas",
		"percutidas",
		"perdidas",
		"perdonadas",
		"perduradas",
		"perecidas",
		"peregrinadas",
		"perfeccionadas",
		"perfiladas",
		"perforadas",
		"perfumadas",
		"pergeñadas",
		"peritadas",
		"perjudicadas",
		"perjuradas",
		"permeadas",
		"permitidas",
		"permutadas",
		"pernoctadas",
		"perpetradas",
		"perpetuadas",
		"perseguidas",
		"perseveradas",
		"persistidas",
		"personadas",
		"personalizadas",
		"personificadas",
		"persuadidas",
		"pertenecidas",
		"pertrechadas",
		"perturbadas",
		"pervertidas",
		"pervividas",
		"pescadas",
		"petadas",
		"peticionadas",
		"picadas",
		"picaneadas",
		"picoteadas",
		"pifiadas",
		"pignoradas",
		"pilladas",
		"pilotadas",
		"piloteadas",
		"pinceladas",
		"pinchadas",
		"pintadas",
		"pintarrajeadas",
		"pinzadas",
		"piradas",
		"pirateadas",
		"pisadas",
		"pisoteadas",
		"pitadas",
		"placidas",
		"plagiadas",
		"planchadas",
		"planeadas",
		"plantadas",
		"planteadas",
		"plasmadas",
		"platicadas",
		"plegadas",
		"pluralizadas",
		"podadas",
		"poetizadas",
		"polemizadas",
		"politizadas",
		"pololeadas",
		"ponderadas",
		"pontificadas",
		"popularizadas",
		"porfiadas",
		"portadas",
		"porteadas",
		"posadas",
		"posesionadas",
		"posibilitadas",
		"posicionadas",
		"pospuestas",
		"posteadas",
		"postergadas",
		"postradas",
		"postuladas",
		"potenciadas",
		"practicadas",
		"precarizadas",
		"precedidas",
		"preceptuadas",
		"precintadas",
		"precipitadas",
		"precisadas",
		"preconizadas",
		"predicadas",
		"predichas",
		"predispuestas",
		"predominadas",
		"preferidas",
		"prefiguradas",
		"pregonadas",
		"preguntadas",
		"prejuzgadas",
		"premiadas",
		"prendadas",
		"prendidas",
		"preocupadas",
		"preparadas",
		"presagiadas",
		"prescindidas",
		"presenciadas",
		"presentadas",
		"presentidas",
		"preservadas",
		"presididas",
		"presionadas",
		"prestadas",
		"prestigiadas",
		"presumidas",
		"presurizadas",
		"pretendidas",
		"preteridas",
		"prevalecidas",
		"prevalidas",
		"prevaricadas",
		"prevenidas",
		"previstas",
		"primadas",
		"principiadas",
		"pringadas",
		"priorizadas",
		"privatizadas",
		"probadas",
		"problematizadas",
		"procedidas",
		"procesadas",
		"proclamadas",
		"procreadas",
		"procuradas",
		"prodigadas",
		"producidas",
		"profanadas",
		"proferidas",
		"profesadas",
		"profesionalizadas",
		"profetizadas",
		"profundizadas",
		"programadas",
		"progresadas",
		"prohibidas",
		"prohijadas",
		"proletarizadas",
		"proliferadas",
		"prologadas",
		"prolongadas",
		"promediadas",
		"prometidas",
		"promocionadas",
		"promovidas",
		"promulgadas",
		"pronosticadas",
		"pronunciadas",
		"propagadas",
		"propaladas",
		"propendidas",
		"propiciadas",
		"propinadas",
		"proporcionadas",
		"propuestas",
		"propugnadas",
		"propulsadas",
		"prorrateadas",
		"prorrogadas",
		"proseguidas",
		"prosperadas",
		"prostituidas",
		"protegidas",
		"protestadas",
		"protocolizadas",
		"provenidas",
		"provocadas",
		"proyectadas",
		"psicoanalizadas",
		"publicadas",
		"publicitadas",
		"puestas",
		"pugnadas",
		"pujadas",
		"pulidas",
		"pulsadas",
		"pululadas",
		"pulverizadas",
		"punadas",
		"punteadas",
		"puntuadas",
		"puntualizadas",
		"punzadas",
		"purgadas",
		"purificadas",
		"puteadas",
		"quebradas",
		"quebrantadas",
		"quejadas",
		"quemadas",
		"querelladas",
		"queridas",
		"quintuplicadas",
		"quitadas",
		"racionadas",
		"racionalizadas",
		"radiadas",
		"radicadas",
		"radicalizadas",
		"raídas",
		"rajadas",
		"ralentizadas",
		"rapadas",
		"rapeadas",
		"raptadas",
		"rascadas",
		"rasgadas",
		"rasguñadas",
		"raspadas",
		"rastreadas",
		"rasuradas",
		"ratificadas",
		"rayadas",
		"razonadas",
		"reabiertas",
		"reabsorbidas",
		"reaccionadas",
		"reactivadas",
		"readaptadas",
		"readmitidas",
		"reafirmadas",
		"reagrupadas",
		"reajustadas",
		"realimentadas",
		"realizadas",
		"realzadas",
		"reanimadas",
		"reanudadas",
		"reaparecidas",
		"rearmadas",
		"reasumidas",
		"reavivadas",
		"rebajadas",
		"rebalsadas",
		"rebanadas",
		"rebasadas",
		"rebatidas",
		"rebautizadas",
		"rebeladas",
		"reblandecidas",
		"rebobinadas",
		"rebosadas",
		"rebotadas",
		"rebozadas",
		"rebuscadas",
		"recabadas",
		"recaídas",
		"recaladas",
		"recalcadas",
		"recalentadas",
		"recalificadas",
		"recapacitadas",
		"recapituladas",
		"recargadas",
		"recatadas",
		"recaudadas",
		"receptadas",
		"recetadas",
		"rechazadas",
		"recibidas",
		"recicladas",
		"recitadas",
		"reclamadas",
		"reclinadas",
		"reclutadas",
		"recobradas",
		"recocidas",
		"recogidas",
		"recolectadas",
		"recomendadas",
		"recomenzadas",
		"recompensadas",
		"recompuestas",
		"reconcentradas",
		"reconciliadas",
		"reconducidas",
		"reconfortadas",
		"reconocidas",
		"reconquistadas",
		"reconsideradas",
		"reconstituidas",
		"reconstruidas",
		"reconvenidas",
		"reconvertidas",
		"recopiladas",
		"recordadas",
		"recorridas",
		"recortadas",
		"recreadas",
		"recriminadas",
		"recrudecidas",
		"rectificadas",
		"recubiertas",
		"reculadas",
		"recuperadas",
		"recurridas",
		"recusadas",
		"redactadas",
		"redefinidas",
		"redescubiertas",
		"redimensionadas",
		"redimidas",
		"rediseñadas",
		"redistribuidas",
		"redituadas",
		"redobladas",
		"redondeadas",
		"reducidas",
		"redundadas",
		"reedificadas",
		"reeditadas",
		"reeducadas",
		"reelaboradas",
		"reembolsadas",
		"reemplazadas",
		"reencarnadas",
		"reencauchadas",
		"reencontradas",
		"reenganchadas",
		"reenviadas",
		"reescritas",
		"reestructuradas",
		"reexaminadas",
		"refaccionadas",
		"referidas",
		"refinadas",
		"refinanciadas",
		"reflejadas",
		"reflexionadas",
		"reflotadas",
		"reforestadas",
		"reformadas",
		"reforzadas",
		"refractadas",
		"refrenadas",
		"refrendadas",
		"refrescadas",
		"refrigeradas",
		"refundidas",
		"refutadas",
		"regadas",
		"regaladas",
		"regañadas",
		"regateadas",
		"regeneradas",
		"regentadas",
		"regenteadas",
		"regidas",
		"regionalizadas",
		"registradas",
		"regladas",
		"reglamentadas",
		"regocijadas",
		"regodeadas",
		"regresadas",
		"reguladas",
		"regularizadas",
		"regurgitadas",
		"rehabilitadas",
		"rehechas",
		"rehogadas",
		"rehuidas",
		"rehusadas",
		"reídas",
		"reinadas",
		"reincididas",
		"reincorporadas",
		"reingresadas",
		"reiniciadas",
		"reinsertadas",
		"reinstaladas",
		"reinstauradas",
		"reintegradas",
		"reinventadas",
		"reinvertidas",
		"reiteradas",
		"reivindicadas",
		"rejuvenecidas",
		"relajadas",
		"relamidas",
		"relanzadas",
		"relatadas",
		"relativizadas",
		"relegadas",
		"releídas",
		"relevadas",
		"religadas",
		"rellenadas",
		"remachadas",
		"remadas",
		"remangadas",
		"remarcadas",
		"rematadas",
		"remecidas",
		"remediadas",
		"rememoradas",
		"remendadas",
		"remitidas",
		"remodeladas",
		"remojadas",
		"remolcadas",
		"remontadas",
		"removidas",
		"remplazadas",
		"renacidas",
		"rendidas",
		"renegadas",
		"renegociadas",
		"reñidas",
		"renombradas",
		"renovadas",
		"rentabilizadas",
		"rentadas",
		"renunciadas",
		"reordenadas",
		"reorganizadas",
		"reorientadas",
		"reparadas",
		"repartidas",
		"repasadas",
		"repatriadas",
		"repelidas",
		"repensadas",
		"repercutidas",
		"repescadas",
		"repetidas",
		"repicadas",
		"repintadas",
		"replanteadas",
		"replegadas",
		"replicadas",
		"repobladas",
		"reportadas",
		"reporteadas",
		"reposadas",
		"repreguntadas",
		"reprendidas",
		"represadas",
		"representadas",
		"reprimidas",
		"reprobadas",
		"reprochadas",
		"reproducidas",
		"repudiadas",
		"repuestas",
		"repugnadas",
		"repuntadas",
		"reputadas",
		"requeridas",
		"requisadas",
		"resaltadas",
		"resarcidas",
		"resbaladas",
		"rescatadas",
		"rescindidas",
		"resecadas",
		"reseñadas",
		"reservadas",
		"reseteadas",
		"resguardadas",
		"resididas",
		"resignadas",
		"resistidas",
		"resonadas",
		"respaldadas",
		"respetadas",
		"respiradas",
		"resplandecidas",
		"respondidas",
		"responsabilizadas",
		"resquebrajadas",
		"restablecidas",
		"restadas",
		"restauradas",
		"restituidas",
		"restregadas",
		"resucitadas",
		"resueltas",
		"resumidas",
		"resurgidas",
		"retadas",
		"retardadas",
		"retenidas",
		"retiradas",
		"retocadas",
		"retomadas",
		"retorcidas",
		"retornadas",
		"retractadas",
		"retraídas",
		"retransmitidas",
		"retrasadas",
		"retratadas",
		"retribuidas",
		"retrotraídas",
		"retumbadas",
		"reunidas",
		"reunificadas",
		"reutilizadas",
		"revalidadas",
		"revalorizadas",
		"revaluadas",
		"reveladas",
		"revendidas",
		"reventadas",
		"reverdecidas",
		"reverenciadas",
		"revertidas",
		"revestidas",
		"reviradas",
		"revisadas",
		"revitalizadas",
		"revividas",
		"revocadas",
		"revolcadas",
		"revoloteadas",
		"revolucionadas",
		"revueltas",
		"ridiculizadas",
		"rifadas",
		"rimadas",
		"rivalizadas",
		"rizadas",
		"robadas",
		"robustecidas",
		"rociadas",
		"rodadas",
		"rodeadas",
		"rogadas",
		"roídas",
		"rondadas",
		"rotadas",
		"rotas",
		"rotuladas",
		"roturadas",
		"rozadas",
		"ruborizadas",
		"rubricadas",
		"rugidas",
		"rumiadas",
		"rumoradas",
		"sabidas",
		"saboreadas",
		"saboteadas",
		"sacadas",
		"saciadas",
		"sacralizadas",
		"sacrificadas",
		"sacudidas",
		"saldadas",
		"salpimentadas",
		"salpullidas",
		"saltadas",
		"salteadas",
		"saludadas",
		"salvadas",
		"salvaguardadas",
		"sanadas",
		"saneadas",
		"sangradas",
		"santificadas",
		"saqueadas",
		"satanizadas",
		"satirizadas",
		"satisfechas",
		"sazonadas",
		"secadas",
		"seccionadas",
		"secretadas",
		"secuenciadas",
		"secuestradas",
		"secundadas",
		"sedimentadas",
		"seducidas",
		"segadas",
		"segmentadas",
		"segregadas",
		"seguidas",
		"seleccionadas",
		"sembradas",
		"señaladas",
		"sensibilizadas",
		"sentadas",
		"sentenciadas",
		"sentidas",
		"separadas",
		"serenadas",
		"serradas",
		"servidas",
		"significadas",
		"silenciadas",
		"simbolizadas",
		"simpatizadas",
		"simplificadas",
		"simuladas",
		"sinceradas",
		"sincronizadas",
		"sindicadas",
		"sindicalizadas",
		"singularizadas",
		"sintetizadas",
		"sintonizadas",
		"sistematizadas",
		"situadas",
		"sobadas",
		"sobornadas",
		"sobradas",
		"sobrecargadas",
		"sobrecogidas",
		"sobreentendidas",
		"sobreestimadas",
		"sobrellevadas",
		"sobrentendidas",
		"sobrepasadas",
		"sobrepuestas",
		"sobresalidas",
		"sobresaltadas",
		"sobrestimadas",
		"sobrevenidas",
		"sobrevividas",
		"sobrevoladas",
		"socavadas",
		"socializadas",
		"socorridas",
		"sodomizadas",
		"sofocadas",
		"sojuzgadas",
		"solapadas",
		"solicitadas",
		"solidarizadas",
		"solidificadas",
		"soliviantadas",
		"soltadas",
		"solucionadas",
		"solventadas",
		"sombreadas",
		"sometidas",
		"sonadas",
		"soñadas",
		"sondeadas",
		"sonreídas",
		"sonrojadas",
		"sopesadas",
		"sopladas",
		"soportadas",
		"sorbidas",
		"sorprendidas",
		"sorteadas",
		"sosegadas",
		"soslayadas",
		"sospechadas",
		"sostenidas",
		"suavizadas",
		"subastadas",
		"subcontratadas",
		"subdivididas",
		"subestimadas",
		"subidas",
		"sublevadas",
		"sublimadas",
		"subrayadas",
		"subrogadas",
		"subsanadas",
		"subsidiadas",
		"subsistidas",
		"substraídas",
		"subsumidas",
		"subvertidas",
		"subyugadas",
		"succionadas",
		"sucedidas",
		"sucumbidas",
		"sudadas",
		"sufragadas",
		"sufridas",
		"sugeridas",
		"sugestionadas",
		"suicidadas",
		"sujetadas",
		"sumadas",
		"sumergidas",
		"suministradas",
		"supeditadas",
		"superadas",
		"superpuestas",
		"supervisadas",
		"suplantadas",
		"suplicadas",
		"suplidas",
		"suprimidas",
		"supuestas",
		"surcadas",
		"surtidas",
		"suscitadas",
		"suspendidas",
		"suspiradas",
		"sustanciadas",
		"sustantivadas",
		"sustentadas",
		"sustituidas",
		"sustraídas",
		"susurradas",
		"suturadas",
		"tabuladas",
		"tachadas",
		"taladas",
		"taladradas",
		"talladas",
		"tambaleadas",
		"tamizadas",
		"tañidas",
		"tanteadas",
		"tapadas",
		"tapizadas",
		"taponadas",
		"tarareadas",
		"tardadas",
		"tasadas",
		"tatuadas",
		"tecleadas",
		"tejidas",
		"telefoneadas",
		"televisadas",
		"temidas",
		"templadas",
		"tendidas",
		"tenidas",
		"tensadas",
		"tentadas",
		"teorizadas",
		"terciadas",
		"tergiversadas",
		"terminadas",
		"territorializadas",
		"testadas",
		"testeadas",
		"testificadas",
		"testimoniadas",
		"tildadas",
		"timadas",
		"timbradas",
		"tinturadas",
		"tipeadas",
		"tipificadas",
		"tiradas",
		"tiranizadas",
		"tironeadas",
		"tiroteadas",
		"titubeadas",
		"tiznadas",
		"tocadas",
		"toleradas",
		"tomadas",
		"tonificadas",
		"topadas",
		"toqueteadas",
		"torcidas",
		"toreadas",
		"tornadas",
		"tornasoladas",
		"torneadas",
		"torpedeadas",
		"torturadas",
		"tosidas",
		"tostadas",
		"totalizadas",
		"trabadas",
		"trabajadas",
		"traducidas",
		"traficadas",
		"tragadas",
		"traicionadas",
		"traídas",
		"trajinadas",
		"tramadas",
		"tramitadas",
		"trancadas",
		"tranquilizadas",
		"transcendidas",
		"transcurridas",
		"transferidas",
		"transfiguradas",
		"transformadas",
		"transfundidas",
		"transgredidas",
		"transigidas",
		"transitadas",
		"transliteradas",
		"translucidas",
		"transmitidas",
		"transmutadas",
		"transparentadas",
		"transpiradas",
		"transportadas",
		"transpuestas",
		"trasegadas",
		"trasgredidas",
		"trasladadas",
		"traslapadas",
		"traslucidas",
		"trasnochadas",
		"traspapeladas",
		"traspasadas",
		"trasplantadas",
		"traspuestas",
		"trasquiladas",
		"trasteadas",
		"trastocadas",
		"trastornadas",
		"trasvasadas",
		"tratadas",
		"trazadas",
		"trenzadas",
		"trepadas",
		"tributadas",
		"trincadas",
		"triplicadas",
		"trituradas",
		"triunfadas",
		"trivializadas",
		"trocadas",
		"troceadas",
		"tronadas",
		"tronchadas",
		"truncadas",
		"tumbadas",
		"tuneadas",
		"turbadas",
		"turnadas",
		"tuteladas",
		"ufanadas",
		"ultimadas",
		"uncidas",
		"ungidas",
		"unidas",
		"universalizadas",
		"untadas",
		"urbanizadas",
		"urdidas",
		"usadas",
		"usufructuadas",
		"usurpadas",
		"utilizadas",
		"vacadas",
		"vaciadas",
		"vaciladas",
		"vacunadas",
		"vagadas",
		"validadas",
		"validas",
		"valoradas",
		"valorizadas",
		"valuadas",
		"vanagloriadas",
		"vandalizadas",
		"vaporizadas",
		"variadas",
		"vaticinadas",
		"vedadas",
		"vehiculadas",
		"vejadas",
		"veladas",
		"vencidas",
		"vendadas",
		"vendidas",
		"veneradas",
		"vengadas",
		"ventiladas",
		"veraneadas",
		"verbalizadas",
		"verificadas",
		"versadas",
		"versionadas",
		"vertebradas",
		"vertidas",
		"vestidas",
		"vetadas",
		"viabilizadas",
		"viajadas",
		"vibradas",
		"victimadas",
		"victimizadas",
		"vigiladas",
		"vigorizadas",
		"vilipendiadas",
		"vindicadas",
		"violadas",
		"violentadas",
		"viradas",
		"visadas",
		"visibilizadas",
		"visitadas",
		"vislumbradas",
		"vistas",
		"visualizadas",
		"vitoreadas",
		"vitrificadas",
		"vituperadas",
		"vividas",
		"vivificadas",
		"vocalizadas",
		"voceadas",
		"vociferadas",
		"voladas",
		"volatilizadas",
		"volcadas",
		"volteadas",
		"vomitadas",
		"votadas",
		"vueltas",
		"vulcanizadas",
		"vulgarizadas",
		"vulneradas",
		"yuxtapuestas",
		"zafadas",
		"zambullidas",
		"zampadas",
		"zanjadas",
		"zarandeadas",
		"zarpadas",
		"zozobradas",
		"zumbadas",
		"zurcidas",
		"zurradas",
	];
}
